// 인스타 주소형식: https://www.instagram.com/explore/tags/name/

const cafeInfo = [
  {
    area: "서울",
    gu_si: "강남구",
    dong: "청담",
    theme: "무채색",
    name: "더포트",
    address: "청담동 130-23",
    off: "x",
    parking: "o",
    link: "https://naver.me/xGO9sYKv",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMTA2MjFfMTQg%2FMDAxNjI0MjY1MjY4MTY0.FvgBr0XkhBHdO4ntcW9q58D339jIP2IwGgMcNalkVKYg.tcLvZF8kMwYzTDpbWJr-ItmW49JiYT9uvqTc5pW3RZcg.PNG.lauren_xx%2Fimage.png",
  },
  {
    area: "서울",
    gu_si: "강남구",
    dong: "신사",
    theme: "주택개조",
    name: "포스터리 베이커",
    address: "신사동 643-4",
    off: "x",
    parking: "x",
    link: "https://naver.me/F9VjLzV9",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjA2MTZfMTQ0%2FMDAxNjU1MzQxMTE2NjQ0.SrdQK_NCYBhqgTK10fi0VmCxSVK-H9Dxq1jjH9JKu_Ag.vQ7SMLBA3pbtjOidhmZ7FiH_cxe3BcpBEu9WCKxippog.JPEG.kcherry2277%2F%25C8%25AD%25B8%25E9_%25C4%25B8%25C3%25B3_2022-06-16_095807.jpg",
  },
  {
    area: "서울",
    gu_si: "송파구",
    dong: "송파",
    theme: "드로잉",
    name: "그림제작소",
    address: "송파동 58-18",
    off: "x",
    parking: "x",
    link: "https://naver.me/xKQWtcB8",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMDA1MTNfNDIg%2FMDAxNTg5MzgxMzgyODg3.ujdBdtSCxMPim_uZk9dAjeziKh4gFp9t7qYdn14z__Qg.UDpdQq1EdzW46qOGT7doinbaejUA0ouFtAEDOiZr-Gcg.JPEG.jasmin4047%2FIMG_2256.jpg",
  },
  {
    area: "서울",
    gu_si: "강남구",
    dong: "도곡",
    theme: "드로잉",
    name: "서울팔레트",
    address: "도곡동 955-12",
    off: "x",
    parking: "x",
    link: "https://naver.me/FKp36ouQ",
    image:
      "https://ldb-phinf.pstatic.net/20220706_79/1657101961336YVmDc_JPEG/B500FC6D-E3F6-418C-87F8-13F322E705C3.jpeg",
  },
  {
    area: "서울",
    gu_si: "성동구",
    dong: "성수",
    theme: "제주",
    name: "제주시성수동",
    address: "성수동2가 328-15",
    off: "x",
    parking: "o",
    link: "https://naver.me/xgaFhXgC",
    image:
      "https://ldb-phinf.pstatic.net/20221009_81/16652473827865r3zi_JPEG/1665247323704-9.jpg",
  },
  {
    area: "서울",
    gu_si: "성동구",
    dong: "성수",
    theme: "이색",
    name: "무브모브",
    address: "성수동2가 301-51",
    off: "x",
    parking: "x",
    link: "https://naver.me/5dxyxJ2r",
    image:
      "https://ldb-phinf.pstatic.net/20200912_227/1599895163545hejPP_JPEG/7_gE24DJtXYWBDJWI7GCFGh0.jpg",
  },
  {
    area: "서울",
    gu_si: "강남구",
    dong: "신사",
    theme: "디저트",
    name: "누데이크",
    address: "신사동 649-8",
    off: "x",
    parking: "o",
    link: "https://naver.me/Fn2inXJi",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjA2MTdfMjkz%2FMDAxNjU1NDUwMDk1ODMx.4xN1262ngD2St4-nZKODRP4vOLHIS-eg0zgM91jQFGYg.2XeMGt0rWxUkxEjX3hq-Rj29o790JIz8k8BMmHx2JKgg.JPEG.yonho1214%2FIMG_6387.jpg",
  },
  {
    area: "서울",
    gu_si: "강남구",
    dong: "신사",
    theme: "외국",
    name: "카페무니",
    address: "신사동 664-22",
    off: "x",
    parking: "x",
    link: "https://naver.me/GFnMTy4g",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjA3MDNfMjQ2%2FMDAxNjU2ODE4NzQ3NjQy.524THcPWOBTtpA6-I2j1UnaTddZSfYYovC8SxBJxe9Mg.Tck3w9G5eC8G35ydtzq3sX-qGr-HvJx-BoEbrbr4jbAg.JPEG.seulkk14%2Foutput_3791681493.jpg",
  },
  {
    area: "서울",
    gu_si: "성동구",
    dong: "성수",
    theme: "디저트",
    name: "서울앵무새",
    address: "성수동1가 685-213",
    off: "x",
    parking: "x",
    link: "https://naver.me/xPI8RzMh",
    image:
      "https://ldb-phinf.pstatic.net/20210406_199/1617678551577SJ7tT_JPEG/ikVKGhWZ6X3_u60YEP1nMpHY.jpg",
  },
  {
    area: "서울",
    gu_si: "성동구",
    dong: "성수",
    theme: "디저트",
    name: "텅 스페이스",
    address: "성수동2가 317-9",
    off: "x",
    parking: "x",
    link: "https://naver.me/GjRG3Sm5",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMTA3MTlfMjc0%2FMDAxNjI2NjkxMjAzMDQy.MySctQcMChkxAP1X8kYM9FRxr1gLhkTZyvKBGKSlGpwg.LUTpwRpFLCS2WZi9zRAr4SQXgYoGuX-9eow7FO7YsJYg.JPEG.psm956282%2F1626188395683-2.jpg",
  },
  {
    area: "서울",
    gu_si: "성동구",
    dong: "성수",
    theme: "이색",
    name: "리얼월드 성수",
    address: "성수동2가 271-5",
    off: "x",
    parking: "x",
    link: "https://naver.me/xgGVfbSk",
    image:
      "https://ldb-phinf.pstatic.net/20220816_117/1660640919821R8L1F_JPEG/%BC%F6%C1%A4%B5%CA_220811-0387.jpg",
  },
  {
    area: "서울",
    gu_si: "송파구",
    dong: "석촌",
    theme: "외국",
    name: "폼커피",
    address: "송파동 7-1",
    off: "x",
    parking: "x",
    link: "https://naver.me/FPeaZ7xo",
    image:
      "https://ldb-phinf.pstatic.net/20221029_178/16669912024514JKNn_JPEG/DACF9784-08BE-443E-B5AB-077C5DAC70A6.jpeg",
  },
  {
    area: "서울",
    gu_si: "송파구",
    dong: "삼전",
    theme: "대형",
    name: "버터베어베이커리",
    address: "삼전동 48-12",
    off: "x",
    parking: "o",
    link: "https://naver.me/5Cz0kpJY",
    image:
      "https://ldb-phinf.pstatic.net/20211017_279/16344237817419IzeL_JPEG/FJE9cStim-4BBiKcrpyLjPK0.jpg",
  },
  {
    area: "서울",
    gu_si: "성동구",
    dong: "뚝섬",
    theme: "대형",
    name: "폴인레미유",
    address: "성수동1가 656-1004",
    off: "신정",
    parking: "x",
    link: "https://naver.me/xJL2IwF0",
    image:
      "https://ldb-phinf.pstatic.net/20220420_257/1650429254409deiLv_JPEG/%C6%FA%C0%CE%B7%B9%B9%CC%C0%AF_%B7%E7%C7%C1%C5%BE4.jpg",
  },
  {
    area: "서울",
    gu_si: "성동구",
    dong: "성수",
    theme: "힙",
    name: "하이엔드라이",
    address: "성수동2가 281",
    off: "x",
    parking: "x",
    link: "https://naver.me/GDcO46vO",
    image:
      "https://ldb-phinf.pstatic.net/20210816_256/1629056695237h4suL_JPEG/aBJV0egaMUOnLXVnhyNx3vbC.jpeg.jpg",
  },
  {
    area: "서울",
    gu_si: "강남구",
    dong: "역삼",
    theme: "이색",
    name: "커피프릭스",
    address: "역삼동 671-13",
    off: "Mon",
    parking: "o",
    link: "https://naver.me/xQZY88uH",
    image:
      "https://ldb-phinf.pstatic.net/20211116_40/1637053245492wGNwu_PNG/A1432.png",
  },
  {
    area: "서울",
    gu_si: "성동구",
    dong: "성수",
    theme: "무채색",
    name: "러프러프",
    address: "성수동2가 271-24",
    off: "1st Mon",
    parking: "x",
    link: "https://naver.me/G9hukt0L",
    image:
      "https://ldb-phinf.pstatic.net/20211115_93/1636957816838znY2m_JPEG/KakaoTalk_20211115_151031492_05.jpg",
  },
  {
    area: "서울",
    gu_si: "광진구",
    dong: "화양",
    theme: "드로잉",
    name: "몽몽공장",
    address: "화양동 3-60",
    off: "Tue",
    parking: "x",
    link: "https://naver.me/Ft8oAGYz",
    image:
      "https://ldb-phinf.pstatic.net/20220103_69/1641211091797Fdmv8_PNG/Screenshot_2021-12-27_175412.png",
  },
  {
    area: "서울",
    gu_si: "성동구",
    dong: "성수",
    theme: "대형",
    name: "옹근달",
    address: "성수동2가 333-52",
    off: "x",
    parking: "x",
    link: "https://naver.me/GOuQCUaJ",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMTA3MjVfMTQ2%2FMDAxNjI3MTczOTc2MjY3.CX3wto4vt_NrJPzZWTpEsPaDz8ghQRojN0xRaCdmBPAg.EBw-P9Vd_vLzojv3NI-o0CRlOXXanmgRn9uFj15TLYog.JPEG.sbtown21%2FKakaoTalk_20210724_225944013_29.jpg",
  },
  {
    area: "경기도",
    gu_si: "성남",
    dong: "오야",
    theme: "한옥",
    name: "새소리물소리",
    address: "오야동 278",
    off: "x",
    parking: "o",
    link: "https://naver.me/5Tv3wAX7",
    image:
      "https://ldb-phinf.pstatic.net/20150815_192/1439613042475nRGYm_PNG/SUBMIT_1439612977448_11462618.png",
  },
  {
    area: "서울",
    gu_si: "송파구",
    dong: "송파",
    theme: "무채색",
    name: "디온웨이",
    address: "송파동 24-7",
    off: "Tue",
    parking: "o",
    link: "https://naver.me/xNdF3eEM",
    image:
      "https://ldb-phinf.pstatic.net/20211004_47/16333220327712mHW9_JPEG/4MpCjydthz2gEGbYjZSZBOcs.jpeg.jpg",
  },
  {
    area: "서울",
    gu_si: "광진구",
    dong: "화양",
    theme: "힙",
    name: "캐치볼클럽",
    address: "화양동 18-26",
    off: "x",
    parking: "x",
    link: "https://naver.me/FCboqfOa",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMTEyMThfMTIg%2FMDAxNjM5ODE0NDkwMzMx.K0csg_Mbonjk8NHX-ejkt6Jv2Rm76KnZa0WVk-Kh1fEg.7LX1uahkF-wWrC60M4AmkhL6WmwCEgLYD-XozatF0wMg.JPEG.leeann704%2FIMG_4407.jpg",
  },
  {
    area: "경기도",
    gu_si: "성남",
    dong: "고등",
    theme: "무채색",
    name: "벙크오프",
    address: "고등동 573-9",
    off: "Mon",
    parking: "o",
    link: "https://naver.me/5X9MxvJ8",
    image:
      "https://ldb-phinf.pstatic.net/20220312_67/1647041197560JpJsk_JPEG/E505FEBC-6816-4B27-9FB6-74EC09B9D64B.jpeg",
  },
  {
    area: "서울",
    gu_si: "송파구",
    dong: "송파",
    theme: "외국",
    name: "진저베어",
    address: "송파동 8-10",
    off: "x",
    parking: "x",
    link: "https://naver.me/xBpXYNtZ",
    image:
      "https://ldb-phinf.pstatic.net/20220225_114/1645782320941aHPWY_JPEG/KakaoTalk_20220223_143917379_02.jpg",
  },
  {
    area: "서울",
    gu_si: "강남구",
    dong: "신사",
    theme: "외국",
    name: "알에비뉴",
    address: "신사동 664-17",
    off: "x",
    parking: "o",
    link: "https://naver.me/5VeA30Oe",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMTA5MTBfNCAg%2FMDAxNjMxMjM5NzE3MDU4.Yee5Zal6g9XeheTois_V5tNf9tGhinsiga2j_2RUhXQg.Qvknrbq6nqmJQXMijzE7swBvXNuYj1S9FqhLAG64o7cg.JPEG.sgcholaw%2F%25B2%25D9%25B9%25CC%25B1%25E2IMG_0051.jpg",
  },
  {
    area: "서울",
    gu_si: "강남구",
    dong: "역삼",
    theme: "갤러리",
    name: "원아베뉴",
    address: "역삼동 649-4",
    off: "x",
    parking: "o",
    link: "https://naver.me/FIg7w1sk",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjEwMjRfMTE4%2FMDAxNjY2NjExMzAzOTc2.qt3SCdjKWL6sWzubXW47WJvpMdTSGSzcxCCbb__XQosg.iZFjGqaPRadho_Wy2nH6xbCXVXd3b4bBDn-GUpr5doEg.JPEG.umsun2004%2FIMG_1109.jpg",
  },
  {
    area: "서울",
    gu_si: "중구",
    dong: "명동",
    theme: "외국",
    name: "몰또",
    address: "명동1가 1-3",
    off: "Sun",
    parking: "x",
    link: "https://naver.me/FrKwy0Ca",
    image:
      "https://ldb-phinf.pstatic.net/20220902_259/1662093130212OMeiR_JPEG/DCC639BC-7B38-4A55-BBDD-8C600DCEE122.JPG",
  },
  {
    area: "서울",
    gu_si: "마포구",
    dong: "동교",
    theme: "포근함",
    name: "코코샌드",
    address: "동교동 148-7",
    off: "x",
    parking: "o",
    link: "https://naver.me/xevjUwS3",
    image:
      "https://ldb-phinf.pstatic.net/20191030_107/1572436784582v04cc_JPEG/YzGoJDNNo0Ra4_89rzoaA0Fu.jpg",
  },
  {
    area: "서울",
    gu_si: "마포구",
    dong: "서교",
    theme: "이색",
    name: "943 킹스크로스",
    address: "서교동 369-1",
    off: "x",
    parking: "x",
    link: "https://naver.me/5aVtIqGW",
    image:
      "https://ldb-phinf.pstatic.net/20200531_228/1590887810536REjfl_JPEG/s9dnHnh6zMqiGK7hn2y3Pref.jpg",
  },
  {
    area: "서울",
    gu_si: "금천구",
    dong: "가산",
    theme: "대형",
    name: "인크커피",
    address: "가산동 544-6",
    off: "x",
    parking: "x",
    link: "https://naver.me/5h32gCtd",
    image:
      "https://ldb-phinf.pstatic.net/20220503_74/1651541665010Nty4G_JPEG/278263225_1358172804607210_1751621262420110588_n.jpg",
  },
  {
    area: "서울",
    gu_si: "마포구",
    dong: "합정",
    theme: "힙",
    name: "버티컬커피",
    address: "서교동 347-24",
    off: "x",
    parking: "x",
    link: "https://naver.me/IGuhxLRt",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjA3MTRfMTE5%2FMDAxNjU3ODA5NTUzMDAz.2m3RUbbqIOylhGD4oFWs23vXICHKObAhWBh3eyymI1gg.SJXDFXssYclDIqG66Th60nRkLNVlRUkXzvNrdAc3aaAg.JPEG.jkj880308%2FIMG_4999.jpg",
  },
  {
    area: "서울",
    gu_si: "송파구",
    dong: "송파",
    theme: "포근함",
    name: "뷰클런즈",
    address: "송파동 45-18",
    off: "x",
    parking: "x",
    link: "https://naver.me/IMQp4gVu",
    image:
      "https://ldb-phinf.pstatic.net/20210214_74/1613232727977kKWeV_JPEG/s-ta49K-HVV_1EEYD3i4AAW-.jpg",
  },
  {
    area: "서울",
    gu_si: "용산구",
    dong: "한강",
    theme: "이색",
    name: "도토리",
    address: "한강로1가 227",
    off: "x",
    parking: "x",
    link: "https://naver.me/GyLKbBh0",
    image:
      "https://ldb-phinf.pstatic.net/20220823_82/1661216091862hpkMY_JPEG/Screenshot_20220822-205328_Instagram.jpg",
  },
  {
    area: "서울",
    gu_si: "용산구",
    dong: "한강",
    theme: "외국",
    name: "테디뵈르",
    address: "한강로2가 49-1",
    off: "x",
    parking: "x",
    link: "https://naver.me/5E3T148r",
    image:
      "https://ldb-phinf.pstatic.net/20221007_212/16651062257035UoTL_JPEG/IMG_9BD6130A35BF-1.jpeg",
  },
  {
    area: "서울",
    gu_si: "용산구",
    dong: "후암",
    theme: "뷰맛집",
    name: "더로열푸드",
    address: "후암동 406-58",
    off: "x",
    parking: "x",
    link: "https://naver.me/Gz515bTk",
    image:
      "https://ldb-phinf.pstatic.net/20200619_71/1592564386008IQdF9_JPEG/YPNXJN_u1EOzH9KPQv5gWjIP.jpeg.jpg",
  },
  {
    area: "서울",
    gu_si: "영등포구",
    dong: "당산",
    theme: "외국",
    name: "진심디자인",
    address: "당산동6가 328-4",
    off: "x",
    parking: "o",
    link: "https://naver.me/FQaIY2ND",
    image:
      "https://ldb-phinf.pstatic.net/20220828_234/1661646172442Vczd8_JPEG/Screenshot_20220827-211551_Samsung_Internet.jpg",
  },
  {
    area: "서울",
    gu_si: "강남구",
    dong: "신사",
    theme: "드로잉",
    name: "경성미술관",
    address: "신사동 544-16",
    off: "x",
    parking: "o",
    link: "https://naver.me/xIh2dwz4",
    image:
      "https://ldb-phinf.pstatic.net/20220817_216/1660693720699MJszO_JPEG/E1BDC4F7-D97A-4126-89E1-215613C63D77.jpeg",
  },
  {
    area: "서울",
    gu_si: "마포구",
    dong: "합정",
    theme: "무채색",
    name: "도식화",
    address: "서교동 409-19",
    off: "x",
    parking: "x",
    link: "https://naver.me/xqvRJSQb",
    image:
      "https://ldb-phinf.pstatic.net/20220704_12/1656920530136MpHi5_JPEG/KakaoTalk_20220704_081021936.jpg",
  },
  {
    area: "서울",
    gu_si: "마포구",
    dong: "동교",
    theme: "우드",
    name: "앤티크커피",
    address: "동교동 113-3",
    off: "x",
    parking: "x",
    link: "https://naver.me/GwDytKXn",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjA3MDRfMzIg%2FMDAxNjU2OTMxNzExMzE4.MSj6WYVpmYMFL2w7DI_cN4gCr8mNF4z2TbPXKexgdSUg.FOVaKgJ7066rZg3R3pyIXHaJlqQ0CS6QMJJVIQqp54gg.JPEG.jisoo831%2FIMG_2290.jpg",
  },
  {
    area: "서울",
    gu_si: "서대문구",
    dong: "연희",
    theme: "무채색",
    name: "시도 플레이스",
    address: "연희동 192-9",
    off: "Tue",
    parking: "x",
    link: "https://naver.me/xje3D5vB",
    image:
      "https://ldb-phinf.pstatic.net/20220426_162/1650938418873FoY5G_JPEG/IMG_6725.jpg",
  },
  {
    area: "서울",
    gu_si: "마포구",
    dong: "연남",
    theme: "힙",
    name: "프랭키클럽",
    address: "연남동 561-2",
    off: "Tue",
    parking: "x",
    link: "https://naver.me/xevRPGr8",
    image:
      "https://pup-review-phinf.pstatic.net/MjAyMjEwMjRfMTEw/MDAxNjY2NTM5MzE2Mzk4.5dcli3O9y_FkCvnjD-ALTYBT0L6bwjq8uBGZSpcS6skg.WeHWFOoKauolZqyLwTm7z-Cp7OWAzfqJC0dUcO5HChQg.JPEG/DSC09501.JPG",
  },
  {
    area: "서울",
    gu_si: "마포구",
    dong: "서교",
    theme: "한옥",
    name: "신이도가",
    address: "서교동 367-31",
    off: "x",
    parking: "x",
    link: "https://naver.me/xswcsHf4",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjEyMTRfMTM4%2FMDAxNjcwOTg3MTIxODkx.pdpjcaomwY7qebbtMccf5Vrs6IywlEPxfa0DukKX2X8g.BmxVh7a6JuBiVqC-r_N04tZiYqyVI4myWRz0iofuzIgg.JPEG.ukrich%2F2022%25A3%25AD12%25A3%25AD13%25A3%25AD10%25A3%25AD44%25A3%25AD12%25A3%25AD435.jpg",
  },
  {
    area: "서울",
    gu_si: "종로구",
    dong: "익선",
    theme: "한옥",
    name: "청수당",
    address: "익선동 144",
    off: "x",
    parking: "x",
    link: "https://naver.me/5DH3kkiW",
    image:
      "https://ldb-phinf.pstatic.net/20200908_107/15995407108786QDrv_JPEG/uVoKhFwiVC-j0fy1Wagk3ZXO.jpeg.jpg",
  },
  {
    area: "서울",
    gu_si: "마포구",
    dong: "연남",
    theme: "포근함",
    name: "어반비치",
    address: "연남동 258-10",
    off: "x",
    parking: "x",
    link: "https://naver.me/GAi3m5Ml",
    image:
      "https://ldb-phinf.pstatic.net/20220510_30/1652148310725t0aJt_JPEG/68462682-9C12-4B26-B8FB-261EDCE1A63C.jpeg",
  },
  {
    area: "서울",
    gu_si: "마포구",
    dong: "서교",
    theme: "제주",
    name: "삼다코지",
    address: "서교동 403-5",
    off: "x",
    parking: "x",
    link: "https://naver.me/xvLS8Kvc",
    image:
      "https://ldb-phinf.pstatic.net/20221027_232/16668587984082mPfv_PNG/%C0%CF%B9%DD%C8%AD%C1%FA8.png",
  },
  {
    area: "서울",
    gu_si: "중구",
    dong: "충무",
    theme: "대형",
    name: "수잔나의 앞치마",
    address: "충무로5가  36-12",
    off: "x ",
    parking: "o",
    link: "https://naver.me/5Y1wSGMK",
    image:
      "https://ldb-phinf.pstatic.net/20210612_288/1623433447568EUHi6_JPEG/lxsiw6_XAFSrJ-HbGccz71z5.jpg",
  },
  {
    area: "서울",
    gu_si: "서초구",
    dong: "서초",
    theme: "대형",
    name: "공미학",
    address: "서초동 1564-1",
    off: "x",
    parking: "x",
    link: "https://naver.me/FgivTYrQ",
    image:
      "https://ldb-phinf.pstatic.net/20190627_109/1561596327644zs39e_JPEG/76ZwYAPJWAwdMBq35gyuKKal.jpeg.jpg",
  },
  {
    area: "서울",
    gu_si: "영등포구",
    dong: "당산",
    theme: "대형",
    name: "맨홀커피",
    address: "당산동5가 43",
    off: "Mon",
    parking: "o",
    link: "https://naver.me/G3JuU5yE",
    image:
      "https://ldb-phinf.pstatic.net/20210929_112/1632906798045y4dB8_JPEG/1YQv03wrgk6LVXs4peLkCL9O.jpg",
  },
  {
    area: "서울",
    gu_si: "강남구",
    dong: "역삼",
    theme: "포근함",
    name: "라브리크 서울",
    address: "역삼동 619-10",
    off: "x",
    parking: "x",
    link: "https://naver.me/F0cNK48N",
    image:
      "https://ldb-phinf.pstatic.net/20220726_123/16588060664715aleR_JPEG/KakaoTalk_Photo_2022-07-26-12-20-35_007.jpeg",
  },
  {
    area: "서울",
    gu_si: "강남구",
    dong: "신사",
    theme: "대형",
    name: "카페 키츠네",
    address: "신사동 535-13",
    off: "신정",
    parking: "x",
    link: "https://naver.me/GBflIEAN",
    image:
      "https://ldb-phinf.pstatic.net/20200814_241/1597391408713EuXqV_JPEG/SF-DykLcHjV4zT672AzdKrxR.jpeg.jpg",
  },
  {
    area: "서울",
    gu_si: "중구",
    dong: "명동",
    theme: "우드",
    name: "더 스팟 패뷸러스",
    address: "명동2가 105",
    off: "x",
    parking: "x",
    link: "https://naver.me/G8UtUVup",
    image:
      "https://ldb-phinf.pstatic.net/20190605_297/15596704617557cePf_JPEG/47m2e1G1WQU_qACZz49QDgwK.jpg",
  },
  {
    area: "서울",
    gu_si: "관악구",
    dong: "신림",
    theme: "갤러리",
    name: "비찰",
    address: "신림동 1636-61",
    off: "Mon",
    parking: "o",
    link: "https://naver.me/F1LiQsIY",
    image:
      "https://ldb-phinf.pstatic.net/20221026_169/1666752886167lNB52_PNG/1666752858571.png",
  },
  {
    area: "서울",
    gu_si: "영등포구",
    dong: "영등포",
    theme: "힙",
    name: "Get That Shot",
    address: "영등포동 618-496",
    off: "신정",
    parking: "o",
    link: "https://naver.me/5h3qA05m",
    image:
      "https://ldb-phinf.pstatic.net/20210917_113/1631881691975id8SB_JPEG/iMmwori-0EnuOad3u-hGOfYI.JPG.jpg",
  },
  {
    area: "서울",
    gu_si: "중구",
    dong: "황학",
    theme: "포근함",
    name: "레레플레이",
    address: "황학동 753-33",
    off: "Tue",
    parking: "x",
    link: "https://naver.me/FJHjuwbz",
    image:
      "https://ldb-phinf.pstatic.net/20210824_31/1629786212632stiX2_JPEG/A447mufEYwup91qfGPlfuh7E.jpeg.jpg",
  },
  {
    area: "서울",
    gu_si: "영등포구",
    dong: "신길",
    theme: "우드",
    name: "루카스커피",
    address: "신길동 625-3",
    off: "x",
    parking: "x",
    link: "https://naver.me/GpJeFAfI",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjAzMjdfMTU3%2FMDAxNjQ4MzA3OTMxMzgx.aMuKKoGAKJ1Kt-XaKI5n2sXLFvEwFVq33SdvBlOYya0g.6XdTR7WSAnci-jqvrfTYIQLWVDiDSwOSbiuD4SEAklUg.JPEG.wsy3468%2FIMG_1074.jpg",
  },
  {
    area: "서울",
    gu_si: "강남구",
    dong: "신사",
    theme: "외국",
    name: "프론트서울",
    address: "신사동 517-27",
    off: "x",
    parking: "o",
    link: "https://naver.me/5jYrqOb1",
    image:
      "https://ldb-phinf.pstatic.net/20220821_230/16610726617184eFhQ_JPEG/KakaoTalk_20220818_123928227.jpg",
  },
  {
    area: "서울",
    gu_si: "마포구",
    dong: "상수",
    theme: "무채색",
    name: "아크로마커피바",
    address: "상수동 334-13",
    off: "x",
    parking: "x",
    link: "https://naver.me/57XRVLhz",
    image:
      "https://ldb-phinf.pstatic.net/20220215_15/1644906188443529Hs_JPEG/E9CA874F-C7A3-4EAC-8E8F-148F273A12F7.jpeg",
  },
  {
    area: "서울",
    gu_si: "영등포구",
    dong: "당산",
    theme: "힙",
    name: "더스크블루",
    address: "당산동4가 32-64",
    off: "2,4 Tue",
    parking: "x",
    link: "https://naver.me/x9JdO3y6",
    image:
      "https://ldb-phinf.pstatic.net/20220208_47/1644306664723JbR9J_JPEG/97386D25-59FC-42CC-BD67-44A0DA39C6DC.jpeg",
  },
  {
    area: "서울",
    gu_si: "중구",
    dong: "을지로",
    theme: "우드",
    name: "커피한약방",
    address: "을지로2가 101-34",
    off: "x",
    parking: "x",
    link: "https://naver.me/IIqf14Bp",
    image:
      "https://ldb-phinf.pstatic.net/20190121_43/1548072497857Io2mn_JPEG/sx5JPzlvf2rWu5Lbcu_Rdh6X.jpeg.jpg",
  },
  {
    area: "서울",
    gu_si: "송파구",
    dong: "송파",
    theme: "디저트",
    name: "봉땅 본점",
    address: "송파동 30-3",
    off: "x",
    parking: "x",
    link: "https://naver.me/GMRIxXdM",
    image:
      "https://ldb-phinf.pstatic.net/20220302_74/1646216995752svb38_JPEG/22F82BDF-3B1D-4107-A712-77C4C18498BA.jpeg",
  },
  {
    area: "서울",
    gu_si: "종로구",
    dong: "익선",
    theme: "한옥",
    name: "아삐뽀레",
    address: "익선동 166-37",
    off: "x",
    parking: "x",
    link: "https://naver.me/xMbHTAuT",
    image:
      "https://ldb-phinf.pstatic.net/20220809_238/1660031172357HezXi_JPEG/KakaoTalk_20220809_160811706_01.jpg",
  },
  {
    area: "서울",
    gu_si: "강남구",
    dong: "신사",
    theme: "한옥",
    name: "청수당",
    address: "신사동 544-9",
    off: "x",
    parking: "x",
    link: "https://naver.me/F8KnLRhZ",
    image:
      "https://ldb-phinf.pstatic.net/20200815_212/1597491562575BzoVx_JPEG/hOnygyABl4cM_VJ0bUbltA_k.jpeg.jpg",
  },
  {
    area: "서울",
    gu_si: "중구",
    dong: "신당",
    theme: "힙",
    name: "링링",
    address: "신당동 304-589",
    off: "Mon",
    parking: "x",
    link: "https://naver.me/GFpeCRFj",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjEyMDFfMTY2%2FMDAxNjY5ODIxNzk5NTAy.5j9oCPH2uTJojfv7t2oe3IrGkzqEMfBIXPO8r1awDEog.V9GT6GVZ8M-9f1LqyxproI948MdWbxP_Q4L6_nftPmwg.JPEG.cjiwons2%2FIMG_9524.JPG",
  },
  {
    area: "서울",
    gu_si: "종로구",
    dong: "익선",
    theme: "한옥",
    name: "낙원역",
    address: "익선동 166-32",
    off: "x",
    parking: "x",
    link: "https://naver.me/G0fchNtc",
    image:
      "https://ldb-phinf.pstatic.net/20220217_69/1645078270112X1ndX_PNG/KakaoTalk_20220217_150552521.png",
  },
  {
    area: "서울",
    gu_si: "용산구",
    dong: "서계",
    theme: "우드",
    name: "상향선",
    address: "서계동 33-89",
    off: "x",
    parking: "x",
    link: "https://naver.me/xGbGzo8N",
    image:
      "https://ldb-phinf.pstatic.net/20220710_31/1657446111732TFaAC_JPEG/1C9F8C96-441F-49C1-AF7D-E385503AAF69.jpeg",
  },
  {
    area: "서울",
    gu_si: "종로구",
    dong: "관훈",
    theme: "힙",
    name: "뮤직컴플렉스",
    address: "관훈동 155-2",
    off: "x",
    parking: "o",
    link: "https://naver.me/Ff0HJTfx",
    image:
      "https://ldb-phinf.pstatic.net/20220629_285/1656480009616HHc4H_JPEG/KakaoTalk_20220628_010721618_08.jpg",
  },
  {
    area: "서울",
    gu_si: "마포구",
    dong: "연남",
    theme: "힙",
    name: "VALT",
    address: "연남동 387-12",
    off: "x",
    parking: "x",
    link: "https://naver.me/535BEQmF",
    image:
      "https://ldb-phinf.pstatic.net/20200909_19/15996469572311pwlP_JPEG/x9O42M0a44ix1LEDc6QFTf5c.jpg",
  },
  {
    area: "서울",
    gu_si: "중구",
    dong: "주교",
    theme: "무채색",
    name: "누공삼",
    address: "주교동 6-1",
    off: "Tue",
    parking: "o",
    link: "https://naver.me/xaCZdBhq",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjAzMTlfMjcz%2FMDAxNjQ3Njk0NzI5ODIz.MetBvj7CYeeNm2-dr8lmRpWzOwLqXxm6Imd7mHdwIBog.IO9r3WG6gjO4LkZEfzrduMYbMjpKxn8k7tvl8oT2NtIg.JPEG.na_na_space%2Fbatch_14.JPG",
  },
  {
    area: "서울",
    gu_si: "서대문구",
    dong: "창천",
    theme: "디저트",
    name: "셀리스도넛",
    address: "창천동 52-49",
    off: "x",
    parking: "x",
    link: "https://naver.me/G2UVUPvV",
    image:
      "https://ldb-phinf.pstatic.net/20201202_258/16068721358619Dyov_JPEG/8oPV0InOGobiAq6Yyee1L_Ww.jpg",
  },
  {
    area: "서울",
    gu_si: "종로구",
    dong: "종로",
    theme: "한옥",
    name: "제이히든하우스",
    address: "종로6가 94",
    off: "x",
    parking: "x",
    link: "https://naver.me/FyexeSsz",
    image:
      "https://ldb-phinf.pstatic.net/20181029_281/1540810617011sy24b_JPEG/8tijkRw7nBaxpU7ytY9379wf.jpeg.jpg",
  },
  {
    area: "서울",
    gu_si: "마포구",
    dong: "연남",
    theme: "대형",
    name: "파이인더샵",
    address: "연남동 245-51",
    off: "x",
    parking: "x",
    link: "https://naver.me/xPQ5YqOP",
    image:
      "https://ldb-phinf.pstatic.net/20220910_152/1662817690844h7Jim_JPEG/Screenshot_20220910-224420_Instagram.jpg",
  },
  {
    area: "서울",
    gu_si: "중구",
    dong: "서소문",
    theme: "뷰맛집",
    name: "커피앤시가렛",
    address: "서소문동 75-95",
    off: "Sun",
    parking: "o",
    link: "https://naver.me/FiLEi2sl",
    image:
      "https://ldb-phinf.pstatic.net/20210928_37/1632796888350ajTMh_JPEG/CHo553O8_yHWf2c4dG7Kd-hz.jpeg.jpg",
  },
  {
    area: "서울",
    gu_si: "종로구",
    dong: "익선",
    theme: "한옥",
    name: "익선주택",
    address: "익선동 166-77",
    off: "x",
    parking: "x",
    link: "https://naver.me/FEJd3HYq",
    image:
      "https://ldb-phinf.pstatic.net/20190424_215/1556089549360a7qmt_JPEG/_biz2mSbRxxyBLZQa1s-hvFQ.jpeg.jpg",
  },
  {
    area: "서울",
    gu_si: "송파구",
    dong: "송파",
    theme: "디저트",
    name: "카페 페퍼",
    address: "송파동 51-10",
    off: "x",
    parking: "x",
    link: "https://naver.me/FOvhs9YS",
    image:
      "https://ldb-phinf.pstatic.net/20210222_119/1613958739721sDjL0_JPEG/ShYrranmhCYLF0VMighLPGAQ.jpg",
  },
  {
    area: "서울",
    gu_si: "마포구",
    dong: "연남",
    theme: "디저트",
    name: "레이어드",
    address: "연남동 223-20",
    off: "x",
    parking: "x",
    link: "https://naver.me/5L3o0yBh",
    image:
      "https://ldb-phinf.pstatic.net/20221216_153/1671170153683Jwxes_JPEG/1000013184.jpg",
  },
  {
    area: "서울",
    gu_si: "종로구",
    dong: "서린",
    theme: "대형",
    name: "페이퍼마쉐",
    address: "서린동 128-2",
    off: "x",
    parking: "x",
    link: "https://naver.me/GnGCVU9B",
    image:
      "https://ldb-phinf.pstatic.net/20200917_28/16003438484816eVLa_JPEG/tgdGWAARGpvpsBG1Cnx8V3dR.jpeg.jpg",
  },
  {
    area: "서울",
    gu_si: "강남구",
    dong: "논현",
    theme: "외국",
    name: "웨스트커프하우스",
    address: "논현동 95-8",
    off: "Mon",
    parking: "x",
    link: "https://naver.me/x9LAaheY",
    image:
      "https://ldb-phinf.pstatic.net/20220812_66/1660311361508jJGyP_JPEG/19799840-A245-4ED0-BA96-94185278C09B.jpeg",
  },
  {
    area: "서울",
    gu_si: "마포구",
    dong: "합정",
    theme: "무채색",
    name: "모크",
    address: "서교동 409-11",
    off: "x",
    parking: "x",
    link: "https://naver.me/FLBKDlCe",
    image:
      "https://ldb-phinf.pstatic.net/20220905_242/1662342905628Spulm_JPEG/KakaoTalk_20220905_105252174.jpg",
  },
  {
    area: "서울",
    gu_si: "마포구",
    dong: "망원",
    theme: "포근함",
    name: "레스피레",
    address: "망원동 57-291",
    off: "x",
    parking: "x",
    link: "https://naver.me/G0fcJEUV",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjA0MDdfMjI5%2FMDAxNjQ5MzEwNzg0ODk1.3p82FYAxLg9ncf4EWTbJZTkVKsTYextRO9mspA6YPMQg.2haxj7sPUROQ4M6Oz1kUN3XfQRBFv50SxBBePf2gRJIg.JPEG.suji3489%2FIMG_9355.JPG",
  },
  {
    area: "서울",
    gu_si: "성동구",
    dong: "성수",
    theme: "외국",
    name: "보마켓",
    address: "성수동1가 685-700",
    off: "x",
    parking: "o",
    link: "https://naver.me/FT0lrFyV",
    image:
      "https://ldb-phinf.pstatic.net/20210901_180/1630484770047Wky3q_JPEG/Jq2bDFBiZrt1jovl1X-EiSYe.JPG.jpg",
  },
  {
    area: "서울",
    gu_si: "종로구",
    dong: "익선",
    theme: "한옥",
    name: "소하염전",
    address: "익선동 166-45",
    off: "x",
    parking: "x",
    link: "https://naver.me/58F7mIJU",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjEyMjNfMjA0%2FMDAxNjcxNzgwNzc1ODE4.V4AV_-W3y7OYdXcxZ_O-NTHEmpJbSmQBPHtxXdZjB_Ag.q_d5h3_vIUToEDNTDmh_vBjKqmtfitjxu4Hy6BKK0aEg.JPEG.wish070%2F20221223%25A3%25DF123250.jpg",
  },
  {
    area: "서울",
    gu_si: "마포구",
    dong: "합정",
    theme: "무채색",
    name: "오디티",
    address: "서교동 394-20",
    off: "x",
    parking: "x",
    link: "https://naver.me/FijcXqLc",
    image:
      "https://ldb-phinf.pstatic.net/20220719_48/1658223700589vxf1n_JPEG/IMG_7844.JPG",
  },
  {
    area: "서울",
    gu_si: "강남구",
    dong: "논현",
    theme: "무채색",
    name: "구테로이테",
    address: "논현동 112-19",
    off: "x",
    parking: "o",
    link: "https://naver.me/G7KAYKmn",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjAxMjZfMjky%2FMDAxNjQzMTg2NzY4MjA4.JHTYeeLNNWHYobh7buCC6D-ftxtxhDwN6mA9evo5obcg.QimOuJ-Mfy0ImrTupsXlkZFKj5bCYJ611lMYk4HwI7Eg.JPEG.happy8038%2F1643186766811.jpg",
  },
  {
    area: "서울",
    gu_si: "성동구",
    dong: "뚝섬",
    theme: "포근함",
    name: "Dyi Workshop",
    address: "성수동1가 685-432",
    off: "Mon",
    parking: "x",
    link: "https://naver.me/G5IYIlLr",
    image:
      "https://ldb-phinf.pstatic.net/20220517_119/1652761742687byUcu_JPEG/20220510_%B0%F8%B0%A3%C1%F6%C8%C6_%C4%AB%C6%E459.jpg",
  },
  {
    area: "서울",
    gu_si: "관악구",
    dong: "신림",
    theme: "대형",
    name: "디자이너리",
    address: "신림동 1465-12",
    off: "x",
    parking: "o",
    link: "https://naver.me/xPIpBd3P",
    image:
      "https://ldb-phinf.pstatic.net/20200207_78/1581052958040n4n5U_JPEG/CR3uxWiE0jAZWeHrzpgoIC_i.jpeg.jpg",
  },
  {
    area: "서울",
    gu_si: "서대문구",
    dong: "연희",
    theme: "외국",
    name: "스웨이커피스테이션",
    address: "연희동 126-1",
    off: "x",
    parking: "x",
    link: "https://naver.me/5lZCfqOA",
    image:
      "https://ldb-phinf.pstatic.net/20210105_277/1609833800494Hlbax_JPEG/kreJOypM5uV-k933N4kNFo3i.jpg",
  },
  {
    area: "서울",
    gu_si: "중구",
    dong: "충무",
    theme: "힙",
    name: "섬광",
    address: "충무로4가 32-16",
    off: "x",
    parking: "x",
    link: "https://naver.me/Gz515RXW",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjEyMTlfMzYg%2FMDAxNjcxNDEzNzMwMjk2.TOwDT_MVka2sf9OVQdyljVQdX7kcoTaXThl9ywiPz7wg.iH8O24x727rBRrwRqMJNb_zSXQerd_8qpGAr8Xyednkg.JPEG.kjw5313%2F%25C0%25BB%25C1%25F6%25B7%25CE%25B3%25EE%25B0%25C5%25B8%25AE_%25C4%25AB%25C6%25E4_%25BC%25B6%25B1%25A4-27.jpg",
  },
  {
    area: "서울",
    gu_si: "송파구",
    dong: "방이",
    theme: "외국",
    name: "포모르",
    address: "방이동 58-24",
    off: "x",
    parking: "x",
    link: "https://naver.me/FVPba9Nd",
    image:
      "https://ldb-phinf.pstatic.net/20220824_296/1661267883067aSniz_JPEG/C235B2FF-328C-451F-9FC3-D002AF1F4F6D.jpeg",
  },
  {
    area: "서울",
    gu_si: "강남구",
    dong: "신사",
    theme: "힙",
    name: "로우앤하이",
    address: "신사동 555",
    off: "Tue",
    parking: "x",
    link: "https://naver.me/xxxNM4ga",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjA2MDhfMjA0%2FMDAxNjU0NjkxOTA4NjQx.hhW6mqIrWjAQ0rNdBkzBzxUfKjG6ReDtCrUEvvRfrE0g.utfxo5wsdVj6HXGoHRfyV27U0INnLnU0Oa6D4b57Dsgg.JPEG.chewingchoco%2FIMG_6212.jpg",
  },
  {
    area: "서울",
    gu_si: "용산구",
    dong: "한강진",
    theme: "힙",
    name: "네로우패스",
    address: "한남동 683-85",
    off: "x",
    parking: "x",
    link: "https://naver.me/5y4qz1Uu",
    image:
      "https://ldb-phinf.pstatic.net/20220228_183/1646013981719WAgAE_JPEG/1645987462944.jpg",
  },
  {
    area: "서울",
    gu_si: "마포구",
    dong: "연남",
    theme: "포근함",
    name: "마가렛 연남",
    address: "연남동 240-49",
    off: "x",
    parking: "x",
    link: "https://naver.me/xlWtuUrl",
    image:
      "https://ldb-phinf.pstatic.net/20220915_264/1663205025064CDqb3_JPEG/IMG_6722.jpg",
  },
  {
    area: "서울",
    gu_si: "성동구",
    dong: "성수",
    theme: "무채색",
    name: "연무장",
    address: "성수동2가 310-63",
    off: "x",
    parking: "o",
    link: "https://naver.me/FS6OQXcG",
    image:
      "https://ldb-phinf.pstatic.net/20220826_121/1661486181890refbO_JPEG/DC8A1636.JPG",
  },
  {
    area: "서울",
    gu_si: "마포구",
    dong: "연남",
    theme: "디저트",
    name: "베이크브리즈",
    address: "연남동 383-96",
    off: "Mon",
    parking: "x",
    link: "https://naver.me/FABI8mts",
    image:
      "https://ldb-phinf.pstatic.net/20220215_4/1644894242704bg6vc_JPEG/15E82F92-18E6-46A9-BF5E-66D8BFFCB59F.jpeg",
  },
  {
    area: "서울",
    gu_si: "동작구",
    dong: "노들",
    theme: "뷰맛집",
    name: "The한강",
    address: "본동 8-10",
    off: "x",
    parking: "x",
    link: "https://naver.me/GvknMBsf",
    image:
      "https://ldb-phinf.pstatic.net/20220610_81/1654843831166wuJcN_JPEG/KakaoTalk_20220610_154923936_04.jpg",
  },
  {
    area: "서울",
    gu_si: "마포구",
    dong: "홍대",
    theme: "주택개조",
    name: "아벨롭",
    address: "서교동 375-2",
    off: "x",
    parking: "x",
    link: "https://naver.me/GwEwmn4c",
    image:
      "https://ldb-phinf.pstatic.net/20221013_245/1665655687771GJI9I_JPEG/P20221013_105006052_9F6BE0DD-E119-4CB0-82F0-491BE386413E-2.jpg",
  },
  {
    area: "서울",
    gu_si: "서대문구",
    dong: "연희",
    theme: "주택개조",
    name: "콘하스",
    address: "연희동 90-1",
    off: "x",
    parking: "x",
    link: "https://naver.me/5L3ofM7r",
    image:
      "https://ldb-phinf.pstatic.net/20190416_72/1555399485280YO2i4_JPEG/Qj-EjO90kSAE1IaRW881ZEvg.JPG.jpg",
  },
  {
    area: "서울",
    gu_si: "용산구",
    dong: "녹사평",
    theme: "우드",
    name: "녹사다리",
    address: "이태원동 548",
    off: "Mon",
    parking: "x",
    link: "https://naver.me/GbEyGyq9",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAxODA2MDhfMTUg%2FMDAxNTI4MzkwNDUzMDQ5.R2rejBkhxedmpQInX6MPX3sE-YgKNq3GqVwf6z_nXhUg.0Zcz0Ltl4OKibbqTfGNKwWy76emI_ipQJb3zMHiYEOEg.JPEG.218_208%2FKakaoTalk_20180608_014217193.jpg",
  },
  {
    area: "서울",
    gu_si: "중구",
    dong: "을지로",
    theme: "힙",
    name: "부스",
    address: "저동2가 48-25",
    off: "Mon",
    parking: "x",
    link: "https://naver.me/5JHs9fIV",
    image:
      "https://ldb-phinf.pstatic.net/20220905_257/1662370956603baDrn_JPEG/KakaoTalk_20220830_203723696.jpg",
  },
  {
    area: "서울",
    gu_si: "중구",
    dong: "을지로",
    theme: "힙",
    name: "공간갑",
    address: "을지로3가 344-12",
    off: "x",
    parking: "x",
    link: "https://naver.me/5iziIoPy",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjA5MTdfMjk1%2FMDAxNjYzMzc1MjM3ODE5.6hfDvZ-bI3YmJMRUMbtBV4pknwueQ-4HQ9SJX7yIFbwg.wcUXg-HI8yoK2tJ7iyWXjXRqb94tWhsl6XtK2Y4Mb7Ag.JPEG.ebgml24%2FIMG_6512.jpg",
  },
  {
    area: "서울",
    gu_si: "중구",
    dong: "을지로",
    theme: "이색",
    name: "O'brett",
    address: "을지로3가 5-7",
    off: "Tue",
    parking: "x",
    link: "https://naver.me/GhE88R9F",
    image:
      "https://ldb-phinf.pstatic.net/20200313_92/1584085480159ERcQu_JPEG/YXYzPcgfT3JiiX3LzplwgUXR.JPG.jpg",
  },
  {
    area: "서울",
    gu_si: "강남구",
    dong: "삼성",
    theme: "주택개조",
    name: "포스톤즈",
    address: "삼성동 168-27",
    off: "x",
    parking: "o",
    link: "https://naver.me/GbE6eouo",
    image:
      "https://ldb-phinf.pstatic.net/20220801_26/1659343683936GHRR0_PNG/1BAE5554.png",
  },
  {
    area: "서울",
    gu_si: "중구",
    dong: "을지로",
    theme: "뷰맛집",
    name: "카다로그",
    address: "을지로2가 101-2",
    off: "Mon",
    parking: "x",
    link: "https://naver.me/xxxRyKjE",
    image:
      "https://ldb-phinf.pstatic.net/20221119_269/16688557505960kFWP_JPEG/%BC%F6%C1%A4%B5%CA_20200212_%2823%29.jpg",
  },
  {
    area: "서울",
    gu_si: "종로구",
    dong: "삼청",
    theme: "한옥",
    name: "데우스카페",
    address: "삼청동 21-3",
    off: "x",
    parking: "x",
    link: "https://naver.me/FsKzmgqD",
    image:
      "https://ldb-phinf.pstatic.net/20220915_79/1663222709946KjlEp_PNG/%BD%BA%C5%A9%B8%B0%BC%A6_2022-09-15_%BF%C0%C8%C4_3.18.17.png",
  },
  {
    area: "서울",
    gu_si: "강남구",
    dong: "역삼",
    theme: "외국",
    name: "타우너스",
    address: "역삼동 725-57",
    off: "x",
    parking: "o",
    link: "https://naver.me/xTe4hx2f",
    image:
      "https://ldb-phinf.pstatic.net/20220405_79/1649148102296WgpyX_JPEG/KakaoTalk_20220405_173736518_06.jpg",
  },
  {
    area: "서울",
    gu_si: "영등포구",
    dong: "당산",
    theme: "힙",
    name: "반카페",
    address: "당산동6가 323",
    off: "Tue",
    parking: "o",
    link: "https://naver.me/FBklTXVv",
    image:
      "https://ldb-phinf.pstatic.net/20221118_57/1668766778386IgBPd_JPEG/DSCF8459.jpg",
  },
  {
    area: "서울",
    gu_si: "성동구",
    dong: "성수",
    theme: "대형",
    name: "LOWIDE",
    address: "성수동1가 685-290",
    off: "x",
    parking: "x",
    link: "https://naver.me/FNmg5HDe",
    image:
      "https://ldb-phinf.pstatic.net/20210630_37/16250468775945BKbX_JPEG/72TE2zIoIwsNg_yguCvtEQU_.jpg",
  },
  {
    area: "서울",
    gu_si: "마포구",
    dong: "망원",
    theme: "디저트",
    name: "카페괄호",
    address: "망원동 57-50",
    off: "x",
    parking: "x",
    link: "https://naver.me/5zJ2IdQA",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjA3MDNfMTA4%2FMDAxNjU2ODUyMDcyMDE3.7Md8WiivZrIGE3SXSTGDF-3Q4T2px_7nmzZwuTIORasg.GUOjSmfMfak5FDrXGUVIg9RXG-RzGHXNAnNhP4VoAREg.JPEG.danrain90%2FIMG_0993.jpg",
  },
  {
    area: "서울",
    gu_si: "용산구",
    dong: "후암",
    theme: "뷰맛집",
    name: "카페다포딜",
    address: "용산동2가 1-349",
    off: "1st Tue",
    parking: "x",
    link: "https://naver.me/GfaGkzKF",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjAxMDRfMjMy%2FMDAxNjQxMjUzMzgxNTU4.p_LULet5uIjVdr69DlelU6__O85n5P8pRUdzsvjy_aog.oq9IBysr7rXzFmx3DKxwZHZHag0Z4fJsnSw1ZtGItvQg.JPEG.cafecrawl%2FKakaoTalk_20220104_082549332_01.jpg",
  },
  {
    area: "서울",
    gu_si: "용산구",
    dong: "한남",
    theme: "디저트",
    name: "사베",
    address: "한남동 31-7",
    off: "Mon",
    parking: "o",
    link: "https://naver.me/FpM67fpo",
    image:
      "https://ldb-phinf.pstatic.net/20220916_209/1663313743785rRH4q_JPEG/facade.jpg",
  },
  {
    area: "서울",
    gu_si: "영등포구",
    dong: "문래",
    theme: "디저트",
    name: "러스트 베이커리",
    address: "문래동2가 42-19",
    off: "x",
    parking: "x",
    link: "https://naver.me/5OnGGzrh",
    image:
      "https://ldb-phinf.pstatic.net/20221110_21/1668070793270nCyUR_JPEG/%A4%A1%A4%A1_%287%29.JPG",
  },
  {
    area: "서울",
    gu_si: "종로구",
    dong: "익선",
    theme: "한옥",
    name: "도넛정수",
    address: "익선동 126-3",
    off: "x",
    parking: "x",
    link: "https://naver.me/FkmM7v1Y",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjAxMDZfMjUx%2FMDAxNjQxNDc2NDg4OTY1.uP5YttqArFQN6hQAf_JllqklyEXt8YSdB5OwBW8R12wg.MnNlypgSlWJbJIatwlLmf3HgtLkkXISqLgruPGzTcZUg.JPEG.pablemo_on%2FIMG_5804.jpg",
  },
  {
    area: "서울",
    gu_si: "성동구",
    dong: "성수",
    theme: "포근함",
    name: "위스위츠",
    address: "성수동2가 328-13",
    off: "insta",
    parking: "x",
    link: "https://naver.me/5uxfhdLO",
    image:
      "https://ldb-phinf.pstatic.net/20210619_59/16240758542581cT7T_JPEG/J3qo_H3TV3Vu8r0ITa1pX3Rl.jpeg.jpg",
  },
  {
    area: "서울",
    gu_si: "마포구",
    dong: "연남",
    theme: "대형",
    name: "작당모의",
    address: "연남동 381-15",
    off: "x",
    parking: "x",
    link: "https://naver.me/xJNaNcBC",
    image:
      "https://ldb-phinf.pstatic.net/20201207_110/16072687274774P21e_JPEG/iyyginXruhsADawA_XdbZIq4.jpeg.jpg",
  },
  {
    area: "서울",
    gu_si: "마포구",
    dong: "연남",
    theme: "디저트",
    name: "표정",
    address: "연남동 387-15",
    off: "Tue",
    parking: "x",
    link: "https://naver.me/xVlzdNMz",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjExMTJfMTA0%2FMDAxNjY4MjI3NTQ0MjQ3.L2qA_XWZWrKNcPeTQ99Os2-UnzBY8GF8pl88rXupEfog.TvjoZWaHXI0CF5Z-Mi0JP-EWJEC1Z91baVWPGuzc9JEg.JPEG.nayeon940%2FIMG_8587.jpg",
  },
  {
    area: "서울",
    gu_si: "종로구",
    dong: "혜화",
    theme: "뷰맛집",
    name: "N321",
    address: "동숭동 201-17",
    off: "Mon,Tue",
    parking: "x",
    link: "https://naver.me/GG4i3iNi",
    image:
      "https://ldb-phinf.pstatic.net/20220915_185/16631711411365SKEz_JPEG/8CD0BBD3-32AA-4DBF-9450-52013D41DE9D.jpeg",
  },
  {
    area: "서울",
    gu_si: "마포구",
    dong: "상수",
    theme: "힙",
    name: "틸다제이",
    address: "상수동 313-6",
    off: "x",
    parking: "x",
    link: "https://naver.me/GxOBgAJx",
    image:
      "https://ldb-phinf.pstatic.net/20221103_146/1667417280612muWuz_JPEG/20221020_111603_mh1666239675071_1.jpg",
  },
  {
    area: "서울",
    gu_si: "중구",
    dong: "을지로",
    theme: "힙",
    name: "크림시크",
    address: "명동1가 59-1",
    off: "x",
    parking: "x",
    link: "https://naver.me/x8lsDEFl",
    image:
      "https://ldb-phinf.pstatic.net/20210322_266/1616395573428qpjYn_PNG/FLoDUPJ2cr-5p0fSA92VV-kx.png",
  },
  {
    area: "서울",
    gu_si: "성동구",
    dong: "서울숲",
    theme: "포근함",
    name: "커먼모티프",
    address: "성수동1가 668-97",
    off: "Tue",
    parking: "x",
    link: "https://naver.me/xWpur6qW",
    image:
      "https://ldb-phinf.pstatic.net/20221005_99/1664966725228VlFTj_JPEG/%A1%DAKakaoTalk_20221005_163141947.jpg",
  },
  {
    area: "서울",
    gu_si: "마포구",
    dong: "연남",
    theme: "디저트",
    name: "카페테틈",
    address: "연남동 382-14",
    off: "x",
    parking: "x",
    link: "https://naver.me/5hgoe01l",
    image:
      "https://ldb-phinf.pstatic.net/20220113_192/1642050443668afdrT_JPEG/7677E5F9-1B62-4ED9-BA17-25BDD948317C.jpeg",
  },
  {
    area: "서울",
    gu_si: "마포구",
    dong: "홍대",
    theme: "외국",
    name: "오퍼카페",
    address: "서교동 355-3",
    off: "x",
    parking: "o",
    link: "https://naver.me/xnndHeid",
    image:
      "https://ldb-phinf.pstatic.net/20221023_33/1666463243723AmFK5_PNG/14.png",
  },
  {
    area: "서울",
    gu_si: "마포구",
    dong: "연남",
    theme: "우드",
    name: "브라운하우스",
    address: "연남동 226-26",
    off: "x",
    parking: "x",
    link: "https://naver.me/IDB1xaaz",
    image:
      "https://ldb-phinf.pstatic.net/20201017_269/1602912655063HcOht_JPEG/jDm6LHSaCnjn_7ErZCb_ToxF.jpeg.jpg",
  },
  {
    area: "서울",
    gu_si: "마포구",
    dong: "홍대",
    theme: "힙",
    name: "어싸이드",
    address: "동교동 178-11",
    off: "x",
    parking: "x",
    link: "https://naver.me/FFvG2TDR",
    image:
      "https://ldb-phinf.pstatic.net/20210405_123/1617634193465cWc1m_JPEG/6ZtNnBV_3mDJHratTCxTeiUE.jpeg.jpg",
  },
  {
    area: "서울",
    gu_si: "강남구",
    dong: "신사",
    theme: "우드",
    name: "고이스트",
    address: "신사동 597-3",
    off: "x",
    parking: "x",
    link: "https://naver.me/5cDjfBMz",
    image:
      "https://ldb-phinf.pstatic.net/20220818_214/1660808488934wjwpM_JPEG/A4699144-1CA9-401B-AC8D-17D4C7919391.jpeg",
  },
  {
    area: "서울",
    gu_si: "광진구",
    dong: "건대",
    theme: "우드",
    name: "아르무아",
    address: "화양동 5-32",
    off: "x",
    parking: "x",
    link: "https://naver.me/FT0knagE",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMTAyMDhfMTc5%2FMDAxNjEyNzYzNjc4NTAx.ALtNgCp7wBJoSCJzBoSI8LL0ZUcwizSF4Fbdsx7zxdAg.g55XOZpukr0dXRdXq85KTDZcQhHGqNDDmuWzRNRuLpEg.JPEG.dus1478963%2FP20210207_200825373_F40A5EDE-74C7-4B19-BB70-46D8301F7309.jpg",
  },
  {
    area: "서울",
    gu_si: "용산구",
    dong: "용산",
    theme: "뷰맛집",
    name: "오잇",
    address: "용산동2가 1-471",
    off: "x",
    parking: "x",
    link: "https://naver.me/FHYuYaTi",
    image:
      "https://ldb-phinf.pstatic.net/20191023_151/1571802376942rUqFr_JPEG/v_CVFxrsHNkaxXa3A_-aU2D5.jpeg.jpg",
  },
  {
    area: "서울",
    gu_si: "마포구",
    dong: "망원",
    theme: "포근함",
    name: "씨멘트",
    address: "망원동 410-10",
    off: "x",
    parking: "o",
    link: "https://naver.me/FcamJful",
    image:
      "https://ldb-phinf.pstatic.net/20210708_60/1625715594946H53E1_JPEG/zX7mIbdHP57T2UjcJqOqMssk.jpeg.jpg",
  },
  {
    area: "서울",
    gu_si: "광진구",
    dong: "건대",
    theme: "디저트",
    name: "그자체 베이커리",
    address: "화양동 33-43",
    off: "x",
    parking: "x",
    link: "https://naver.me/IDB1Swxq",
    image:
      "https://ldb-phinf.pstatic.net/20210413_259/1618261456757RrUQx_JPEG/AP7s5gumlYaCN-2t79uaDxJ2.jpg",
  },
  {
    area: "서울",
    gu_si: "용산구",
    dong: "한강진",
    theme: "힙",
    name: "MSMR",
    address: "한남동 657-21",
    off: "Mon",
    parking: "x",
    link: "https://naver.me/G8moAGb3",
    image:
      "https://ldb-phinf.pstatic.net/20221216_237/1671165112215LqK7S_JPEG/%BE%E7%B8%BB%BB%E7%C1%F82.jpg",
  },
  {
    area: "서울",
    gu_si: "중구",
    dong: "시청",
    theme: "뷰맛집",
    name: "리에제와플 더 뷰",
    address: "태평로2가 366-1",
    off: "x",
    parking: "x",
    link: "https://naver.me/xfxAxsbh",
    image:
      "https://ldb-phinf.pstatic.net/20220701_291/1656659985774pM3av_JPEG/%BA%E4%B8%C0%C1%FD.jpg",
  },
  {
    area: "서울",
    gu_si: "마포구",
    dong: "가좌",
    theme: "외국",
    name: "르빵드파리",
    address: "연남동 246-4",
    off: "x",
    parking: "x",
    link: "https://naver.me/F31LFqAc",
    image:
      "https://ldb-phinf.pstatic.net/20221129_235/1669697916948kGds3_JPEG/%B8%A3%BB%A7%B5%E5_%BB%E7%C1%F8.jpg",
  },
  {
    area: "서울",
    gu_si: "성동구",
    dong: "서울숲",
    theme: "주택개조",
    name: "어라운드데이",
    address: "성수동1가 685-483",
    off: "x",
    parking: "x",
    link: "https://naver.me/Fk5dbZLB",
    image:
      "https://ldb-phinf.pstatic.net/20220110_133/1641824403108PYJNp_JPEG/8930F484-3CD6-4AC4-A046-E718C8FC3E12.jpeg",
  },
  {
    area: "서울",
    gu_si: "용산구",
    dong: "용산",
    theme: "외국",
    name: "브레디 포스트",
    address: "서교동 364-20",
    off: "x",
    parking: "x",
    link: "https://naver.me/FbisGrvC",
    image:
      "https://ldb-phinf.pstatic.net/20220905_224/16623668530641qIlU_JPEG/IMG_3151.jpg",
  },
  {
    area: "서울",
    gu_si: "마포구",
    dong: "망원",
    theme: "힙",
    name: "카펫",
    address: "망원동 57-12",
    off: "x",
    parking: "x",
    link: "https://naver.me/GZAj0Eqy",
    image:
      "https://ldb-phinf.pstatic.net/20211213_177/1639374033096ihuCv_JPEG/IMG_0771.jpg",
  },
  {
    area: "서울",
    gu_si: "성동구",
    dong: "성수",
    theme: "무채색",
    name: "루프 베이커리",
    address: "성수동2가 302-43",
    off: "x",
    parking: "x",
    link: "https://naver.me/535ByXxP",
    image:
      "https://ldb-phinf.pstatic.net/20210204_46/1612401031389Hg67k_JPEG/MGG32Yaa4mEVKiHpFWsBtNjk.jpg",
  },
  {
    area: "서울",
    gu_si: "중구",
    dong: "동대문",
    theme: "무채색",
    name: "티프",
    address: "쌍림동 22-16",
    off: "x",
    parking: "x",
    link: "https://naver.me/5VeAfC8z",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjA4MDlfMTAx%2FMDAxNjYwMDU0NDQ5NDE4.JRLkH5N87t8WjgrcoS1xEY0_hGJ8j5CG-LZMMgjQNLIg.Si_T-VOFiSwa21iriVEcCGCyO-gq85vJQgQWyLngM5cg.JPEG.ginasuji%2FIMG_5938.jpg",
  },
  {
    area: "서울",
    gu_si: "강남구",
    dong: "신사",
    theme: "드로잉",
    name: "미야갤러리",
    address: "신사동 517-29",
    off: "x",
    parking: "o",
    link: "https://naver.me/FU35Pmin",
    image:
      "https://ldb-phinf.pstatic.net/20210524_276/1621841977327EO8BY_JPEG/QA5q5YBkpYrXiCnkXx0HrkUk.jpg",
  },
  {
    area: "서울",
    gu_si: "성동구",
    dong: "뚝섬",
    theme: "디저트",
    name: "온더",
    address: "성수동1가 7-13",
    off: "x",
    parking: "o",
    link: "https://naver.me/x2PkMpPM",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMTA1MjBfMTgz%2FMDAxNjIxNTEyNzIwMjM0.VO7dFAr_Fw8td_C8Tk3oQ9KMWrb3WumNkjv9__2tZjgg.r8vTNDBcHYzEAC4ICo92KqZnLUZjeGRTFQ-CtKQuDYYg.JPEG.jjininimms%2FDSC08398.jpg",
  },
  {
    area: "서울",
    gu_si: "마포구",
    dong: "연남",
    theme: "이색",
    name: "펠른",
    address: "연남동 504-50",
    off: "x",
    parking: "o",
    link: "https://naver.me/GFpeeJMx",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMTA3MjdfODUg%2FMDAxNjI3MzQ1MjU5NTc2.vwrXbNxzc3pYvz0lhDd9zFrOoJupqmUrztJUaI-_LEAg.g1VS3QxnBtpHCnUKDjh8GFOv6zFQ6Cz4sdRwLntGyvAg.JPEG.ugogirl96%2FKakaoTalk_20210726_071632571_01.jpg",
  },
  {
    area: "서울",
    gu_si: "마포구",
    dong: "홍대",
    theme: "포근함",
    name: "커피 벌스데이",
    address: "서교동 328-74",
    off: "신정",
    parking: "x",
    link: "https://naver.me/xpPET6wq",
    image:
      "https://ldb-phinf.pstatic.net/20210909_1/1631160025758rVXME_JPEG/Lf39mp4-Uow_1mTms3Guh_bq.jpeg.jpg",
  },
  {
    area: "서울",
    gu_si: "송파구",
    dong: "석촌",
    theme: "포근함",
    name: "카페2.7",
    address: "석촌동 58-24",
    off: "Tue",
    parking: "x",
    link: "https://naver.me/G0IsYetj",
    image:
      "https://ldb-phinf.pstatic.net/20220708_146/1657241444122Gopfp_JPEG/7.jpeg",
  },
  {
    area: "서울",
    gu_si: "영등포구",
    dong: "문래",
    theme: "대형",
    name: "폰트",
    address: "문래동2가 33-4",
    off: "x",
    parking: "x",
    link: "https://naver.me/FTO5egeG",
    image:
      "https://ldb-phinf.pstatic.net/20220406_47/1649205846440PbTrS_JPEG/pont_mullae_001.jpg",
  },
  {
    area: "서울",
    gu_si: "용산구",
    dong: "서빙고",
    theme: "힙",
    name: "어반플랜트",
    address: "서빙고동 195-1",
    off: "x",
    parking: "x",
    link: "https://naver.me/GQcoS9ZT",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjAxMjhfMTk1%2FMDAxNjQzMzUyMjEzNjU0.hKGT2C_tv0JQkhKC4To9gBgJwHHaTlOVIiq6pPGw2mEg.zR8YKVEZqka7aIYBmk9PEYB4msUbwPfkI3EdrU1ptrcg.JPEG.cjaezero%2FIMG_8724.jpg",
  },
  {
    area: "서울",
    gu_si: "마포구",
    dong: "합정",
    theme: "대형",
    name: "포비 베이직",
    address: "합정동 426-18",
    off: "x",
    parking: "x",
    link: "https://naver.me/FzHm9yZF",
    image:
      "https://ldb-phinf.pstatic.net/20180718_132/1531902568681jBDV6_JPEG/WciZ4iyNBr66V6A6KbQYq-Tr.jpg",
  },
  {
    area: "서울",
    gu_si: "중구",
    dong: "을지로",
    theme: "뷰맛집",
    name: "바캉스커피",
    address: "다동 117",
    off: "Mon",
    parking: "x",
    link: "https://naver.me/xdIk6iBo",
    image:
      "https://ldb-phinf.pstatic.net/20221208_197/1670472169726ohrGt_JPEG/C3043976-8C7C-402F-A973-E028BCA29C7D.jpeg",
  },
  {
    area: "서울",
    gu_si: "마포구",
    dong: "홍대",
    theme: "무채색",
    name: "어썸마운틴",
    address: "동교동 113-83",
    off: "x",
    parking: "x",
    link: "https://naver.me/FZJ6utbu",
    image:
      "https://ldb-phinf.pstatic.net/20210606_80/1622957251633uBdjW_JPEG/K5LJJeJGighoHd4L3N1gjEpU.jpg",
  },
  {
    area: "서울",
    gu_si: "마포구",
    dong: "가좌",
    theme: "포근함",
    name: "브래디스커피",
    address: "연남동 244-1",
    off: "M,T,W",
    parking: "x",
    link: "https://naver.me/GA1SligJ",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjA1MjVfOCAg%2FMDAxNjUzNDY3NTQ1NTk1.KVmRsTPDE8erCcGA6bGGJYhO15sNNuaBRZVllLns5-og.Lk8Qn3uAwNrS-SEke4kYx84w-8HVZPpfWm8YeXMlNQsg.JPEG.mayeye1004%2FIMG_2292.jpg",
  },
  {
    area: "서울",
    gu_si: "마포구",
    dong: "홍대",
    theme: "디저트",
    name: "비포블루밍",
    address: "동교동 148-9",
    off: "x",
    parking: "x",
    link: "https://naver.me/F9Qpjz9B",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMzAxMDNfNzkg%2FMDAxNjcyNzU0ODY5MTUy.XgSWciWiXoyKK6Q2_oCSeIMmxFweismgcvl_O-XH9JMg.d7_4OsaQrQWiR5_8vS7qtS4HoWaGtclikC8DS6ToHrUg.JPEG.tszx9207%2FIMG_8837.JPG",
  },
  {
    area: "서울",
    gu_si: "광진구",
    dong: "건대",
    theme: "힙",
    name: "투또톤토",
    address: "화양동 5-3",
    off: "x",
    parking: "x",
    link: "https://naver.me/xdVrSkqO",
    image:
      "https://ldb-phinf.pstatic.net/20220529_80/1653758621504KKmWy_JPEG/KakaoTalk_20220529_022223806_01.jpg",
  },
  {
    area: "서울",
    gu_si: "마포구",
    dong: "합정",
    theme: "포근함",
    name: "멧라운지",
    address: "서교동 398-5",
    off: "x",
    parking: "o",
    link: "https://naver.me/5OntKUwb",
    image:
      "https://ldb-phinf.pstatic.net/20200329_180/1585442218524j0oTR_JPEG/DpsZdCn2D39zJjLg94KrUT6a.jpg",
  },
  {
    area: "서울",
    gu_si: "성동구",
    dong: "왕십리",
    theme: "힙",
    name: "BlueJAY",
    address: "하왕십리동 972-33",
    off: "x",
    parking: "o",
    link: "https://naver.me/GQcephBU",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjAyMDZfMjY2%2FMDAxNjQ0MTMxODQwODAz.02S_IJmxX4KBJ_Zy6xe1JXEfGkKc-MDWzLx025umyBkg.GVzhOuwLn3xF8V5JDv8v_XwMo3yLTuO5Zm0RIIkme5Ag.JPEG.witch3211%2F20220205_165750.jpg",
  },
  {
    area: "서울",
    gu_si: "강남구",
    dong: "압구정",
    theme: "이색",
    name: "페인팅룸",
    address: "신사동 644-13",
    off: "x",
    parking: "x",
    link: "https://naver.me/FzHmLHbT",
    image:
      "https://ldb-phinf.pstatic.net/20220524_23/16533713881882mnWs_JPEG/1653368062347.jpg",
  },
  {
    area: "서울",
    gu_si: "영등포구",
    dong: "문래",
    theme: "힙",
    name: "무슨클럽",
    address: "문래동2가 60-9",
    off: "x",
    parking: "x",
    link: "https://naver.me/Fdsfdbw8",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMTEyMjdfMjU0%2FMDAxNjQwNjAzNDc5MTk4.hlYBmN2ptoGXwJmGJealoorsRNH8HnvvXdJXJDj-3r0g.P4YV20vmIPU-QH3lLGMZE9BiOFJAU_VyGHTuZ3A_12Mg.JPEG.su406%2FIMG_2172.jpg",
  },
  {
    area: "서울",
    gu_si: "용산구",
    dong: "한강진",
    theme: "대형",
    name: "맥심플랜트",
    address: "한남동 683-140",
    off: "x",
    parking: "x",
    link: "https://naver.me/5Q4GIRso",
    image:
      "https://ldb-phinf.pstatic.net/20180426_166/1524721255503DlppS_JPEG/6LXLh-aVMUbqBk8rE--V597R.jpg",
  },
  {
    area: "서울",
    gu_si: "성동구",
    dong: "뚝섬",
    theme: "디저트",
    name: "인치스",
    address: "성수동1가 685-420",
    off: "Mon",
    parking: "x",
    link: "https://naver.me/5PZ3SDpa",
    image:
      "https://ldb-phinf.pstatic.net/20220722_108/1658467450805i6Fzb_JPEG/3E94C3D3-2EDB-47A4-87A6-770E5C928793.jpg",
  },
  {
    area: "서울",
    gu_si: "성동구",
    dong: "뚝섬",
    theme: "힙",
    name: "보스코",
    address: "성수동1가 656-1097",
    off: "x",
    parking: "x",
    link: "https://naver.me/5DbjFKTp",
    image:
      "https://ldb-phinf.pstatic.net/20220704_250/1656904023378T52qj_JPEG/D5AD1559-C73D-4997-806B-95AC3631C331.jpeg",
  },
  {
    area: "경기도",
    gu_si: "남양주",
    dong: "별내",
    theme: "대형",
    name: "보나리베",
    address: "별내동 719-2",
    off: "x",
    parking: "o",
    link: "https://naver.me/5SWasKcR",
    image:
      "https://ldb-phinf.pstatic.net/20191111_209/15734489718515ujdE_JPEG/QNEBRFHiyYsO5X6eot9yEcEk.jpg",
  },
  {
    area: "경기도",
    gu_si: "남양주",
    dong: "별내",
    theme: "대형",
    name: "닉센",
    address: "별내동 659",
    off: "x",
    parking: "o",
    link: "https://naver.me/5vIiEcPf",
    image:
      "https://ldb-phinf.pstatic.net/20220620_70/1655652610752cz3j1_JPEG/KakaoTalk_20220609_164915499_02.jpg",
  },
  {
    area: "서울",
    gu_si: "종로구",
    dong: "인왕산",
    theme: "이색",
    name: "더숲 초소책방",
    address: "옥인동 산3-1",
    off: "x",
    parking: "x",
    link: "https://naver.me/FGoe3mEj",
    image:
      "https://ldb-phinf.pstatic.net/20221125_69/1669340172603Hn8la_JPEG/0D269C2D-5EE6-4315-9F13-CAFAFB811546.jpeg",
  },
  {
    area: "서울",
    gu_si: "강북구",
    dong: "수유",
    theme: "뷰맛집",
    name: "아카데미하우스",
    address: "수유동 산76",
    off: "x",
    parking: "o",
    link: "https://naver.me/Gv97eP7S",
    image:
      "https://ldb-phinf.pstatic.net/20220817_172/1660703601542hKSqc_JPEG/IMG_7226.jpg",
  },
  {
    area: "서울",
    gu_si: "종로구",
    dong: "부암",
    theme: "뷰맛집",
    name: "산모퉁이",
    address: "부암동 97-5",
    off: "x",
    parking: "x",
    link: "https://naver.me/5fnjEUN3",
    image:
      "https://ldb-phinf.pstatic.net/20190529_35/1559062899693b4E2n_JPEG/RRUvkPF-XvvbwFz6yEulEPVv.JPG.jpg",
  },
  {
    area: "서울",
    gu_si: "강북구",
    dong: "수유",
    theme: "주택개조",
    name: "수유리조트",
    address: "수유동 221-18",
    off: "x",
    parking: "x",
    link: "https://naver.me/FFviHKQt",
    image:
      "https://ldb-phinf.pstatic.net/20201001_17/1601489606186fQOLH_JPEG/jZLHRLPNxFod3oWFAExNHTuH.jpeg.jpg",
  },
  {
    area: "서울",
    gu_si: "성북구",
    dong: "성신",
    theme: "무채색",
    name: "PRD",
    address: "동선동4가 127",
    off: "Mon",
    parking: "x",
    link: "https://naver.me/FMw2cU05",
    image:
      "https://ldb-phinf.pstatic.net/20220513_27/1652444477807eoMtj_JPEG/E953EE7C-311C-4BF8-99FD-7571C0BC6833.jpeg",
  },
  {
    area: "서울",
    gu_si: "성북구",
    dong: "성북",
    theme: "대형",
    name: "오버스토리",
    address: "성북동 8-28",
    off: "예약제",
    parking: "x",
    link: "https://naver.me/5PS2R247",
    image:
      "https://ldb-phinf.pstatic.net/20200715_80/1594788301681WrXMk_JPEG/Ua8zhLO0rO9pzhTRLbypN1CI.jpg",
  },
  {
    area: "경기도",
    gu_si: "하남시",
    dong: "검단산",
    theme: "외국",
    name: "카페웨더",
    address: "창우동 287-1",
    off: "x",
    parking: "o",
    link: "https://naver.me/Fgivtt1G",
    image:
      "https://ldb-phinf.pstatic.net/20220422_80/1650626424615SBl47_JPEG/AD57AB15-1213-405E-9C55-CF221C7FE724.jpeg",
  },
  {
    area: "경기도",
    gu_si: "남양주",
    dong: "평내",
    theme: "대형",
    name: "키스톤 스피시즈",
    address: "금곡동 14-1",
    off: "x",
    parking: "o",
    link: "https://naver.me/5DHEEXWl",
    image:
      "https://ldb-phinf.pstatic.net/20211015_165/16342982605743Rlcy_JPEG/x2soyAj3sjt7EBEt7uktdDL-.jpg",
  },
  {
    area: "경기도",
    gu_si: "남양주",
    dong: "별내",
    theme: "뷰맛집",
    name: "카페파즈",
    address: "별내동 1148-6",
    off: "x",
    parking: "o",
    link: "https://naver.me/FEJOHR8b",
    image:
      "https://ldb-phinf.pstatic.net/20210908_227/1631096865762jffsU_JPEG/2YXEPaRKd8yi2B_H0jVMPnJE.jpeg.jpg",
  },
  {
    area: "경기도",
    gu_si: "남양주",
    dong: "북한강",
    theme: "뷰맛집",
    name: "대너리스",
    address: "삼봉리 200-18",
    off: "x",
    parking: "o",
    link: "https://naver.me/FmgVT8IU",
    image:
      "https://ldb-phinf.pstatic.net/20211228_220/16406941924980rzTh_JPEG/KakaoTalk_20211228_205420061_07.jpg",
  },
  {
    area: "경기도",
    gu_si: "남양주",
    dong: "북한강",
    theme: "뷰맛집",
    name: "라온숨",
    address: "금남리 671",
    off: "x",
    parking: "o",
    link: "https://naver.me/56IDFXeL",
    image:
      "https://ldb-phinf.pstatic.net/20210607_89/1623030336448DCPhA_JPEG/uMt0Uqw-EKhUejIC6Mfd4arO.jpg",
  },
  {
    area: "경기도",
    gu_si: "양평",
    dong: "북한강",
    theme: "한옥",
    name: "하우스 베이커리",
    address: "문호리 338-1",
    off: "x",
    parking: "o",
    link: "https://naver.me/GJrF3UyN",
    image:
      "https://ldb-phinf.pstatic.net/20181104_138/1541298745385tcsyz_JPEG/oLJrOmesRm46px3bV5nbPCUd.JPG.jpg",
  },
  {
    area: "경기도",
    gu_si: "남양주",
    dong: "별내",
    theme: "디저트",
    name: "카페소유",
    address: "별내동 2286-17",
    off: "x",
    parking: "o",
    link: "https://naver.me/GMRvA4di",
    image:
      "https://ldb-phinf.pstatic.net/20210309_191/1615279049262I1Ib0_JPEG/qy3g6MUMEX9kok7M6WOPC-ML.jpg",
  },
  {
    area: "경기도",
    gu_si: "남양주",
    dong: "송천",
    theme: "힙",
    name: "수디",
    address: "송천리 306-1",
    off: "Mon",
    parking: "o",
    link: "https://naver.me/5yXvKixi",
    image:
      "https://ldb-phinf.pstatic.net/20211127_142/1637987328336QXkdu_JPEG/003A0C32-2207-4A66-B451-848A7B38DD77.jpeg",
  },
  {
    area: "경기도",
    gu_si: "남양주",
    dong: "북한강",
    theme: "뷰맛집",
    name: "하백 북한강점",
    address: "금남리 689",
    off: "x",
    parking: "o",
    link: "https://naver.me/FbRh37vN",
    image:
      "https://ldb-phinf.pstatic.net/20221219_90/1671425135635mzbGL_JPEG/KakaoTalk_20221219_125410548_04.jpg",
  },
  {
    area: "경기도",
    gu_si: "남양주",
    dong: "화도",
    theme: "대형",
    name: "더베이커스가든",
    address: "묵현리 150-1",
    off: "x",
    parking: "o",
    link: "https://naver.me/55I693Kp",
    image:
      "https://ldb-phinf.pstatic.net/20211129_100/1638173832150VodlQ_PNG/%BA%A31111112.png",
  },
  {
    area: "경기도",
    gu_si: "양평",
    dong: "북한강",
    theme: "대형",
    name: "테라로사",
    address: "문호리 623",
    off: "x",
    parking: "o",
    link: "https://naver.me/59jNjKCl",
    image:
      "https://ldb-phinf.pstatic.net/20201010_57/16023277141841KhDO_JPEG/nDv-stu7VdsNkibDeI2kdGAq.jpg",
  },
  {
    area: "서울",
    gu_si: "강북구",
    dong: "수유",
    theme: "주택개조",
    name: "레드포션",
    address: "수유동 224-26",
    off: "x",
    parking: "x",
    link: "https://naver.me/xrt2kHwn",
    image:
      "https://ldb-phinf.pstatic.net/20220223_267/1645614547871PAeKR_JPEG/Screenshot_20220223-200606_Instagram.jpg",
  },
  {
    area: "경기도",
    gu_si: "남양주",
    dong: "진접",
    theme: "대형",
    name: "달빛새 베이커리",
    address: "내각리 473",
    off: "x",
    parking: "o",
    link: "https://naver.me/5zJolYYs",
    image:
      "https://ldb-phinf.pstatic.net/20220823_212/16612395078158BkQ1_JPEG/%B3%B2%BE%E7%C1%D6%C4%AB%C6%E4_%B4%DE%BA%FB%BB%F5%BA%A3%C0%CC%C4%BF%B8%AE_53.jpg",
  },
  {
    area: "경기도",
    gu_si: "남양주",
    dong: "진접",
    theme: "이색",
    name: "그날그날",
    address: "금곡리 778",
    off: "Tue",
    parking: "o",
    link: "https://naver.me/FPseB2pF",
    image:
      "https://ldb-phinf.pstatic.net/20211001_83/1633055416367NuXmg_JPEG/DlDt7VU-BElx3aRDijy4f-98.jpeg.jpg",
  },
  {
    area: "서울",
    gu_si: "노원구",
    dong: "노원",
    theme: "힙",
    name: "뮤어카페",
    address: "상계동 693",
    off: "Wen",
    parking: "o",
    link: "https://naver.me/5CbGwDLW",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjEwMjNfMjcg%2FMDAxNjY2NDkzMjA5NDkz.IQBcPDTe90O1fXqbrtoPR6xJHm1bRjH3YqWZI0L62DIg.KjYClKUxOb6b8sfqms7JWUhTeGuenUoryB4vxiznq5kg.JPEG.abcsk0319%2FIMG_1099.jpg",
  },
  {
    area: "경기도",
    gu_si: "의정부",
    dong: "의정부",
    theme: "포근함",
    name: "옴브레",
    address: "의정부동 176-10",
    off: "Tue",
    parking: "x",
    link: "https://naver.me/FWvyJdh1",
    image:
      "https://ldb-phinf.pstatic.net/20220420_82/1650451265425xkt5T_JPEG/0E7A2469.jpg",
  },
  {
    area: "서울",
    gu_si: "노원구",
    dong: "노원",
    theme: "디저트",
    name: "시즌",
    address: "상계동 358-6",
    off: "x",
    parking: "x",
    link: "https://naver.me/Fgivr80N",
    image:
      "https://ldb-phinf.pstatic.net/20200604_264/1591260698406KVfS6_JPEG/gVMyoQGImeSkoQ78cUp2gNiT.jpeg.jpg",
  },
  {
    area: "경기도",
    gu_si: "남양주",
    dong: "화도",
    theme: "외국",
    name: "더하이브",
    address: "월산리 288-2",
    off: "x",
    parking: "o",
    link: "https://naver.me/xJNavPBa",
    image:
      "https://ldb-phinf.pstatic.net/20180719_238/1532003577725xA5Hy_JPEG/mph2icbv6z80kHDWCUKJn8qi.jpg",
  },
  {
    area: "경기도",
    gu_si: "남양주",
    dong: "별내",
    theme: "디저트",
    name: "산들제빵소",
    address: "별내동 785-1",
    off: "x",
    parking: "o",
    link: "https://naver.me/xDs6WaZB",
    image:
      "https://ldb-phinf.pstatic.net/20191209_114/1575859058079mCmCh_JPEG/FI8WYPt8lNbp-34gADFgUOiD.jpg",
  },
  {
    area: "경기도",
    gu_si: "의정부",
    dong: "의정부",
    theme: "무채색",
    name: "앤앤드",
    address: "의정부동 176-14",
    off: "Wen",
    parking: "x",
    link: "https://naver.me/xB4P7scp",
    image:
      "https://ldb-phinf.pstatic.net/20210419_148/1618836329484DRfve_JPEG/DfKZ69yFOkj7ZX8J9t_MHoI-.jpg",
  },
  {
    area: "서울",
    gu_si: "노원구",
    dong: "공릉",
    theme: "주택개조",
    name: "위플랜트",
    address: "공릉동 587-1",
    off: "x",
    parking: "x",
    link: "https://naver.me/5oQi8B2J",
    image:
      "https://ldb-phinf.pstatic.net/20191230_9/1577692788825zjG1i_JPEG/w7rUEIuLlUmc_PnYAj2UH8in.jpeg.jpg",
  },
  {
    area: "서울",
    gu_si: "노원구",
    dong: "노원",
    theme: "우드",
    name: "감각",
    address: "상계동 337",
    off: "x",
    parking: "o",
    link: "https://naver.me/GGhUuAJW",
    image:
      "https://ldb-phinf.pstatic.net/20190428_7/155642426842097bSz_JPEG/8o9GdutpA2a3s3mGITU_5s7G.jpg",
  },
  {
    area: "경기도",
    gu_si: "남양주",
    dong: "다산",
    theme: "포근함",
    name: "요피",
    address: "다산동 6060-2",
    off: "x",
    parking: "o",
    link: "https://naver.me/xIhatUrE",
    image:
      "https://ldb-phinf.pstatic.net/20211005_229/16334343409838KqVk_JPEG/wwrnDFYgik3uHSw-_kl2Q73i.jpg",
  },
  {
    area: "경기도",
    gu_si: "의정부",
    dong: "민락",
    theme: "포근함",
    name: "커피하다",
    address: "민락동 819-1",
    off: "x",
    parking: "o",
    link: "https://naver.me/xjeJVkiL",
    image:
      "https://ldb-phinf.pstatic.net/20190912_42/1568276680131vUfYY_JPEG/MiRWh8e_YNQhacI5mojV-ZRu.jpeg.jpg",
  },
  {
    area: "서울",
    gu_si: "강북구",
    dong: "수유",
    theme: "힙",
    name: "티틸Cafe+Bar",
    address: "수유동 221-21",
    off: "Tue",
    parking: "o",
    link: "https://naver.me/x8ByGfMA",
    image:
      "https://ldb-phinf.pstatic.net/20221013_207/1665658378476xOLcK_JPEG/DSCF2498.jpg",
  },
  {
    area: "경기도",
    gu_si: "구리",
    dong: "구리",
    theme: "주택개조",
    name: "피어네",
    address: "수택동 521-54",
    off: "wen",
    parking: "x",
    link: "https://naver.me/FCb4NO0b",
    image:
      "https://ldb-phinf.pstatic.net/20211214_263/16394750565418w536_JPEG/%C7%C7%BE%EE%B3%D7_%BF%DC%BA%CE.jpg",
  },
  {
    area: "경기도",
    gu_si: "남양주",
    dong: "오남",
    theme: "뷰맛집",
    name: "실버팟",
    address: "오남리 30-5",
    off: "x",
    parking: "o",
    link: "https://naver.me/GWFrobLw",
    image:
      "https://ldb-phinf.pstatic.net/20221222_99/1671688390430SQw6R_JPEG/%A4%A4%A4%B7%A4%B8%A4%A1324324.jpg",
  },
  {
    area: "서울",
    gu_si: "강북구",
    dong: "수유",
    theme: "무채색",
    name: "육월",
    address: "수유동 182-46",
    off: "wen",
    parking: "x",
    link: "https://naver.me/x22TpV71",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjA2MjNfNDgg%2FMDAxNjU1OTcxNTg1OTQ1.ap5pExlUFzyF6z38TFj-NEPijatgZc4lpcC_WLg8yzkg.CkkY6VxOXYdN1F_VG6dsjpF80dp-Z9N5K4HynpUOQy8g.JPEG.dajungaaa%2Foutput_3181659090.jpg",
  },
  {
    area: "경기도",
    gu_si: "남양주",
    dong: "화도",
    theme: "대형",
    name: "맷돌카페",
    address: "마석우리 514-13",
    off: "x",
    parking: "o",
    link: "https://naver.me/F9VYrCnU",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjEwMjhfNzgg%2FMDAxNjY2OTY3NTA4NjI4.2KUZeMZQ6MSunzeomIwI8768e3ksCbovdGrTcRQAQIAg.FRmGXC0kZDhr04llqpVV59EJh07y6p2t05DTkyT5nZsg.JPEG.sy2eh%2FIMG_6677.JPG",
  },
  {
    area: "경기도",
    gu_si: "양평",
    dong: "북한강",
    theme: "외국",
    name: "느린정원",
    address: "문호리 640-1",
    off: "Tue",
    parking: "o",
    link: "https://naver.me/FqSHE6DC",
    image:
      "https://ldb-phinf.pstatic.net/20180820_265/1534728521024qWuYx_JPEG/A40ePOCNkmfcvWUBEAkqH8k6.jpeg.jpg",
  },
  {
    area: "경기도",
    gu_si: "남양주",
    dong: "별내",
    theme: "디저트",
    name: "라플렌",
    address: "청학리 551",
    off: "x",
    parking: "o",
    link: "https://naver.me/535B08C2",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMTA5MjhfMjY5%2FMDAxNjMyODE2NTk3MzQx.NCNIJzdKFasZBz1JtyZGN36pJiy1I5FMdy_ICDkh-Gwg.QK7lZ6VjMSomjO8bOsW5aTqxlySif4XV5MGUQdAenwwg.JPEG.eueuy%2F20210928_170835.jpg",
  },
  {
    area: "서울",
    gu_si: "강북구",
    dong: "수유",
    theme: "포근함",
    name: "선데이 베이글",
    address: "수유동 189-37",
    off: "x",
    parking: "x",
    link: "https://naver.me/5bRNPpD7",
    image:
      "https://ldb-phinf.pstatic.net/20220214_34/1644813475593Ap9yy_JPEG/25B5B887-3B02-42E4-952F-A3A3D9CDAEDC.jpeg",
  },
  {
    area: "경기도",
    gu_si: "남양주",
    dong: "도농",
    theme: "포근함",
    name: "카페소고",
    address: "일패동 561-2",
    off: "x",
    parking: "o",
    link: "https://naver.me/I5FcW3vL",
    image:
      "https://ldb-phinf.pstatic.net/20210603_138/1622706381398dWsq4_JPEG/ubidGtQl9RO9ZSuXmLMHX_9s.jpeg.jpg",
  },
  {
    area: "경기도",
    gu_si: "남양주",
    dong: "북한강",
    theme: "뷰맛집",
    name: "녹화",
    address: "금남리 657-2",
    off: "x",
    parking: "o",
    link: "https://naver.me/535BBEal",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMTA3MjBfNDkg%2FMDAxNjI2NzY4MjY3NDgx.2NQH3yQW6ZKs5SEQJBY7sDlWwSRMS4aDktDqskiwf40g.ZJN3U65V2PHIEYZRDBKL2Zdt1FkMuy9nIUmVeCQWMnMg.JPEG.sy920125%2FKakaoTalk_20210720_125521005_02.jpg",
  },
  {
    area: "서울",
    gu_si: "도봉구",
    dong: "쌍문",
    theme: "뷰맛집",
    name: "세이지",
    address: "쌍문동 167-6",
    off: "Tue",
    parking: "o",
    link: "https://naver.me/xBh2Z0j7",
    image:
      "https://ldb-phinf.pstatic.net/20221024_97/16665938508952XNHS_JPEG/1666593792759-0.jpg",
  },
  {
    area: "서울",
    gu_si: "강북구",
    dong: "미아",
    theme: "힙",
    name: "어니언 미아",
    address: "미아동 127-9",
    off: "x",
    parking: "x",
    link: "https://naver.me/F0Kw55QD",
    image:
      "https://ldb-phinf.pstatic.net/20190204_137/1549212805018QTWb0_PNG/i2fDWplpuc2dxZ9ixhz0vhvz.png",
  },
  {
    area: "서울",
    gu_si: "강북구",
    dong: "미아",
    theme: "주택개조",
    name: "베이커안",
    address: "미아동 695-3",
    off: "Mon",
    parking: "x",
    link: "https://naver.me/IFFjz7X2",
    image:
      "https://ldb-phinf.pstatic.net/20221115_266/1668464662023cz3SI_JPEG/1667810598593.jpg",
  },
  {
    area: "서울",
    gu_si: "강북구",
    dong: "미아",
    theme: "주택개조",
    name: "폴드커피",
    address: "하월곡동 133",
    off: "Tue",
    parking: "x",
    link: "https://naver.me/GjRGnNvn",
    image:
      "https://ldb-phinf.pstatic.net/20190510_271/1557446828368qnY8g_JPEG/x0x9HZ3d2R-s5ZfhSOrDhyOF.jpg",
  },
  {
    area: "서울",
    gu_si: "강북구",
    dong: "미아",
    theme: "무채색",
    name: "데어유고",
    address: "미아동 52-68",
    off: "Tue",
    parking: "x",
    link: "https://naver.me/xTeAPe2n",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjA4MDFfMTk3%2FMDAxNjU5MzM3NjA1Njk5.zlUd3a_qfb0MSdJZFiUl53t02f-YRnw1uieO_nXlRwkg.8KWVdQjvQ1fi1oi36mvuzEuf28yGnDZvGEK5FfutQi0g.JPEG.ahcldk%2FIMG_8768.JPG",
  },
  {
    area: "서울",
    gu_si: "성북구",
    dong: "길음",
    theme: "포근함",
    name: "바스크",
    address: "길음동 1171-14",
    off: "Thur",
    parking: "x",
    link: "https://naver.me/GGhUM4hA",
    image:
      "https://ldb-phinf.pstatic.net/20170529_97/1496029171194BIsPN_JPEG/186477426636976_2.jpeg",
  },
  {
    area: "서울",
    gu_si: "강북구",
    dong: "미아",
    theme: "포근함",
    name: "녹베이크샵",
    address: "미아동 465-46",
    off: "Sun",
    parking: "x",
    link: "https://naver.me/Fgi9OEay",
    image:
      "https://ldb-phinf.pstatic.net/20210720_33/1626747568137KESAA_JPEG/aZHYTyU-FwEHvDhy2oYBUdoJ.jpg",
  },
  {
    area: "서울",
    gu_si: "강북구",
    dong: "미아",
    theme: "힙",
    name: "코스모",
    address: "미아동 87-177",
    off: "x",
    parking: "x",
    link: "https://naver.me/GPrhfs1u",
    image:
      "https://ldb-phinf.pstatic.net/20211121_277/16374535800808jWYX_JPEG/1A204572-3DE7-4ABB-B3F4-DA925E2FFCF6.jpeg",
  },
  {
    area: "인천",
    gu_si: "옹진",
    dong: "영흥도",
    theme: "뷰맛집",
    name: "하이바다",
    address: "내리 724-132",
    off: "Wen",
    parking: "o",
    link: "https://naver.me/FEJdw6q8",
    image:
      "https://ldb-phinf.pstatic.net/20190521_289/1558404864782qnXQ3_JPEG/_tQbCM7Lamdkehbtq-uLNF2f.jpeg.jpg",
  },
  {
    area: "경기도",
    gu_si: "수원",
    dong: "행궁",
    theme: "외국",
    name: "프랭크커핀바",
    address: "신풍동 221-19",
    off: "x",
    parking: "x",
    link: "https://naver.me/5wHCypuy",
    image:
      "https://ldb-phinf.pstatic.net/20221103_227/16674563437402wi3S_JPEG/1667031231588-1.jpg",
  },
  {
    area: "경기도",
    gu_si: "수원",
    dong: "팔달",
    theme: "대형",
    name: "와치유어헤드",
    address: "북수동 15-1",
    off: "x",
    parking: "x",
    link: "https://naver.me/GguVXIUQ",
    image:
      "https://ldb-phinf.pstatic.net/20221115_35/1668507796209emRQU_JPEG/2654BCED-FCBF-4F5C-B8B7-C9ED0BFA999E.jpeg",
  },
  {
    area: "경기도",
    gu_si: "수원",
    dong: "매산",
    theme: "무채색",
    name: "스톤",
    address: "매산로1가 114-9",
    off: "x",
    parking: "x",
    link: "https://naver.me/GyyeMu8M",
    image:
      "https://ldb-phinf.pstatic.net/20221116_283/1668580034611zsjnf_JPEG/2022-11-13-23-04-46-094.jpg",
  },
  {
    area: "인천",
    gu_si: "연수",
    dong: "송도",
    theme: "외국",
    name: "힐먼트",
    address: "송도동 169",
    off: "Wen",
    parking: "o",
    link: "https://naver.me/GPF4PgVE",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjEyMjNfMTYz%2FMDAxNjcxNzc2OTU4MzE2.9MAxmBAN_bGm1bSyqUcLvSSVjR5-0S6x_HoFyHpMBNYg.HXrwLPkwGy_Z5I5ll-6-DmjRlIhavfImnMQ1AnIw2esg.JPEG.170309%2Foutput_321253510.jpg",
  },
  {
    area: "경기도",
    gu_si: "안산",
    dong: "사동",
    theme: "디저트",
    name: "휘쿠버",
    address: "사동 1563-4",
    off: "x",
    parking: "x",
    link: "https://naver.me/GBlqZhJA",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjEyMDVfMTAz%2FMDAxNjcwMjQ0NzE5MTE1.EMNaMsaipBBpATVY2WUL-BPxJsKzjqWEBDMP7LFtHRIg.67jkzzhJm-j37PYXS6sJovzZ5NtZrC9d-tSwABBF8mcg.JPEG.dahyun0120%2FIMG_4308.jpg",
  },
  {
    area: "경기도",
    gu_si: "수원",
    dong: "행궁",
    theme: "한옥",
    name: "경안당",
    address: "장안동 124",
    off: "Mon",
    parking: "x",
    link: "https://naver.me/FJH6Gftu",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjEyMjlfMjIg%2FMDAxNjcyMzIzNjI4MDc1.LYzl-yGkjS2dwALkqJ4WpAUNvGK5Z9JxEedcWClbo-wg.EjfUefJ1bxc485_w7UvERzlz3pOb5G7-MwWt9U4K9Uog.JPEG.gmlwn5315%2FIMG_7821.jpg",
  },
  {
    area: "경기도",
    gu_si: "수원",
    dong: "팔달",
    theme: "무채색",
    name: "콜링우드",
    address: "북수동 145-1 1층",
    off: "x",
    parking: "x",
    link: "https://naver.me/GvkXMAuo",
    image:
      "https://ldb-phinf.pstatic.net/20191001_100/1569912971785mml7i_JPEG/b3XEhF8Z6G8Aw8bbEP5RhjJ3.jpeg.jpg",
  },
  {
    area: "경기도",
    gu_si: "화성",
    dong: "정남",
    theme: "한옥",
    name: "혜경궁베이커리",
    address: "보통리 588",
    off: "x",
    parking: "x",
    link: "https://naver.me/FVPbUAwm",
    image:
      "https://ldb-phinf.pstatic.net/20220302_179/1646193695600GKH7l_JPEG/KakaoTalk_20220227_111143348_10.jpg",
  },
  {
    area: "경기도",
    gu_si: "수원",
    dong: "고색",
    theme: "외국",
    name: "오니리크",
    address: "고색동 42-26",
    off: "x",
    parking: "o",
    link: "https://naver.me/FBwtFExR",
    image:
      "https://ldb-phinf.pstatic.net/20210908_281/1631105972398eCpWl_JPEG/-bKgh6GO1JnPVdrm9-VV2H7U.jpeg.jpg",
  },
  {
    area: "경기도",
    gu_si: "안산",
    dong: "대부도",
    theme: "뷰맛집",
    name: "카페루헤",
    address: "대부북동 1851-7",
    off: "x",
    parking: "o",
    link: "https://naver.me/GnG4wd4t",
    image:
      "https://ldb-phinf.pstatic.net/20220408_276/1649396402971KtBqj_JPEG/KakaoTalk_20220408_143023784.jpg",
  },
  {
    area: "경기도",
    gu_si: "수원",
    dong: "수원",
    theme: "우드",
    name: "혜야",
    address: "매산로3가 94-28",
    off: "Mon",
    parking: "x",
    link: "https://naver.me/xRQ0Zub5",
    image:
      "https://ldb-phinf.pstatic.net/20210409_202/1617945104488TB48E_JPEG/sKrKThiXQFRbSb7CYeQTxOj4.jpeg.jpg",
  },
  {
    area: "인천",
    gu_si: "연수",
    dong: "송도",
    theme: "포근함",
    name: "기노스코",
    address: "송도동 83",
    off: "x",
    parking: "o",
    link: "https://naver.me/G6DyDwNm",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjA5MjhfMTMg%2FMDAxNjY0MzM3ODg5ODc0.TTzsWCtoOGcF0gJK71_2Dq79qIwVYK1jCqEUdHV2bCMg.uFZpQuGLEb6qu3b1cfq-AxB88fHxUJ2DWV_8DcUxl0Mg.JPEG.our0602%2FIMG_5983.JPG",
  },
  {
    area: "경기도",
    gu_si: "수원",
    dong: "고색",
    theme: "한옥",
    name: "삐에스몽테 제빵소",
    address: "고색동 464-5",
    off: "x",
    parking: "o",
    link: "https://naver.me/5wfHb4qU",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMTEyMjVfMTgz%2FMDAxNjQwNDQ0MzEzMTUx.luAb9UckZN_9TOT6j8Glow4ApV4yoBDe-wCrJnjSJ68g.h1FIRf_5LVP5CFhWKUtoLcXD2KFyBD-xug7jLWDQTuYg.JPEG.haha3981%2FIMG_3127.jpg",
  },
  {
    area: "경기도",
    gu_si: "안산",
    dong: "중앙",
    theme: "힙",
    name: "덴커피",
    address: "고잔동 540-11",
    off: "x",
    parking: "x",
    link: "https://naver.me/F1ISr38N",
    image:
      "https://ldb-phinf.pstatic.net/20210725_183/1627186618167omfOy_JPEG/TYBhQZoU-eiLV5Mk0H6y1sD3.jpeg.jpg",
  },
  {
    area: "경기도",
    gu_si: "수원",
    dong: "행궁",
    theme: "포근함",
    name: "코우하우스",
    address: "신풍동 151",
    off: "Tue",
    parking: "x",
    link: "https://naver.me/5zoAWzxY",
    image:
      "https://ldb-phinf.pstatic.net/20221004_299/1664874502570ij6R0_JPEG/C74D7F2C-C432-4A6B-8E37-6794391EE390.jpeg",
  },
  {
    area: "경기도",
    gu_si: "안산",
    dong: "대부도",
    theme: "뷰맛집",
    name: "빈솔트",
    address: "대부북동 1870-78",
    off: "Wen",
    parking: "o",
    link: "https://naver.me/F2v9RNpn",
    image:
      "https://ldb-phinf.pstatic.net/20211002_262/1633125094834x82W0_JPEG/AZ2L70B_8jpHtviVhZK_tdBO.jpeg.jpg",
  },
  {
    area: "인천",
    gu_si: "연수",
    dong: "송도",
    theme: "포근함",
    name: "포크",
    address: "송도동 174-1",
    off: "x",
    parking: "o",
    link: "https://naver.me/FxLXJ4TT",
    image:
      "https://ldb-phinf.pstatic.net/20220910_154/16627890270864dCcL_JPEG/3B630B17-6AFD-443C-B5E3-ACB63F7E8E8E.jpeg",
  },
  {
    area: "인천",
    gu_si: "옹진",
    dong: "선재도",
    theme: "외국",
    name: "플로레도 선재도",
    address: "선재리 636-10",
    off: "x",
    parking: "o",
    link: "https://naver.me/xqfovjcW",
    image:
      "https://ldb-phinf.pstatic.net/20220617_239/1655444847277b7BJi_JPEG/KakaoTalk_20220617_144434492_04.jpg",
  },
  {
    area: "인천",
    gu_si: "연수",
    dong: "송도",
    theme: "디저트",
    name: "컵피",
    address: "송도동 169",
    off: "x",
    parking: "o",
    link: "https://naver.me/xZDOqItY",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMTA5MjlfMjY5%2FMDAxNjMyODk3NzI2MTU4.0zqomfa6Vy9HWlNCoE94x5LlTRHtT0vS4XOPLfVYZQIg.94Uz1cVD8cqaQOW3LxY1eUF7tP1z9ZWE3BPyZmpBAnQg.JPEG.one5692%2FIMG_3021.jpg",
  },
  {
    area: "경기도",
    gu_si: "시흥",
    dong: "오이도",
    theme: "뷰맛집",
    name: "프로젝트C",
    address: "정왕동 2030-10",
    off: "x",
    parking: "x",
    link: "https://naver.me/5RctoVCi",
    image:
      "https://ldb-phinf.pstatic.net/20190402_48/1554202917726jIWJg_JPEG/Py_fe3C2gXQWVni3lX-UX8qP.jpg",
  },
  {
    area: "경기도",
    gu_si: "수원",
    dong: "행궁",
    theme: "외국",
    name: "그랜마베이글",
    address: "팔달로1가 11-10",
    off: "x",
    parking: "x",
    link: "https://naver.me/x7rhc7EP",
    image:
      "https://ldb-phinf.pstatic.net/20221030_247/1667097628930nF2AF_JPEG/481D5257-CE0C-484C-8FB5-B120DD78CD49.jpeg",
  },
  {
    area: "경기도",
    gu_si: "수원",
    dong: "행궁",
    theme: "힙",
    name: "킵댓 본점",
    address: "장안동 119-24",
    off: "x",
    parking: "x",
    link: "https://naver.me/FZJrauPB",
    image:
      "https://ldb-phinf.pstatic.net/20211104_222/1635958619881pmxOe_JPEG/xFKLoK2D94mFKPSo0cMSBI2K.jpg",
  },
  {
    area: "경기도",
    gu_si: "안산",
    dong: "중앙",
    theme: "무채색",
    name: "멜커피",
    address: "고잔동 540-3",
    off: "2nd Mon",
    parking: "x",
    link: "https://naver.me/xQNAq6PC",
    image:
      "https://ldb-phinf.pstatic.net/20221029_11/1667028802375qsASf_JPEG/KakaoTalk_20221029_162956190_04.jpg",
  },
  {
    area: "경기도",
    gu_si: "안산",
    dong: "대부도",
    theme: "외국",
    name: "발리다",
    address: "대부북동 1870-96",
    off: "x",
    parking: "o",
    link: "https://naver.me/GDc4vT2f",
    image:
      "https://ldb-phinf.pstatic.net/20211116_42/1637031786468qMLtr_JPEG/F3E68F74-FBA7-4B40-9966-20271104AA4F.jpeg",
  },
  {
    area: "경기도",
    gu_si: "수원",
    dong: "행궁",
    theme: "한옥",
    name: "온유여월",
    address: "장안동 28-10",
    off: "x",
    parking: "x",
    link: "https://naver.me/FdGhzZZx",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjEwMjRfODUg%2FMDAxNjY2NTk1OTI5NDY1.ki6HVRjZY8SzDnFE_3w69jHWXyUV_jL7lFCpKJ8OQbAg.U9tXzU4K-NqJ2oJoxiZmbfbAp1Zkj38sAXwWSSqgnIkg.JPEG.dajum0214%2F20221016%25A3%25DF165829.jpg",
  },
  {
    area: "경기도",
    gu_si: "수원",
    dong: "매산",
    theme: "외국",
    name: "일상엔베이커리",
    address: "매산로3가 128-12",
    off: "x",
    parking: "o",
    link: "https://naver.me/FFvifkwE",
    image:
      "https://ldb-phinf.pstatic.net/20221202_123/1669937629739zE1iU_JPEG/KakaoTalk_Photo_2022-08-02-08-56-29-3.jpeg",
  },
  {
    area: "경기도",
    gu_si: "안산",
    dong: "대부도",
    theme: "디저트",
    name: "리베르테",
    address: "대부북동 1836-16",
    off: "x",
    parking: "o",
    link: "https://naver.me/xNdljwSm",
    image:
      "https://ldb-phinf.pstatic.net/20221026_10/1666763244981Ykt6S_JPEG/0461E99D-B666-4AAF-A947-B291F271C5AC.jpeg",
  },
  {
    area: "경기도",
    gu_si: "수원",
    dong: "행궁",
    theme: "포근함",
    name: "킵댓 로스터리",
    address: "신풍동 132-1",
    off: "x",
    parking: "x",
    link: "https://naver.me/xNoEVv0n",
    image:
      "https://ldb-phinf.pstatic.net/20220628_88/1656405686581XxigB_JPEG/KakaoTalk_20220628_174033938_02.jpg",
  },
  {
    area: "인천",
    gu_si: "옹진",
    dong: "영흥도",
    theme: "뷰맛집",
    name: "플로레도 영흥도",
    address: "내리 213-32",
    off: "x",
    parking: "o",
    link: "https://naver.me/5Z0vSFQ5",
    image:
      "https://ldb-phinf.pstatic.net/20221127_208/1669513824824cjjHT_JPEG/KakaoTalk_20221127_104855935.jpg",
  },
  {
    area: "경기도",
    gu_si: "수원",
    dong: "팔달",
    theme: "외국",
    name: "루소홈",
    address: "북수동 39-1",
    off: "x",
    parking: "x",
    link: "https://naver.me/5pjq8Glq",
    image:
      "https://ldb-phinf.pstatic.net/20220404_155/1649070089268Oym83_JPEG/%BF%DC%BA%CE.jpg",
  },
  {
    area: "경기도",
    gu_si: "수원",
    dong: "팔달",
    theme: "디저트",
    name: "스퀘어드",
    address: "신풍동 221-25",
    off: "x",
    parking: "x",
    link: "https://naver.me/GdJ1bv6q",
    image:
      "https://ldb-phinf.pstatic.net/20201210_219/1607610212860j0N8G_JPEG/0tIPIaFeoKl-wqYTEM_NRp2I.jpg",
  },
  {
    area: "경기도",
    gu_si: "안산",
    dong: "중앙",
    theme: "힙",
    name: "하우디",
    address: "고잔동 534-3",
    off: "x",
    parking: "o",
    link: "https://naver.me/50ofsl2T",
    image:
      "https://ldb-phinf.pstatic.net/20221227_11/1672108539600VTWB5_JPEG/image.jpg",
  },
  {
    area: "경기도",
    gu_si: "수원",
    dong: "팔달",
    theme: "우드",
    name: "호작도",
    address: "북수동 64",
    off: "Tue",
    parking: "x",
    link: "https://naver.me/5DH3bsDL",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMTA4MDJfNzAg%2FMDAxNjI3OTEwNjIxNDUy.-JFbOp-7wl4P6QGUw-RiQZa3y9VpMuTGjRdWQdMvMLMg.5_L0mzabqusZ7T8p9zFtzpGbC6JTq6enSmLnE_ci1hAg.JPEG.im_yewon_v%2Foutput_3058030572.jpg",
  },
  {
    area: "경기도",
    gu_si: "안양",
    dong: "만안",
    theme: "무채색",
    name: "levelroz",
    address: "안양동 674-270",
    off: "Mon",
    parking: "x",
    link: "https://naver.me/FhyfhZdG",
    image:
      "https://ldb-phinf.pstatic.net/20230102_84/16726472380931St1K_JPEG/0CC53906-5C28-45E3-A3C5-E5620BC3CFD0.jpeg",
  },
  {
    area: "경기도",
    gu_si: "수원",
    dong: "행궁",
    theme: "우드",
    name: "리틀꼴렉터",
    address: "장안동 281-1",
    off: "Thur",
    parking: "x",
    link: "https://naver.me/xpaDfl53",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjEyMjFfMjI1%2FMDAxNjcxNTgzMjIxOTY3.d_ILWDfaordAKZOFo63tJTb-A1e_J81ousT5Uvcbl9kg.pwQo5LwDg5WkY_snXqf9fi0z1OeCeMglK1SgROq7NRog.JPEG.delay-%2FIMG_7237.jpg",
  },
  {
    area: "인천",
    gu_si: "연수",
    dong: "송도",
    theme: "무채색",
    name: "린치핀",
    address: "송도동 169",
    off: "x",
    parking: "x",
    link: "https://naver.me/FjojD06z",
    image:
      "https://ldb-phinf.pstatic.net/20220821_196/1661089432606CnaQW_JPEG/_PAC6273.jpg",
  },
  {
    area: "경기도",
    gu_si: "시흥",
    dong: "배곧",
    theme: "무채색",
    name: "캄",
    address: "배곧동 214",
    off: "x",
    parking: "o",
    link: "https://naver.me/FHuTmRxq",
    image:
      "https://ldb-phinf.pstatic.net/20221002_174/1664639968545T4f5q_JPEG/KakaoTalk_20221002_005846878_03.jpg",
  },
  {
    area: "경기도",
    gu_si: "수원",
    dong: "행궁",
    theme: "대형",
    name: "초안",
    address: "북수동 297-2",
    off: "x",
    parking: "x",
    link: "https://naver.me/57w89tPj",
    image:
      "https://ldb-phinf.pstatic.net/20220614_52/1655194640349gi3GG_JPEG/CF67786A-0781-4D16-9862-3C6150E3CD29.jpeg",
  },
  {
    area: "경기도",
    gu_si: "수원",
    dong: "팔달",
    theme: "외국",
    name: "버터북",
    address: "신풍동 116-21",
    off: "x",
    parking: "x",
    link: "https://naver.me/Fwkhdaiq",
    image:
      "https://pup-review-phinf.pstatic.net/MjAyMjExMjVfMTQz/MDAxNjY5Mzc1NzY5Njc0.R8jQguO08bzQxiFxKVfDSnsLopWluaNCOteUEXanix8g.-LLgsCLNaNBpO2UugNRiBFn9kR7yPROAo0Odn8rqEn0g.JPEG/20221125_124131.jpg",
  },
  {
    area: "경기도",
    gu_si: "수원",
    dong: "팔달",
    theme: "한옥",
    name: "헤올커피로스터즈",
    address: "북수동 8-1",
    off: "x",
    parking: "x",
    link: "https://naver.me/GiHrTGO6",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjA1MzBfMjYg%2FMDAxNjUzOTE2NzI3Nzc0.Z4vR0Lcky08dxhrXyhlt9EXxSdI0gTjIA3FaJISrCJIg.yVgL4NDM3VDiZ4v1Nq4RYDx9jl7zv5QXF4jq6Wj8eF0g.JPEG.happy_jeong5%2FIMG_4212.jpg",
  },
  {
    area: "경기도",
    gu_si: "시흥",
    dong: "배곧",
    theme: "무채색",
    name: "ONAR",
    address: "배곧동 228-2",
    off: "Mon",
    parking: "o",
    link: "https://naver.me/xvL78540",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjEyMTBfMjQ5%2FMDAxNjcwNjA1MzQ4MzIy.WUyU-s002k_8OCMc2teuZWM3UIlZv4j_bKPBKBdI58Eg.-Vl4i_68GTDL5Do1l59ZAzNWGA47Uo_gLQBwMYmfjuMg.JPEG.guwolmemory%2FIMG_5594.jpg",
  },
  {
    area: "경기도",
    gu_si: "수원",
    dong: "팔달",
    theme: "포근함",
    name: "매트그린",
    address: "장안동 132-1",
    off: "Tue",
    parking: "x",
    link: "https://naver.me/5PS2W84l",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMDA0MTlfNDUg%2FMDAxNTg3Mjg1MDA4NDYw.7vruGvoCABcfTT_gaqoDw-Lka7NllU9CX4PxAAuMkB4g.gUnwSCULuNwRIG6Z6a90zmQ4rUEHIBySEzRbG6W3jaEg.JPEG.leafplates%2F1587285008777.jpg",
  },
  {
    area: "경기도",
    gu_si: "안산",
    dong: "한대",
    theme: "무채색",
    name: "묵커피바",
    address: "사동 1567-5",
    off: "x",
    parking: "o",
    link: "https://naver.me/Fgibtxl3",
    image:
      "https://ldb-phinf.pstatic.net/20210924_115/1632494051718ygmjh_JPEG/URPlgIjSCk6AfXmbx30uLdV_.jpeg.jpg",
  },
  {
    area: "경기도",
    gu_si: "안산",
    dong: "한대",
    theme: "무채색",
    name: "직지 마운티니어링",
    address: "사동 1581-3",
    off: "Mon",
    parking: "o",
    link: "https://naver.me/GnCcvJke",
    image:
      "https://ldb-phinf.pstatic.net/20221111_136/1668100507109yIj4c_JPEG/KakaoTalk_Photo_2022-08-17-22-14-03_002.jpeg",
  },
  {
    area: "경기도",
    gu_si: "안산",
    dong: "해안로",
    theme: "뷰맛집",
    name: "이프오션",
    address: "사동 1646",
    off: "Mon",
    parking: "x",
    link: "https://naver.me/GPBH7cmM",
    image:
      "https://ldb-phinf.pstatic.net/20220507_22/1651870834024cLjhd_JPEG/IMG_7810.jpg",
  },
  {
    area: "경기도",
    gu_si: "화성",
    dong: "비봉",
    theme: "한옥",
    name: "화림원",
    address: "삼화리 1069-1",
    off: "Mon",
    parking: "o",
    link: "https://naver.me/Fnv4W0Dq",
    image:
      "https://ldb-phinf.pstatic.net/20220228_244/16460392761776xbtL_JPEG/3E48D509-1F23-40C3-BD9B-F6CD67571B84.jpeg",
  },
  {
    area: "경기도",
    gu_si: "안산",
    dong: "상록",
    theme: "대형",
    name: "모더스브레드",
    address: "팔곡일동 49-3",
    off: "x",
    parking: "o",
    link: "https://naver.me/IFjmHhC4",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjExMjZfODgg%2FMDAxNjY5NDMyNDkyNDg4.eHNzPyqB60aZNTmedU5wK0Pc57kqZJj7d0t-h5HbOR4g.6MmByrJVq4V-my3yFjGYVWsIBZ_C2RVMyGkS0NaY9YEg.JPEG.wowlovesoo%2FIMG_3116.jpg",
  },
  {
    area: "경기도",
    gu_si: "안산",
    dong: "상록",
    theme: "한옥",
    name: "소담행",
    address: "양상동 220-1",
    off: "x",
    parking: "o",
    link: "https://naver.me/GULxhbw2",
    image:
      "https://ldb-phinf.pstatic.net/20220424_113/16508008515288oouw_JPEG/1650800772334-0.jpg",
  },
  {
    area: "경기도",
    gu_si: "안산",
    dong: "상록",
    theme: "대형",
    name: "리모트플레이스",
    address: "건건동 325-1",
    off: "x",
    parking: "o",
    link: "https://naver.me/FJH7tOf4",
    image:
      "https://ldb-phinf.pstatic.net/20221126_128/1669396382501HSWd0_JPEG/DFC82EC0-8472-4F6B-80FF-A05F0873BEC5.jpeg",
  },
  {
    area: "경기도",
    gu_si: "안산",
    dong: "단원",
    theme: "한옥",
    name: "카페유일",
    address: "화정동 562",
    off: "x",
    parking: "o",
    link: "https://naver.me/xE1qv99p",
    image:
      "https://ldb-phinf.pstatic.net/20220412_249/1649729989503G1Kkm_JPEG/2.jpg",
  },
  {
    area: "경기도",
    gu_si: "안산",
    dong: "중앙",
    theme: "무채색",
    name: "웹스커피",
    address: "고잔동 726-2",
    off: "x",
    parking: "x",
    link: "https://naver.me/GrMgujiT",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjA5MDhfMTMw%2FMDAxNjYyNjQzNzMwNzcw.KFS8th1v7ahQBdUge8idTDcghXre8vNIInuayN1UULgg.19tBU1whAthPOCmKKOqbbmRlXOQ7QkC-RkegPgV0lswg.JPEG.kimdodoyeon%2FIMG_8545.jpg",
  },
  {
    area: "경기도",
    gu_si: "안산",
    dong: "단원",
    theme: "힙",
    name: "모디디",
    address: "선부동 961-1",
    off: "Thur",
    parking: "x",
    link: "https://naver.me/5zviG3lF",
    image:
      "https://ldb-phinf.pstatic.net/20220519_278/1652935463618k7APV_JPEG/FD2F2BB2-3A41-4561-B110-9B5F1BE74017.jpeg",
  },
  {
    area: "경기도",
    gu_si: "안산",
    dong: "고잔",
    theme: "힙",
    name: "팔레트",
    address: "고잔동 526-3",
    off: "Sun",
    parking: "o",
    link: "https://naver.me/FeexC77e",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjA2MTdfMjIx%2FMDAxNjU1NDU5MzExMjUz.LaRxfMNiBWMoyMGmZEInNFb_c7qi8Ckk4iVwVe0a_tog.QSbLiZT6FyvrPtCPux-GVKozzLPLJGkKtqfqdjFamWwg.JPEG.riminin41%2FIMG_8381.jpg",
  },
  {
    area: "경기도",
    gu_si: "화성",
    dong: "새솔",
    theme: "대형",
    name: "세베크",
    address: "새솔동 77-11",
    off: "x",
    parking: "o",
    link: "https://naver.me/GMqZ4Jfl",
    image:
      "https://ldb-phinf.pstatic.net/20220411_103/1649676045135s0OqJ_JPEG/IMG_20220403_170530_793.jpg",
  },
  {
    area: "경기도",
    gu_si: "안산",
    dong: "고잔",
    theme: "힙",
    name: "포터블",
    address: "고잔동 710-2",
    off: "x",
    parking: "x",
    link: "https://naver.me/FEJa6Lx5",
    image:
      "https://ldb-phinf.pstatic.net/20210729_124/1627540229323YE0XT_JPEG/sJLHYYtj7cuOURC6nfTU2f9s.jpeg.jpg",
  },
  {
    area: "경기도",
    gu_si: "군포",
    dong: "반월호수",
    theme: "무채색",
    name: "디마인커피로스터즈",
    address: "둔대동 442-4",
    off: "x",
    parking: "o",
    link: "https://naver.me/FiLOPiyo",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMTA5MDNfMjgx%2FMDAxNjMwNjc3NjgwNjU3.Bqsg0WzdiV4FBjHsTM8Q72yfvxK2U0Pp8332-82gcOwg.dapaYmT1wPcLrhqh7O6JJ_xJ_Y22OaMQULzniHzdDpAg.JPEG.healingprana%2F20210712%25A3%25DF103200.jpg",
  },
  {
    area: "경기도",
    gu_si: "안산",
    dong: "고잔",
    theme: "힙",
    name: "온뜨",
    address: "고잔동 703-2",
    off: "x",
    parking: "x",
    link: "https://naver.me/FjxUbsnr",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjA1MzBfMjI0%2FMDAxNjUzODc1MTQyNzYy.T-U7DUSRBHnB74CF2kDVFnDAhzUScRhXwi49kO62fG4g.QPRfFaa1-OxrPrirY8y8WGyJEIjnF9cBV6IkImmr83sg.JPEG.eunbee021128%2FIMG_0855.jpg",
  },
  {
    area: "경기도",
    gu_si: "안산",
    dong: "한대",
    theme: "포근함",
    name: "오토르테 본점",
    address: "사동 1572-7",
    off: "M,Tue",
    parking: "o",
    link: "https://naver.me/xUStBIsM",
    image:
      "https://ldb-phinf.pstatic.net/20210128_164/1611841527843yEaUN_JPEG/E4oLp9AVOx6komsKfpOJGsWJ.jpg",
  },
  {
    area: "경기도",
    gu_si: "안산",
    dong: "단원",
    theme: "대형",
    name: "데미안",
    address: "신길동 403-1",
    off: "x",
    parking: "o",
    link: "https://naver.me/5zJZhC1j",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjA1MTBfMjQ3%2FMDAxNjUyMTk0MjgxNjcz.bZlumWJuObZfiHNoQo5Xeaxx3JxYQcr7vCqQ9Urq9e8g.mqO5YFYUAxgbTdr-4y9_rwLrvEFVnBSf-UCIo3skD6Yg.JPEG.sybj0610%2FIMG_0179.jpg",
  },
  {
    area: "경기도",
    gu_si: "안산",
    dong: "한대",
    theme: "힙",
    name: "AP coffee",
    address: "사동 1569-4",
    off: "x",
    parking: "x",
    link: "https://naver.me/5nPVov32",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMzAxMDNfMjQy%2FMDAxNjcyNzMxMzYzNTA3.Cb2sj-5vxxYb8vBF_DRCrBeMTsXH4EzKTUWw5813rYUg.oZADA0tTuLMiZ2HVgUGmxULCOqdjlPNRQ5mLSnz3jWgg.JPEG.westwise_%2Foutput_4118552920.jpg",
  },
  {
    area: "경기도",
    gu_si: "안산",
    dong: "중앙",
    theme: "포근함",
    name: "아어",
    address: "고잔동 740-2",
    off: "x",
    parking: "x",
    link: "https://naver.me/Ft8lGW1e",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjExMDdfMjY4%2FMDAxNjY3ODI2MjQyOTM5.nobptTl89enEvy9zsC5pPfK0oelk_IyuVjTDDaNUp84g.RbuwrK8Xh1OEHuu7uEgyyANDHGN7H3ayD3HQohRqzfMg.JPEG.moa_moa_%2FIMG_1624.jpg",
  },
  {
    area: "경기도",
    gu_si: "안산",
    dong: "고잔",
    theme: "포근함",
    name: "뉴탭",
    address: "고잔동 705-10",
    off: "x",
    parking: "o",
    link: "https://naver.me/5FeQC87x",
    image:
      "https://ldb-phinf.pstatic.net/20211112_36/1636695274378BcHxq_JPEG/KakaoTalk_20211112_142907214_01.jpg",
  },
  {
    area: "경기도",
    gu_si: "시흥",
    dong: "배곧",
    theme: "갤러리",
    name: "테일러버튼",
    address: "배곧동 294-3",
    off: "x",
    parking: "o",
    link: "https://naver.me/Gfa8YkRj",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjA3MDVfMTIw%2FMDAxNjU2OTg0NTQ5MTc5.QG2fqgftiIden-yXAkUJC8SPMfvzSd19oDicH4mDDQEg.myJ7Jf5JoGmJOHJphcWhV_YamP8GTtpx1w_ol4dKQUog.JPEG.yjyoung1109%2FIMG_3367.jpg",
  },
  {
    area: "인천",
    gu_si: "연수",
    dong: "송도",
    theme: "힙",
    name: "오션97",
    address: "송도동 84-2",
    off: "x",
    parking: "o",
    link: "https://naver.me/5CzpexxU",
    image:
      "https://ldb-phinf.pstatic.net/20200629_165/1593421680955sTjBT_JPEG/Hus-fIBGMZoI49A0r1_06qQj.jpg",
  },
  {
    area: "인천",
    gu_si: "연수",
    dong: "연수",
    theme: "포근함",
    name: "온음커피",
    address: "동춘동 1116-9",
    off: "Mon",
    parking: "o",
    link: "https://naver.me/GlVU467Y",
    image:
      "https://ldb-phinf.pstatic.net/20220223_200/1645607650266GaAEq_JPEG/KakaoTalk_20220215_173228399_23.jpg",
  },
  {
    area: "경기도",
    gu_si: "시흥",
    dong: "정왕",
    theme: "뷰맛집",
    name: "블루웨이브커피",
    address: "정왕동 2720-3",
    off: "x",
    parking: "o",
    link: "https://naver.me/x9JSf3UR",
    image:
      "https://ldb-phinf.pstatic.net/20210722_169/1626932569430x2Jkh_JPEG/gM1TSv_0kg-PUMcU8Y9AC7aB.jpg",
  },
  {
    area: "경기도",
    gu_si: "시흥",
    dong: "배곧",
    theme: "뷰맛집",
    name: "또잇카페",
    address: "배곧동 291-1",
    off: "x",
    parking: "o",
    link: "https://naver.me/xxx2i1fc",
    image:
      "https://ldb-phinf.pstatic.net/20210716_155/1626422165613cCWY7_JPEG/WT5e-sbT0DErWm30sdV3t9np.jpg",
  },
  {
    area: "경기도",
    gu_si: "시흥",
    dong: "배곧",
    theme: "포근함",
    name: "해월커피",
    address: "배곧동 219",
    off: "x",
    parking: "o",
    link: "https://naver.me/xaCm8btZ",
    image:
      "https://ldb-phinf.pstatic.net/20220213_273/1644681831257GOi0b_JPEG/1644496709234-5.jpg",
  },
  {
    area: "인천",
    gu_si: "연수",
    dong: "송도",
    theme: "힙",
    name: "어글리무드",
    address: "송도동 22-21",
    off: "Mon",
    parking: "o",
    link: "https://naver.me/xpYK2BYi",
    image:
      "https://ldb-phinf.pstatic.net/20220831_33/1661931701015NT0Eu_JPEG/10D37237-3D16-45B6-81D3-2D30973A5233.jpeg",
  },
  {
    area: "경기도",
    gu_si: "시흥",
    dong: "오이도",
    theme: "뷰맛집",
    name: "강남할배제빵소",
    address: "정왕동 1973-17",
    off: "x",
    parking: "o",
    link: "https://naver.me/5WcuVt8f",
    image:
      "https://ldb-phinf.pstatic.net/20221025_220/1666690412928h0bz3_JPEG/KakaoTalk_20221017_181933674_02.jpg",
  },
  {
    area: "경기도",
    gu_si: "시흥",
    dong: "오이도",
    theme: "뷰맛집",
    name: "웨이브",
    address: "정왕동 2718-5",
    off: "Mon",
    parking: "o",
    link: "https://naver.me/GkKhENGG",
    image:
      "https://ldb-phinf.pstatic.net/20221124_31/1669274287929o7JGs_JPEG/1669209779157-01.jpeg",
  },
  {
    area: "충청도",
    gu_si: "당진",
    dong: "신평",
    theme: "대형",
    name: "로드1950",
    address: "매산리 1-25",
    off: "x",
    parking: "o",
    link: "https://naver.me/Gtt9jvjw",
    image:
      "https://ldb-phinf.pstatic.net/20210225_223/1614182831967rWeaT_JPEG/l0ssJn2O8wYHaYW6HYLmdEZE.jpg",
  },
  {
    area: "경기도",
    gu_si: "화성",
    dong: "동탄",
    theme: "포근함",
    name: "라크드미엘",
    address: "송동 723-1",
    off: "x",
    parking: "o",
    link: "https://naver.me/G2HLaDvB",
    image:
      "https://ldb-phinf.pstatic.net/20220308_258/1646669204771IqLL4_JPEG/220222-0236.jpg",
  },
  {
    area: "충청도",
    gu_si: "당진",
    dong: "합덕",
    theme: "뷰맛집",
    name: "피어라",
    address: "석우리 48-35",
    off: "x",
    parking: "o",
    link: "https://naver.me/GQ4YNjbK",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMDA1MDFfMjU1%2FMDAxNTg4MzEzNjk5MTY3.LpHaosHhO6DaW0Utse8R1lE6TH4u-yJM7xHgrX91t7Mg.7B1XDUgq7eSf5t17nvyRsHiZeYC_COH-MjXYh72Fg2Eg.JPEG.ij8937%2FIMG_7404.jpg",
  },
  {
    area: "충청도",
    gu_si: "공주",
    dong: "유구",
    theme: "이색",
    name: "숲너울",
    address: "문금리 2",
    off: "Mon",
    parking: "o",
    link: "https://naver.me/xOCmCohH",
    image:
      "https://ldb-phinf.pstatic.net/20220523_241/1653278214863gkl1n_JPEG/Screenshot_20220523-125548_Gallery.jpg",
  },
  {
    area: "경기도",
    gu_si: "화성",
    dong: "동탄",
    theme: "대형",
    name: "포근베이커리",
    address: "송동 716-1",
    off: "x",
    parking: "o",
    link: "https://naver.me/xScnQ2Te",
    image:
      "https://ldb-phinf.pstatic.net/20210214_245/1613309238867fHpIH_JPEG/kGrzf2z9wq8f34mKVHJtu5rI.jpeg.jpg",
  },
  {
    area: "충청도",
    gu_si: "천안",
    dong: "동남",
    theme: "이색",
    name: "기억저장소",
    address: "매당리 360-3",
    off: "Fri",
    parking: "o",
    link: "https://naver.me/xsw8qwey",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjA4MjFfMjAz%2FMDAxNjYxMDEzMzY3MDIx._mi-5aHyatZ6EO5ca41RmgHp1K37Qjid4uuPFFm6IjEg.L5_aSToX5kPKgmnfBLiITngKHRV2A-9c62v7tM-M5Ogg.JPEG.dhsdb2761%2FIMG_9492.JPG",
  },
  {
    area: "충청도",
    gu_si: "당진",
    dong: "신평",
    theme: "뷰맛집",
    name: "해어름",
    address: "매산리 29-10",
    off: "x",
    parking: "o",
    link: "https://naver.me/F9QppMJ1",
    image:
      "https://ldb-phinf.pstatic.net/20210429_231/1619676811517V81I2_JPEG/JP21hfBmgYQlzr7VzU9NqruY.jpg",
  },
  {
    area: "충청도",
    gu_si: "아산",
    dong: "영인",
    theme: "대형",
    name: "아레피",
    address: "아산리 317-10",
    off: "x",
    parking: "o",
    link: "https://naver.me/I5o4AcqG",
    image:
      "https://ldb-phinf.pstatic.net/20211224_216/164034562116451B1L_JPEG/KakaoTalk_20211224_203013402_07.jpg",
  },
  {
    area: "충청도",
    gu_si: "공주",
    dong: "쌍신",
    theme: "뷰맛집",
    name: "춘소커피",
    address: "쌍신동 162-6",
    off: "x",
    parking: "o",
    link: "https://naver.me/GC6FbH3m",
    image:
      "https://pup-review-phinf.pstatic.net/MjAyMjEyMzFfMTMx/MDAxNjcyNDkyNzYwMTEz.pA4p0h1EVYqqPqmemWDRphGfSVXJlOznujcKRo75Ceog.UDM_MxwZ2r9kRleXeM5kzu8qPr36TrBLrBJ2pp2KZTIg.JPEG/92D0E1D0-0AA6-41EE-9F57-A08B7AE2DC36.jpeg",
  },
  {
    area: "경기도",
    gu_si: "안산",
    dong: "고잔",
    theme: "포근함",
    name: "오어스커피하우스",
    address: "고잔동 681-3",
    off: "x",
    parking: "o",
    link: "https://naver.me/xNoVFuVG",
    image:
      "https://ldb-phinf.pstatic.net/20220825_69/1661423722322qb4WP_JPEG/2244829A-7603-4418-A263-5E90A3BC2823.jpeg",
  },
  {
    area: "충청도",
    gu_si: "예산",
    dong: "봉산",
    theme: "이색",
    name: "백설농부",
    address: "궁평리 102-1",
    off: "x",
    parking: "o",
    link: "https://naver.me/xTliwwDC",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjEwMDdfMjQ3%2FMDAxNjY1MTEyMzIwMTQ2.LmTP9_-uOVFg4Ko_YZyi11XHnU75GP6hhT-2BuCZXXQg._5mtczpgAm8WnRQkGk6pilQtmQAWTe7MxN42FifvAUYg.JPEG.beherit_%2FIMG_8224.jpg",
  },
  {
    area: "충청도",
    gu_si: "천안",
    dong: "동남",
    theme: "대형",
    name: "카페 루",
    address: "봉명동 131-65",
    off: "x",
    parking: "o",
    link: "https://naver.me/GZASABrS",
    image:
      "https://ldb-phinf.pstatic.net/20221013_260/1665644519556fOwV9_PNG/thejeeumchunan00084.png",
  },
  {
    area: "경기도",
    gu_si: "화성",
    dong: "제부도",
    theme: "이색",
    name: "오솔길",
    address: "제부리 26",
    off: "x",
    parking: "o",
    link: "https://naver.me/GbUaOeta",
    image:
      "https://ldb-phinf.pstatic.net/20220818_94/1660833993630omKEw_PNG/rm7wcy3ipyhhwigjxmtthvls20220730.png",
  },
  {
    area: "충청도",
    gu_si: "당진",
    dong: "신평",
    theme: "뷰맛집",
    name: "해어름베이커리",
    address: "매산리 29-27",
    off: "x",
    parking: "o",
    link: "https://naver.me/FEJ1FutS",
    image:
      "https://ldb-phinf.pstatic.net/20210612_53/1623476227912tB8LJ_JPEG/7nSy8_EHEDkNiKVIw6PpfPRz.jpg",
  },
  {
    area: "경기도",
    gu_si: "평택",
    dong: "팽성",
    theme: "외국",
    name: "텐독스",
    address: "노양리 99-1",
    off: "x",
    parking: "o",
    link: "https://naver.me/xVl3d4Fy",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjA0MThfMTMz%2FMDAxNjUwMjY3MTEwNDk2.PDohXtE_3BcT-HgwnI0GTVhDjhlbfukZ4y0yvAV013wg.UGDC2awXFWh_P63MhUp3W35ID7WLaTwbAsXjI0obpM8g.JPEG.hyeyoun0414%2FIMG_2202.jpg",
  },
  {
    area: "경기도",
    gu_si: "평택",
    dong: "삼남",
    theme: "우드",
    name: "Mollick",
    address: "도일동 886-1",
    off: "x",
    parking: "o",
    link: "https://naver.me/GgOI3ubB",
    image:
      "https://ldb-phinf.pstatic.net/20220531_14/1653994380735Jj9ac_JPEG/1EB14707-0E7D-438F-86BC-2F46779325EC.jpeg",
  },
  {
    area: "경기도",
    gu_si: "평택",
    dong: "지산",
    theme: "포근함",
    name: "프리퍼",
    address: "지산동 519-3",
    off: "x",
    parking: "o",
    link: "https://naver.me/5nbmyvHg",
    image:
      "https://ldb-phinf.pstatic.net/20221002_266/1664716235869gItvw_JPEG/Screenshot_20221002_221022_TISTORY.jpg",
  },
  {
    area: "경기도",
    gu_si: "평택",
    dong: "서탄",
    theme: "한옥",
    name: "사리당",
    address: "사리 781",
    off: "x",
    parking: "o",
    link: "https://naver.me/GiH3IlDj",
    image:
      "https://ldb-phinf.pstatic.net/20220726_114/16588434845328svCE_JPEG/5C5154BA-7652-4EB6-9F18-91C11165084D.jpeg",
  },
  {
    area: "충청도",
    gu_si: "예산",
    dong: "간양",
    theme: "한옥",
    name: "간양길",
    address: "간양리 72-2",
    off: "Mon",
    parking: "o",
    link: "https://naver.me/GPrFdsBg",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMTA5MjJfMjQ3%2FMDAxNjMyMzE3NzM1MTIy.FzUgQJMBHeEotEdkwX7oI_Crxm7gJ9WweJOj91YBcxEg.f-IqIuuquFhj80o6yg5YRySNkb7xAVm_ih46aIkyMmUg.JPEG.gmlwjd5162%2FKakaoTalk_20210922_221335254_08.jpg",
  },
  {
    area: "충청도",
    gu_si: "청양",
    dong: "운곡",
    theme: "한옥",
    name: "앵화당",
    address: "모곡리 135-1",
    off: "Mon",
    parking: "o",
    link: "https://naver.me/xoRBKoD0",
    image:
      "https://pup-review-phinf.pstatic.net/MjAyMjEyMzFfMjAy/MDAxNjcyNDc2NDUzOTE0.KKW_cPY9GlCRCNBaiHACOoqLUjGr6DKEXoqTMCQQhKsg.-djwmQBUoSz48gJ2HzT6yS749YjkmuDzb7HktSghXDEg.JPEG/20221231_125807.jpg",
  },
  {
    area: "경기도",
    gu_si: "화성",
    dong: "제부도",
    theme: "한옥",
    name: "물레",
    address: "장외리 271",
    off: "x",
    parking: "o",
    link: "https://naver.me/F36oIO9H",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMTA4MDNfMjAx%2FMDAxNjI3OTIzMzY4Nzg0.cYtAJL3-tlI1_dyLwTLZDvzCExZ33wJ86NhZGrwR8RQg.LU7UjapvUKt8VU5iBh81ErvGkUdXCoKMty1Rw5ZKBIgg.JPEG.eoo20%2F20210801%25A3%25DF153401.jpg",
  },
  {
    area: "충청도",
    gu_si: "예산",
    dong: "삽교",
    theme: "포근함",
    name: "제2막",
    address: "상하리 372-27",
    off: "x",
    parking: "o",
    link: "https://naver.me/GDc5M5yc",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjA2MjRfMTYx%2FMDAxNjU1OTk2NTg1MzQ3.VfLo_lPY2eWjYdL8ScSnxbec3FZWo_Uys9UWAppgriUg.F5q9pQlw4ER8QaZKLUiFiVTud-rxjcYM8Pk7iCoTfnQg.JPEG.miran0006%2Foutput_3218520045.jpg",
  },
  {
    area: "충청도",
    gu_si: "아산",
    dong: "둔포",
    theme: "뷰맛집",
    name: "카페든해",
    address: "둔포리 324-4",
    off: "x",
    parking: "o",
    link: "https://naver.me/GhEu4hbD",
    image:
      "https://ldb-phinf.pstatic.net/20220408_48/1649405358042wBobF_JPEG/1649396930630.jpg",
  },
  {
    area: "경기도",
    gu_si: "시흥",
    dong: "배곧",
    theme: "무채색",
    name: "윌로우우드",
    address: "배곧동 101-29",
    off: "Mon",
    parking: "o",
    link: "https://naver.me/x0ahhTtU",
    image:
      "https://ldb-phinf.pstatic.net/20201213_157/1607866470056QjuAY_JPEG/GG3FrLDZPR7P00NPVo1cBmR3.jpeg.jpg",
  },
  {
    area: "경기도",
    gu_si: "시흥",
    dong: "배곧",
    theme: "뷰맛집",
    name: "캄",
    address: "배곧동 214",
    off: "x",
    parking: "o",
    link: "https://naver.me/FHuTmRxq",
    image:
      "https://ldb-phinf.pstatic.net/20221002_191/1664640104031k6YzK_JPEG/KakaoTalk_20221002_005846878.jpg",
  },
  {
    area: "경기도",
    gu_si: "시흥",
    dong: "오이도",
    theme: "힙",
    name: "헤이오",
    address: "정왕동 2036-18",
    off: "x",
    parking: "x",
    link: "https://naver.me/GjdTShLy",
    image:
      "https://ldb-phinf.pstatic.net/20220704_183/1656931759496kvH0E_JPEG/94DA913B-BC26-427D-8199-F813B8295B00.jpeg",
  },
  {
    area: "서울",
    gu_si: "은평구",
    dong: "진관",
    theme: "한옥",
    name: "1인1상",
    address: "진관동 219",
    off: "Mon",
    parking: "o",
    link: "https://naver.me/x6PUiMb7",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjExMThfMTIg%2FMDAxNjY4NzgyNjM2OTAx.6XubdRoJSfbUs3sG_XXfXC4Tb6LB2cTSmYSMrK2395Ig.RGYiVQTDObrYxEv9QEEpAKG01ZWPjxR0w2QemLoF13sg.JPEG.etro5456%2F20221117%25A3%25DF023114.jpg",
  },
  {
    area: "서울",
    gu_si: "은평구",
    dong: "녹번",
    theme: "브런치",
    name: "37.5 녹번점",
    address: "녹번동 19-121",
    off: "x",
    parking: "o",
    link: "https://naver.me/FOvhmc9r",
    image:
      "https://ldb-phinf.pstatic.net/20200924_300/1600937184018JhROK_JPEG/tPl0-JMdIHiXh5VQ2C4u0B5A.jpg",
  },
  {
    area: "서울",
    gu_si: "은평구",
    dong: "진관",
    theme: "뷰맛집",
    name: "카페309",
    address: "진관동 309-14",
    off: "x",
    parking: "o",
    link: "https://naver.me/G3hIBmQJ",
    image:
      "https://ldb-phinf.pstatic.net/20221014_151/1665724019661Hycpw_JPEG/3.jpeg",
  },
  {
    area: "경기도",
    gu_si: "고양",
    dong: "용두",
    theme: "대형",
    name: "프레베리 서오릉",
    address: "용두동 432-64",
    off: "x",
    parking: "o",
    link: "https://naver.me/FABYQzId",
    image:
      "https://ldb-phinf.pstatic.net/20221229_215/1672282178533bVrLy_JPEG/KakaoTalk_20221229_114841850.jpg",
  },
  {
    area: "서울",
    gu_si: "종로구",
    dong: "북악산",
    theme: "디저트",
    name: "몽핀",
    address: "홍지동 133-3",
    off: "Mon",
    parking: "o",
    link: "https://naver.me/x4biREYx",
    image:
      "https://ldb-phinf.pstatic.net/20210713_226/1626173969891IPIk0_JPEG/nOaR1AddO9Z5tGIlncJQuFLX.jpg",
  },
  {
    area: "서울",
    gu_si: "은평구",
    dong: "연신내",
    theme: "우드",
    name: "823m",
    address: "갈현동 453-22",
    off: "x",
    parking: "x",
    link: "https://naver.me/xcKJo6eF",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAxOTAxMThfNjYg%2FMDAxNTQ3Nzk5NDUzMjk1.qBHmuSQyaMHOsXD2g2g6ic30wszOLDsL3f_uy2eFXAkg.Ey3eq8qmMtU_s3HGtBrbKFIkYmO7IQZieSsrqkFvgPsg.JPEG.vice1982%2FIMG_3087.JPG",
  },
  {
    area: "경기도",
    gu_si: "고양",
    dong: "화전",
    theme: "포근함",
    name: "아말룬커피",
    address: "화전동 579-3",
    off: "x",
    parking: "x",
    link: "https://naver.me/5IltUZYb",
    image:
      "https://ldb-phinf.pstatic.net/20220506_187/1651819424978zz8Sw_JPEG/KakaoTalk_20220503_164811419.jpg",
  },
  {
    area: "서울",
    gu_si: "은평구",
    dong: "연신내",
    theme: "무채색",
    name: "오버필",
    address: "갈현동 454-8",
    off: "Mon",
    parking: "x",
    link: "https://naver.me/5qgvHCNz",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjA0MTFfMTA2%2FMDAxNjQ5NjgwMjM0NTA3.L6mfK7mXh2UO4s5XoyEf7bOL6GQ2T4tRBUUQl7HLk_og.BTAm9_Czh3MgdNyONGh6FW5OcawONClq1dC9vEHlLcAg.JPEG.inmes2%2F%25BF%25AC%25BD%25C5%25B3%25BB%25BF%25AA%25B8%25C0%25C1%25FD_7.jpg",
  },
  {
    area: "서울",
    gu_si: "은평구",
    dong: "역촌",
    theme: "주택개조",
    name: "flot",
    address: "녹번동 82-41",
    off: "x",
    parking: "x",
    link: "https://naver.me/FwnANMuk",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAxODA4MjdfNDIg%2FMDAxNTM1MzMxMjg1OTQ3.N94bEWZC7E-kPg06neAYGk84KIp0eDuXguQeQxvPNHkg.A4oVZ9R6o7WaBulHaly8i5N7_wzL-suJnXkZ01dSQPMg.JPEG.bi_a%2F8F99CBCD-FA16-4DAC-96B7-7577F3B98AD5.jpg",
  },
  {
    area: "서울",
    gu_si: "은평구",
    dong: "새절",
    theme: "포근함",
    name: "필구커피",
    address: "응암동 582-18",
    off: "Tue",
    parking: "x",
    link: "https://naver.me/FArQ1q4R",
    image:
      "https://ldb-phinf.pstatic.net/20220429_59/16512050706577zpcJ_JPEG/77D74388-5C33-4BC6-8AE5-BA7E5B7C6E05.jpeg",
  },
  {
    area: "서울",
    gu_si: "은평구",
    dong: "새절",
    theme: "포근함",
    name: "근린커피",
    address: "응암동 579-33",
    off: "x",
    parking: "x",
    link: "https://naver.me/x0ahecYv",
    image:
      "https://ldb-phinf.pstatic.net/20200411_149/1586537643339asRvN_JPEG/y2ERP55joBD1pg0z2Beibh-0.jpg",
  },
  {
    area: "서울",
    gu_si: "은평구",
    dong: "역촌",
    theme: "디저트",
    name: "시수",
    address: "대조동 45-2",
    off: "x",
    parking: "x",
    link: "https://naver.me/GjG4Uf6F",
    image:
      "https://ldb-phinf.pstatic.net/20221120_76/1668942087810NKjxA_JPEG/1F9FADE6-1703-442C-90F4-015CC7D2B82E.jpeg",
  },
  {
    area: "서울",
    gu_si: "은평구",
    dong: "불광",
    theme: "포근함",
    name: "이룸커피",
    address: "불광동 542-3",
    off: "Wen",
    parking: "x",
    link: "https://naver.me/FfMeYCux",
    image:
      "https://ldb-phinf.pstatic.net/20210326_159/16167376301400EB1g_JPEG/cCo4u4sLqd2lwaSJdAqPftux.JPG.jpg",
  },
  {
    area: "서울",
    gu_si: "은평구",
    dong: "불광",
    theme: "대형",
    name: "프리롤",
    address: "불광동 285-20",
    off: "x",
    parking: "o",
    link: "https://naver.me/FPejUluU",
    image:
      "https://ldb-phinf.pstatic.net/20220918_103/1663511916311I4NON_JPEG/KakaoTalk_20220918_231906703_09.jpg",
  },
  {
    area: "서울",
    gu_si: "은평구",
    dong: "구산",
    theme: "디저트",
    name: "오 파티세리",
    address: "역촌동 7-17",
    off: "Thur",
    parking: "o",
    link: "https://naver.me/FNuZplGi",
    image:
      "https://ldb-phinf.pstatic.net/20220614_58/1655182815256FMscm_JPEG/B6341478-667E-4BBD-9101-AC00B181C708.jpeg",
  },
  {
    area: "서울",
    gu_si: "은평구",
    dong: "응암",
    theme: "우드",
    name: "이일삼점",
    address: "응암동 120-39",
    off: "Tue",
    parking: "x",
    link: "https://naver.me/xpPWcERv",
    image:
      "https://ldb-phinf.pstatic.net/20190320_158/1553050861940nxkuV_JPEG/sYcxTqMLGqbIigwcNp9w0PLZ.jpg",
  },
  {
    area: "서울",
    gu_si: "은평구",
    dong: "응암",
    theme: "포근함",
    name: "릴렉세이션포인트",
    address: "역촌동 66-57",
    off: "x",
    parking: "o",
    link: "https://naver.me/xNdzxe3s",
    image:
      "https://ldb-phinf.pstatic.net/20220108_199/1641610205036SE77d_JPEG/1633063891928.jpg",
  },
  {
    area: "서울",
    gu_si: "은평구",
    dong: "역촌",
    theme: "디저트",
    name: "볕뉘",
    address: "역촌동 14-56",
    off: "Sun,M",
    parking: "x",
    link: "https://naver.me/xxxOmzRP",
    image:
      "https://ldb-phinf.pstatic.net/20220716_71/1657956087042IULrz_JPEG/103846FC-CE79-4152-B3DB-3C5A7FFBE0D5.jpeg",
  },
  {
    area: "서울",
    gu_si: "은평구",
    dong: "불광",
    theme: "이색",
    name: "카페 쓸",
    address: "녹번동 7",
    off: "insta",
    parking: "o",
    link: "https://naver.me/506HxfCs",
    image:
      "https://ldb-phinf.pstatic.net/20220809_193/16600372760919JGXv_PNG/%C4%B8%C3%B3.PNG",
  },
  {
    area: "서울",
    gu_si: "은평구",
    dong: "새절",
    theme: "우드",
    name: "담대하게",
    address: "응암동 579-37",
    off: "W,Thur",
    parking: "x",
    link: "https://naver.me/GaMT9dau",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjAzMTRfMjkz%2FMDAxNjQ3MjM0OTkzMTM2.Dp7bfaf5V6MJFWeBZ4w5OO3guWp5zlJQOlvUP6Bk0_kg.uesEv4_MGTS9cq04S9wLdujrWaFtn71yJp3mEbX_uiAg.JPEG.dnr6578%2FDSC09546.JPG",
  },
  {
    area: "서울",
    gu_si: "은평구",
    dong: "새절",
    theme: "우드",
    name: "라이언베이커",
    address: "신사동 348-2",
    off: "x",
    parking: "x",
    link: "https://naver.me/xZ95QxMM",
    image:
      "https://ldb-phinf.pstatic.net/20220803_242/1659521206019Tbije_JPEG/%B6%F3%C0%CC%BE%F0-%BA%A3%C0%CC%C4%BF-%BF%DC%B0%FC.jpg",
  },
  {
    area: "서울",
    gu_si: "은평구",
    dong: "응암",
    theme: "이색",
    name: "선과점",
    address: "역촌동 191-2",
    off: "insta",
    parking: "x",
    link: "https://naver.me/5aVtnbmk",
    image:
      "https://ldb-phinf.pstatic.net/20191018_63/1571325719465ItyYH_JPEG/WovgWtKDvLkR6PW79O-vsyOc.jpeg.jpg",
  },
  {
    area: "서울",
    gu_si: "은평구",
    dong: "새절",
    theme: "우드",
    name: "잔원",
    address: "신사동 229-33",
    off: "insta",
    parking: "x",
    link: "https://naver.me/IgTNXZOC",
    image:
      "https://ldb-phinf.pstatic.net/20210507_243/1620370149786cqwn5_JPEG/NTOql10GANA2w1gqNKEG-Arf.jpeg.jpg",
  },
  {
    area: "서울",
    gu_si: "은평구",
    dong: "새절",
    theme: "포근함",
    name: "에르네스토",
    address: "신사동 171-4",
    off: "1,3Mon",
    parking: "x",
    link: "https://naver.me/Fa3wpQMp",
    image:
      "https://ldb-phinf.pstatic.net/20220524_202/1653384543101EJLnV_JPEG/KakaoTalk_20220524_140422415.jpg",
  },
  {
    area: "서울",
    gu_si: "은평구",
    dong: "새절",
    theme: "힙",
    name: "우프커피",
    address: "응암동 125-1",
    off: "Mon",
    parking: "x",
    link: "https://naver.me/Fk50aaoa",
    image:
      "https://ldb-phinf.pstatic.net/20210621_163/1624283089429nShXt_JPEG/2Uvi5MSc72HwpX7D9O5PzuEp.jpeg.jpg",
  },
  {
    area: "서울",
    gu_si: "은평구",
    dong: "새절",
    theme: "포근함",
    name: "포니커피",
    address: "응암동 334-2",
    off: "Wen",
    parking: "x",
    link: "https://naver.me/GttDmg3d",
    image:
      "https://ldb-phinf.pstatic.net/20211019_125/1634631306058s0hJS_JPEG/zXboMiKCUYNQDTr9sU2KuozQ.jpeg.jpg",
  },
  {
    area: "서울",
    gu_si: "은평구",
    dong: "새절",
    theme: "무채색",
    name: "월화-점",
    address: "응암동 126-5",
    off: "Tue",
    parking: "x",
    link: "https://m.place.naver.com/share?id=1021145576&tabsPath=%2Fhome&appMode=detail",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjA0MjBfMTQ5%2FMDAxNjUwNDM3NTYzNDMz.hytaQxuaxLPJsY9-0s7aKrE8NB9lY-VdItHcr7MoFEgg.3QiVSkb8UPN6Yqs_SxEpgd8bHqS6SpTu9wQ0_LFjc04g.JPEG.jiiinsol_%2FIMG_4951.JPG",
  },
  {
    area: "서울",
    gu_si: "은평구",
    dong: "연신내",
    theme: "포근함",
    name: "해례커피",
    address: "갈현동 430-1",
    off: "x",
    parking: "x",
    link: "https://naver.me/FuVEtJlo",
    image:
      "https://ldb-phinf.pstatic.net/20220719_65/1658212077492fQSVA_JPEG/29246269-4E32-4DDD-8926-496627E263C0.jpeg",
  },
  {
    area: "서울",
    gu_si: "은평구",
    dong: "새절",
    theme: "대형",
    name: "커핀그루나루",
    address: "응암동 239-15",
    off: "x",
    parking: "x",
    link: "https://naver.me/5bRtc2dS",
    image:
      "https://ldb-phinf.pstatic.net/20220425_26/1650869273218vyhx0_JPEG/resize_%B1%E8%C7%F6%C8%A3_%C4%BF%C7%C9%B1%D7%B7%E7%B3%AA%B7%E7_15.jpg",
  },
  {
    area: "서울",
    gu_si: "은평구",
    dong: "구산",
    theme: "포근함",
    name: "열린",
    address: "역촌동 2-1",
    off: "2,3Tue",
    parking: "x",
    link: "https://naver.me/GpJ5dj3g",
    image:
      "https://ldb-phinf.pstatic.net/20211111_195/1636624717158AEENH_JPEG/20211111_185544.jpg",
  },
  {
    area: "서울",
    gu_si: "은평구",
    dong: "불광",
    theme: "뷰맛집",
    name: "두들",
    address: "대조동 240",
    off: "Tue",
    parking: "x",
    link: "https://naver.me/x2PzNbxK",
    image:
      "https://ldb-phinf.pstatic.net/20210415_93/1618475202786IBsUS_JPEG/xq-j5fQVZsw7dajihhp35B-p.jpeg.jpg",
  },
  {
    area: "서울",
    gu_si: "은평구",
    dong: "구산",
    theme: "우드",
    name: "운율커피",
    address: "구산동 22-34",
    off: "Mon",
    parking: "o",
    link: "https://naver.me/GfoSXdVX",
    image:
      "https://ldb-phinf.pstatic.net/20221027_45/1666864575632mr4zu_JPEG/B38EF3F7-7FE1-4E0C-A23A-E856DE410303.jpeg",
  },
  {
    area: "서울",
    gu_si: "은평구",
    dong: "연신내",
    theme: "힙",
    name: "빛",
    address: "대조동 187-46",
    off: "x",
    parking: "x",
    link: "https://naver.me/5jYM0RCY",
    image:
      "https://ldb-phinf.pstatic.net/20220325_42/1648185983560KVGRG_JPEG/220325_01.jpg",
  },
  {
    area: "서울",
    gu_si: "은평구",
    dong: "연신내",
    theme: "우드",
    name: "YCP",
    address: "대조동 197-15",
    off: "x",
    parking: "x",
    link: "https://naver.me/GVSyQfLx",
    image:
      "https://ldb-phinf.pstatic.net/20211206_39/1638778499604itUDO_JPEG/0B266F57-7A6D-4CD6-A1F2-9B241FFCE430.jpeg",
  },
  {
    area: "서울",
    gu_si: "은평구",
    dong: "응암",
    theme: "디저트",
    name: "킨로스",
    address: "역촌동 83-62",
    off: "Mon",
    parking: "x",
    link: "https://naver.me/GQ4IgOZl",
    image:
      "https://ldb-phinf.pstatic.net/20211126_168/1637915804472Cw3Hk_JPEG/KakaoTalk_20211126_173538897.jpg",
  },
  {
    area: "서울",
    gu_si: "은평구",
    dong: "연신내",
    theme: "우드",
    name: "테테커피",
    address: "대조동 187-41",
    off: "Wen",
    parking: "x",
    link: "https://naver.me/G4weU5OR",
    image:
      "https://ldb-phinf.pstatic.net/20220811_265/1660211513778klpVM_JPEG/82FC345B-9686-4C74-BBAB-F95200E0E64D.jpeg",
  },
  {
    area: "서울",
    gu_si: "은평구",
    dong: "연신내",
    theme: "우드",
    name: "버키커피",
    address: "갈현동 430-19",
    off: "Mon",
    parking: "x",
    link: "https://naver.me/x6ZIvgti",
    image:
      "https://ldb-phinf.pstatic.net/20220317_121/1647521440090VnnM5_JPEG/75DB9FF3-3161-4B80-BD2B-B01341BCB9AB.jpeg",
  },
  {
    area: "서울",
    gu_si: "은평구",
    dong: "연신내",
    theme: "힙",
    name: "플럽커피",
    address: "갈현동 456-12",
    off: "x",
    parking: "x",
    link: "https://naver.me/501oJf4O",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjA4MTZfMjg5%2FMDAxNjYwNjU4MTE0NTcz.MCaYhP1QeHvic6m2gkKaGZYaUQHsR9dHR5rOO8nFv4Eg.IzTQUPMc4_MF2GcG4SkZnR60hXq_cI2VpGSIHd0J5egg.JPEG.kkonis%2FIMG_4711.jpg",
  },
  {
    area: "서울",
    gu_si: "은평구",
    dong: "응암",
    theme: "우드",
    name: "오티알",
    address: "신사동 27-38",
    off: "insta",
    parking: "x",
    link: "https://naver.me/GeW4prPy",
    image:
      "https://ldb-phinf.pstatic.net/20220518_243/1652853201294y9vrX_JPEG/1923B505-E08A-4699-ADFE-202E1EF0F8D5.JPG",
  },
  {
    area: "경기도",
    gu_si: "광명",
    dong: "소하",
    theme: "한옥",
    name: "소하고택",
    address: "소하동 27-1",
    off: "Sun",
    parking: "o",
    link: "https://naver.me/FGoelp8I",
    image:
      "https://ldb-phinf.pstatic.net/20190915_12/1568530964746iBEqs_PNG/ketClkbUuHmTBExIZWF2ZfsO.png",
  },
  {
    area: "경기도",
    gu_si: "안양",
    dong: "만안",
    theme: "브런치",
    name: "사이숲",
    address: "석수동 814-3",
    off: "x",
    parking: "o",
    link: "https://naver.me/GZAjM9JH",
    image:
      "https://ldb-phinf.pstatic.net/20200519_53/1589881575737yx9uG_JPEG/QKzDrq_XASutjwxDcjDELjxB.jpg",
  },
  {
    area: "서울",
    gu_si: "금천구",
    dong: "독산",
    theme: "우드",
    name: "카페독산",
    address: "독산동 1001-2",
    off: "Sun",
    parking: "x",
    link: "https://naver.me/5Am2KSbi",
    image:
      "https://pup-review-phinf.pstatic.net/MjAyMjExMDNfODEg/MDAxNjY3NDYwNTc2Nzc2.f4d76I1QvCXCya0Um93UCAjahO2N2Tvvzq3qbc-gqI0g.bEM9_9FkeVoYsIL4zzng2Z-d6tvJvB9MfN4DcLCzfNYg.JPEG/C96A5874-0AA3-490E-B67C-38C8C78E4D26.jpeg",
  },
  {
    area: "경기도",
    gu_si: "시흥",
    dong: "물왕",
    theme: "뷰맛집",
    name: "무랑가배",
    address: "물왕동 23-6",
    off: "x",
    parking: "o",
    link: "https://naver.me/GVAWdrMc",
    image:
      "https://ldb-phinf.pstatic.net/20210707_69/16255933098720MtLG_JPEG/P175GZO9b59bivMqgyI1IpWO.jpg",
  },
  {
    area: "경기도",
    gu_si: "광명",
    dong: "광명",
    theme: "이색",
    name: "써머브릭",
    address: "일직동 512-3",
    off: "Mon",
    parking: "o",
    link: "https://naver.me/GDXPamA0",
    image:
      "https://ldb-phinf.pstatic.net/20211202_87/1638376656487V44OK_JPEG/%BD%E1%B8%D3%BA%EA%B8%AF_%B3%BB%B0%FC1.jpg",
  },
  {
    area: "경기도",
    gu_si: "광명",
    dong: "광명",
    theme: "무채색",
    name: "노플랜커피",
    address: "일직동 509-2",
    off: "Mon",
    parking: "o",
    link: "https://naver.me/5h3cgDND",
    image:
      "https://ldb-phinf.pstatic.net/20210701_221/1625119395310b5frD_JPEG/OORrOWo_0DwL5tHs4DiDuqM-.jpg",
  },
  {
    area: "경기도",
    gu_si: "안양",
    dong: "안양",
    theme: "무채색",
    name: "언아이콘",
    address: "안양동 676-182",
    off: "x",
    parking: "x",
    link: "https://naver.me/5mY2DaMU",
    image:
      "https://ldb-phinf.pstatic.net/20220227_161/1645951955820VsKkO_JPEG/IMG_20211120_180110_452.jpg",
  },
  {
    area: "경기도",
    gu_si: "시흥",
    dong: "물왕",
    theme: "뷰맛집",
    name: "커피와일드",
    address: "산현동 251-2",
    off: "Mon",
    parking: "o",
    link: "https://naver.me/FiLEO4HP",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAxOTA0MDhfMjI3%2FMDAxNTU0NzAxNjgyNTg2.U-XO5MfSHxS_OGNF8jczsRjKV1QXfDJWZNg9OuKJZz4g.pP8c_AvKeZMFFNmxtLnokVOTbJ30gca3jMvRl3KhI9Yg.JPEG.kardia80%2FDSC02667.JPG",
  },
  {
    area: "경기도",
    gu_si: "안양",
    dong: "만안",
    theme: "힙",
    name: "올타커피",
    address: "박달동 85-9",
    off: "Sun",
    parking: "x",
    link: "https://naver.me/xM82b0kQ",
    image:
      "https://ldb-phinf.pstatic.net/20221115_271/1668514231296iADkM_JPEG/KakaoTalk_20221115_210757897_01.jpg",
  },
  {
    area: "경기도",
    gu_si: "광명",
    dong: "하얀",
    theme: "포근함",
    name: "마로치노",
    address: "하안동 888",
    off: "x",
    parking: "o",
    link: "https://naver.me/GTOUwmPF",
    image:
      "https://ldb-phinf.pstatic.net/20220314_153/1647231816203EoQID_JPEG/Resized_1647185688967-5.jpeg",
  },
  {
    area: "경기도",
    gu_si: "안양",
    dong: "안양",
    theme: "우드",
    name: "어버트피",
    address: "안양동 1195-118",
    off: "Wen",
    parking: "x",
    link: "https://naver.me/xFprO4ab",
    image:
      "https://ldb-phinf.pstatic.net/20210102_23/1609572149079il26E_JPEG/X2CckRmkwCLqH4I4Y7vCNJhb.jpeg.jpg",
  },
  {
    area: "경기도",
    gu_si: "광명",
    dong: "광명",
    theme: "포근함",
    name: "가유카페",
    address: "일직동 518",
    off: "x",
    parking: "o",
    link: "https://naver.me/FVPl2zWc",
    image:
      "https://ldb-phinf.pstatic.net/20210613_27/16235718553635c26Y_JPEG/UeAXjD3BdlCi12e7fwpW5rkr.jpg",
  },
  {
    area: "경기도",
    gu_si: "안양",
    dong: "안양",
    theme: "힙",
    name: "베이스먼트",
    address: "안양동 711-145",
    off: "Mon",
    parking: "o",
    link: "https://naver.me/54VkIq7y",
    image:
      "https://ldb-phinf.pstatic.net/20211126_23/1637913347036oboqC_JPEG/BC049CD0-1A11-411B-934D-0794DF3AC36B.jpeg",
  },
  {
    area: "경기도",
    gu_si: "안양",
    dong: "안양",
    theme: "우드",
    name: "마틴스피스",
    address: "안양동 674-215",
    off: "x",
    parking: "x",
    link: "https://naver.me/5AnMZIbF",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjEyMjlfMTA4%2FMDAxNjcyMjg3NTc0Mjg2.FW20bGH9LyN5jvGdAH6SNo4VDk1ultafk0rlBaR372Ag.-YhaqlsAWXooB--qHtmJCjdTSfLiHFZr8ZIlRsclclQg.JPEG.jjh901108%2F20221228%25A3%25DF163738.jpg",
  },
  {
    area: "경기도",
    gu_si: "광명",
    dong: "광명사거리",
    theme: "포근함",
    name: "열시오븐",
    address: "광명동 304-15",
    off: "Sun,M",
    parking: "o",
    link: "https://naver.me/xpP3h4XW",
    image:
      "https://ldb-phinf.pstatic.net/20210712_298/1626087942639I8TKY_JPEG/RJGqhF8QeUrumN5nDkS2Ehkq.jpeg.jpg",
  },
  {
    area: "서울",
    gu_si: "금천구",
    dong: "금천구청",
    theme: "힙",
    name: "IMP",
    address: "시흥동 887",
    off: "x",
    parking: "x",
    link: "https://naver.me/F4rzwpN2",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjA4MjJfMTAx%2FMDAxNjYxMTQ1ODIzMTI4.z7kKK-Wqxwu-ARvAqvjAuExXiio4Y1xbK2sJktArFKsg.jcVCHeTg70T3Y8dJHzp9Kq_ZpaFq6TkPEyRgUEbua2Ag.JPEG.2222yn%2FKakaoTalk_20220821_013540399.jpg",
  },
  {
    area: "경기도",
    gu_si: "광명",
    dong: "광명",
    theme: "포근함",
    name: "해디베이크",
    address: "일직동 512",
    off: "insta",
    parking: "o",
    link: "https://naver.me/5X9Dw6JP",
    image:
      "https://ldb-phinf.pstatic.net/20210127_51/1611745221057CsVUn_JPEG/zWO1FaP3X3FGZiQon3-RlRBI.jpg",
  },
  {
    area: "경기도",
    gu_si: "안양",
    dong: "만안",
    theme: "포근함",
    name: "ep cake",
    address: "박달동 45-3",
    off: "Mon",
    parking: "x",
    link: "https://naver.me/FjoCkBJe",
    image:
      "https://ldb-phinf.pstatic.net/20220623_37/1655963618199HHQks_JPEG/CE5E6BE7-F44B-4658-9C90-812045DE4378.jpeg",
  },
  {
    area: "경기도",
    gu_si: "안양",
    dong: "관악",
    theme: "힙",
    name: "에피토미",
    address: "석수동 183-7",
    off: "Wen",
    parking: "o",
    link: "https://naver.me/Gz51MM9q",
    image:
      "https://ldb-phinf.pstatic.net/20220327_280/1648347333095Cs330_JPEG/KakaoTalk_20210905_172519659_01.jpg",
  },
  {
    area: "서울",
    gu_si: "금천구",
    dong: "금천구청",
    theme: "힙",
    name: "6Pound",
    address: "독산동 1155",
    off: "Tue",
    parking: "x",
    link: "https://naver.me/FlJC12dI",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjA4MjJfMjIz%2FMDAxNjYxMTMzNTQ4ODY3.75NWLEdkJhl88jBBjlqBNK1je89s4iNIlSrMDMCxCLAg.xOR3tRm3EJeSrdb3bR0sTwXjSL1RMs7u9J3FDuNu9gEg.JPEG.alma3000%2FKakaoTalk_20220814_173940142_02.jpg",
  },
  {
    area: "경기도",
    gu_si: "의왕",
    dong: "백운호수",
    theme: "디저트",
    name: "모테이",
    address: "내손동 3-4",
    off: "x",
    parking: "o",
    link: "https://naver.me/x2Pk8RrV",
    image:
      "https://ldb-phinf.pstatic.net/20200225_1/1582638873085YjIH6_JPEG/3KirsDtYcE8sPcOhgPzAgyxM.jpeg.jpg",
  },
  {
    area: "경기도",
    gu_si: "의왕",
    dong: "백운호수",
    theme: "뷰맛집",
    name: "그린플래그",
    address: "학의동 604-2",
    off: "x",
    parking: "o",
    link: "https://naver.me/5jAjdDfH",
    image:
      "https://pup-review-phinf.pstatic.net/MjAyMjA2MDJfNTkg/MDAxNjU0MTMwMDM3Nzky.dm-n2GvmtdrU2tm3UdmV2MaU72XELsnm8Ukra9yAFiIg._LlEojtg67ZJTIA3_uJTo5VVmb00xefDX4dfiP03QvIg.JPEG/upload_424bc152ffb2eb80dcb44667e98ec795.jpg",
  },
  {
    area: "경기도",
    gu_si: "의왕",
    dong: "백운호수",
    theme: "대형",
    name: "위빌리지",
    address: "학의동 630-1",
    off: "x",
    parking: "o",
    link: "https://naver.me/5kLXLSnL",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjExMTVfMTU4%2FMDAxNjY4NDc4ODY3ODM5.jRxyg66cn6Z0i4uewX9v86opouBYFnhuu7jPKDD05A8g.jgcZKWlxL7ou_MWzZbo6kqhiYZSUSjoy7QDOjSk8TzUg.JPEG.michelle171%2FIMG_4486.jpg",
  },
  {
    area: "경기도",
    gu_si: "의왕",
    dong: "백운",
    theme: "뷰맛집",
    name: "호야스",
    address: "학의동 874-14",
    off: "Tue",
    parking: "o",
    link: "https://naver.me/5NYaNCkj",
    image:
      "https://ldb-phinf.pstatic.net/20220226_164/1645870881819k8hzV_JPEG/1645869644715-0.jpg",
  },
  {
    area: "경기도",
    gu_si: "의왕",
    dong: "백운",
    theme: "대형",
    name: "포듐커피",
    address: "학의동 1039",
    off: "x",
    parking: "o",
    link: "https://naver.me/FDW4WNrK",
    image:
      "https://ldb-phinf.pstatic.net/20220912_259/16629938655899TM6d_JPEG/20220911_121819_%281%29.jpg",
  },
  {
    area: "경기도",
    gu_si: "안양",
    dong: "인덕원",
    theme: "우드",
    name: "우디드커피",
    address: "관양동 1706-3",
    off: "x",
    parking: "o",
    link: "https://naver.me/IGm7Rss8",
    image:
      "https://ldb-phinf.pstatic.net/20220428_56/1651075093692Ft3NN_JPEG/744D1ED0-6C1F-400C-9BA1-6CD8079DE44F.jpeg",
  },
  {
    area: "경기도",
    gu_si: "안양",
    dong: "인덕원",
    theme: "우드",
    name: "레이커피바",
    address: "관양동 1492-14",
    off: "x",
    parking: "x",
    link: "https://naver.me/51Yn7L1v",
    image:
      "https://ldb-phinf.pstatic.net/20200614_43/1592061927458NxdaV_JPEG/ilOaNOowET-dGvIKXFLoj6Z_.jpeg.jpg",
  },
  {
    area: "경기도",
    gu_si: "안양",
    dong: "범계",
    theme: "무채색",
    name: "Vibra",
    address: "호계동 1045-2",
    off: "x",
    parking: "x",
    link: "https://naver.me/57w1vtc9",
    image:
      "https://ldb-phinf.pstatic.net/20220313_50/16471496001634huuI_JPEG/59F84692-DFEF-4EE3-8AFD-FB132000529D.jpeg",
  },
  {
    area: "경기도",
    gu_si: "안양",
    dong: "인덕원",
    theme: "뷰맛집",
    name: "카페토브",
    address: "관양동 1725-5",
    off: "x",
    parking: "o",
    link: "https://naver.me/5L3oTjny",
    image:
      "https://ldb-phinf.pstatic.net/20200623_163/1592874459306jVeiV_JPEG/2IcZUl16Omc_3OYwHapnwMg1.jpeg.jpg",
  },
  {
    area: "경기도",
    gu_si: "안양",
    dong: "안양",
    theme: "우드",
    name: "위치타",
    address: "안양동 711-7",
    off: "Mon",
    parking: "x",
    link: "https://naver.me/5uxcalpV",
    image:
      "https://ldb-phinf.pstatic.net/20210401_14/1617273343282bRqG7_JPEG/_7LhvV_g5-MOi4euYgVwAdJK.jpg",
  },
  {
    area: "경기도",
    gu_si: "안양",
    dong: "산본",
    theme: "포근함",
    name: "녹던",
    address: "산본동 1135-1",
    off: "x",
    parking: "x",
    link: "https://naver.me/xbw9DSf3",
    image:
      "https://ldb-phinf.pstatic.net/20220818_221/1660802472000aT1Vp_JPEG/Screenshot_20220815-004116_Gallery.jpg",
  },
  {
    area: "경기도",
    gu_si: "안양",
    dong: "인덕원",
    theme: "우드",
    name: "리띵커피",
    address: "관양동 1712-4",
    off: "x",
    parking: "x",
    link: "https://naver.me/GXERrQAm",
    image:
      "https://ldb-phinf.pstatic.net/20220123_12/16428642247024IXyQ_JPEG/KakaoTalk_20220122_235144800.jpg",
  },
  {
    area: "경기도",
    gu_si: "안양",
    dong: "범계",
    theme: "힙",
    name: "리띵커피",
    address: "비산동 1108-1",
    off: "x",
    parking: "o",
    link: "https://naver.me/5ZvEa8ak",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjExMDdfMzgg%2FMDAxNjY3Nzk3ODA5Njg1.vsujaJkowfI9Sd9yEkGpmNjPC8MHNXMHW2zLKCT9szsg.8HthPdxWQ0tIt6tunirm-AVdL3cnBaN1j1MSZLzX-xQg.JPEG.aalsrud234%2F1667796840737.jpg",
  },
  {
    area: "경기도",
    gu_si: "군포",
    dong: "반월호수",
    theme: "대형",
    name: "웰스커피",
    address: "둔대동 427-6",
    off: "Mon",
    parking: "o",
    link: "https://naver.me/FEJVIib3",
    image:
      "https://ldb-phinf.pstatic.net/20220630_136/1656581308507FR7Ho_JPEG/72CFDB50-A65B-472D-815D-D02AD154D2A4.jpeg",
  },
  {
    area: "경기도",
    gu_si: "의왕",
    dong: "왕송호수",
    theme: "뷰맛집",
    name: "카페인더뷰",
    address: "초평동 370-4",
    off: "x",
    parking: "o",
    link: "https://naver.me/xDs68QT5",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMDA0MThfMjUg%2FMDAxNTg3MTQxMDgyMzE5.W6Yv98eETCIrq81i11_uxSLBcFfjCI_gE14pApMwqesg.8jxgPnJsNJfGsK9jgbB_DQNlCtbS7EucVuTxNiwmgRMg.JPEG.jmmmmz%2FKakaoTalk_Photo_2020-04-18-00-52-09-27.jpeg",
  },
  {
    area: "경기도",
    gu_si: "의왕",
    dong: "왕송호수",
    theme: "뷰맛집",
    name: "초평가배",
    address: "초평동 376-1",
    off: "x",
    parking: "o",
    link: "https://naver.me/x9LPZk9S",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjA2MjdfNjgg%2FMDAxNjU2MzM4MzkzMjI3.98ipQFdHaTIMx_ufdRBS5nn8yjm1L1TJ9__maC-U58sg.JEzmthYHcJ8SPCu7Juq9Cw2xs5_7tABXU_3LMjjMDBgg.JPEG.lnr9242%2FKakaoTalk_Photo_2022-06-27-22-57-38_030.jpeg",
  },
  {
    area: "경기도",
    gu_si: "의왕",
    dong: "의왕",
    theme: "주택개조",
    name: "가배정원",
    address: "초평동 248-1",
    off: "x",
    parking: "o",
    link: "https://naver.me/5kqWQSqD",
    image:
      "https://ldb-phinf.pstatic.net/20220808_144/1659915400022UlVAo_JPEG/%B0%A1%B9%E8%C1%A4%BF%F8%B3%D7%C0%CC%B9%F6%BB%E7%C1%F85.jpg",
  },
  {
    area: "경기도",
    gu_si: "의왕",
    dong: "왕송호수",
    theme: "대형",
    name: "카페몽블",
    address: "초평동 520-1",
    off: "Mon",
    parking: "o",
    link: "https://naver.me/FUrpPGZ7",
    image:
      "https://ldb-phinf.pstatic.net/20211117_85/1637133525713tOiER_JPEG/1637133484820-2.jpg",
  },
  {
    area: "경기도",
    gu_si: "의왕",
    dong: "의왕",
    theme: "이색",
    name: "영화플라워카페",
    address: "삼동 471-68",
    off: "x",
    parking: "o",
    link: "https://naver.me/GWFrqxB6",
    image:
      "https://ldb-phinf.pstatic.net/20220310_265/1646898818158Ad9qO_JPEG/B04E76F6-91BC-4CCB-9C3C-E95DBB2DC722.jpeg",
  },
  {
    area: "전라도",
    gu_si: "담양",
    dong: "전남",
    theme: "대형",
    name: "라운디드",
    address: "삼만리 443",
    off: "x",
    parking: "o",
    link: "https://naver.me/5cADnwwq",
    image:
      "https://ldb-phinf.pstatic.net/20221222_209/1671683260411omOv1_JPEG/90641A4A-A979-4EA2-AF7E-66CF2DBE247A.jpeg",
  },
  {
    area: "광주",
    gu_si: "동구",
    dong: "학동",
    theme: "한옥",
    name: "티에디트",
    address: "학동 873-21",
    off: "Mon",
    parking: "x",
    link: "https://naver.me/FOhhJsTs",
    image:
      "https://ldb-phinf.pstatic.net/20221201_255/1669889997401aMUao_JPEG/BTP03813.jpg",
  },
  {
    area: "광주",
    gu_si: "광산구",
    dong: "첨단",
    theme: "우드",
    name: "프랭크커핀바 첨단",
    address: "쌍암동 694-114",
    off: "x",
    parking: "o",
    link: "https://naver.me/FgvM1NlD",
    image:
      "https://ldb-phinf.pstatic.net/20221020_202/1666263703683T3jfG_JPEG/12E67018-374E-4CFA-96B5-8E9AD39724D9.jpeg",
  },
  {
    area: "광주",
    gu_si: "광산구",
    dong: "수완",
    theme: "우드",
    name: "프랭크커핀바 수완",
    address: "수완동 1660",
    off: "x",
    parking: "o",
    link: "https://naver.me/xcJbXepj",
    image:
      "https://ldb-phinf.pstatic.net/20221122_162/1669046712235Eb2K6_JPEG/6F65192F-CECE-4571-B01B-3DD713418EDE.jpeg",
  },
  {
    area: "광주",
    gu_si: "광산구",
    dong: "송정",
    theme: "대형",
    name: "하울링",
    address: "우산동 220-61",
    off: "Tue",
    parking: "o",
    link: "https://naver.me/5SaUHMr3",
    image:
      "https://ldb-phinf.pstatic.net/20221114_170/16684142489298n3PP_JPEG/KakaoTalk_20221114_170446186.jpg",
  },
  {
    area: "광주",
    gu_si: "남구",
    dong: "남광주",
    theme: "힙",
    name: "티라미뚜",
    address: "양림동 499-1",
    off: "Mon",
    parking: "o",
    link: "https://naver.me/GGhUtR8p",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMTA2MTRfMjY3%2FMDAxNjIzNjQzMjM1MDk3.NN7gbOwpw-TkGaMdfrJ4dqCVIed1HvnTC8BYyfnPBnUg.NZsLfAzf8qDYTjLKfvb8tUFSQYwpKhem1HtFv457ulwg.JPEG.ehddnjs_98%2FKakaoTalk_20210614_005035654_01.jpg",
  },
  {
    area: "전라도",
    gu_si: "담양",
    dong: "전남",
    theme: "대형",
    name: "옥담",
    address: "기곡리 264",
    off: "x",
    parking: "o",
    link: "https://naver.me/GMRvFqH5",
    image:
      "https://ldb-phinf.pstatic.net/20201110_48/16049838632503ggkf_JPEG/U9z4W2_8yJ_32dQaVkPB_IO7.jpg",
  },
  {
    area: "광주",
    gu_si: "광산구",
    dong: "첨단",
    theme: "브런치",
    name: "무두",
    address: "쌍암동 694-142",
    off: "x",
    parking: "o",
    link: "https://naver.me/5EQ3Vwjw",
    image:
      "https://ldb-phinf.pstatic.net/20191115_41/1573808718924LjE2h_JPEG/AmdtoRpr9HSv_fXC4bTt1iNb.jpeg.jpg",
  },
  {
    area: "광주",
    gu_si: "북구",
    dong: "중흥",
    theme: "무채색",
    name: "디어하우스",
    address: "중흥동 206",
    off: "insta",
    parking: "x",
    link: "https://naver.me/F2YvnvJp",
    image:
      "https://ldb-phinf.pstatic.net/20221122_269/1669101316710akXJe_JPEG/KakaoTalk_20221122_152114075_10.jpg",
  },
  {
    area: "광주",
    gu_si: "광산구",
    dong: "수완",
    theme: "우드",
    name: "커프커프하우스",
    address: "수완동 1716",
    off: "x",
    parking: "o",
    link: "https://naver.me/5Y1wr5xJ",
    image:
      "https://ldb-phinf.pstatic.net/20211209_44/16390239219921XPrx_JPEG/06CD61E4-223C-421B-B876-51CA1AAE283F.jpeg",
  },
  {
    area: "전라도",
    gu_si: "담양",
    dong: "전남",
    theme: "힙",
    name: "버트",
    address: "양각리 332-1",
    off: "Tue",
    parking: "o",
    link: "https://naver.me/ID1WXhik",
    image:
      "https://ldb-phinf.pstatic.net/20221006_205/1665060779742iHiO8_JPEG/99351EA6-BB30-450B-B011-FF1D85E8F5E3.jpeg",
  },
  {
    area: "광주",
    gu_si: "남구",
    dong: "남광주",
    theme: "힙",
    name: "리틀브릭",
    address: "양림동 356",
    off: "x",
    parking: "x",
    link: "https://naver.me/GROPmgKt",
    image:
      "https://ldb-phinf.pstatic.net/20221208_230/1670501533690wqk9H_JPEG/20221208_205157.jpg",
  },
  {
    area: "광주",
    gu_si: "광산구",
    dong: "신가",
    theme: "디저트",
    name: "슬로우무드",
    address: "신가동 1073",
    off: "x",
    parking: "o",
    link: "https://naver.me/IMQn0HZr",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMDAzMDZfMzEg%2FMDAxNTgzNTA2MTIyNTE4.x6MzTS2Xjp8vTpX5WKCKC-_9Bg6GwgXDaR9SIv1GJXYg.COgqFzIWuoKIzKfSp_RLPbC_KKzVmR6uY9PNw42Exwsg.JPEG.keswndud%2F1B599139-7F8A-4C73-A862-B79D8EB69AA9.jpeg",
  },
  {
    area: "광주",
    gu_si: "광산구",
    dong: "치평",
    theme: "브런치",
    name: "퍼니스",
    address: "치평동 881-2",
    off: "x",
    parking: "o",
    link: "https://naver.me/501otluZ",
    image:
      "https://ldb-phinf.pstatic.net/20211211_174/1639189845601l9Wuv_JPEG/KakaoTalk_20211117_155337765.jpg",
  },
  {
    area: "광주",
    gu_si: "동구",
    dong: "운림",
    theme: "힙",
    name: "Y9YA",
    address: "운림동 667-2",
    off: "Tue",
    parking: "x",
    link: "https://naver.me/5lC7w9D4",
    image:
      "https://ldb-phinf.pstatic.net/20221213_241/16709097433317M8dQ_JPEG/70C8F896-F90F-4CA0-89D4-E5C3321E40FE.jpeg",
  },
  {
    area: "광주",
    gu_si: "동구",
    dong: "동명",
    theme: "무채색",
    name: "Avvio",
    address: "동명동 64-2",
    off: "x",
    parking: "x",
    link: "https://naver.me/GUvtJnWr",
    image:
      "https://ldb-phinf.pstatic.net/20220829_259/1661759403897dKBew_JPEG/1661758669396.jpg",
  },
  {
    area: "광주",
    gu_si: "서구",
    dong: "운천",
    theme: "우드",
    name: "무난",
    address: "쌍촌동 985-9",
    off: "Mon",
    parking: "x",
    link: "https://naver.me/FwkjoKhc",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjA5MjVfMTY1%2FMDAxNjY0MTEzMDMxNzc4.gLKMLp8BI5fSq0KE_BTjCAEjjDw6HC2Gj8ql1mRMtPkg.DZ0GI8ZVTJwUMLdjg1ddO5xrBOlL5EI3fiDy6INM4KEg.JPEG.ty0987%2Foutput_4202106105.jpg",
  },
  {
    area: "전라도",
    gu_si: "담양",
    dong: "전남",
    theme: "포근함",
    name: "카페밀",
    address: "수북리 567-1",
    off: "x",
    parking: "o",
    link: "https://naver.me/xUSZaPCn",
    image:
      "https://ldb-phinf.pstatic.net/20220720_185/1658299017018TqB8b_PNG/KakaoTalk_Photo_2022-07-20-15-36-39.png",
  },
  {
    area: "광주",
    gu_si: "서구",
    dong: "운천",
    theme: "무채색",
    name: "수묵",
    address: "쌍촌동 968-4",
    off: "x",
    parking: "o",
    link: "https://naver.me/5jABl6Iu",
    image:
      "https://ldb-phinf.pstatic.net/20220208_95/1644302207721VsNSf_JPEG/KakaoTalk_20220205_115321017.jpg",
  },
  {
    area: "광주",
    gu_si: "광산구",
    dong: "월계",
    theme: "우드",
    name: "페어링",
    address: "월계동 882-1",
    off: "x",
    parking: "o",
    link: "https://naver.me/xZD0O6eq",
    image:
      "https://ldb-phinf.pstatic.net/20211118_217/1637225100375B1o6a_JPEG/SZ_00904.jpg",
  },
  {
    area: "광주",
    gu_si: "동구",
    dong: "지산",
    theme: "힙",
    name: "디셈버20",
    address: "지산동 73-1",
    off: "Mon",
    parking: "x",
    link: "https://naver.me/xagfvydS",
    image:
      "https://ldb-phinf.pstatic.net/20221221_279/1671596350451LnThC_JPEG/KakaoTalk_20221221_100913427_02.jpg",
  },
  {
    area: "광주",
    gu_si: "동구",
    dong: "동명",
    theme: "포근함",
    name: "도피 ",
    address: "동명동 80-6",
    off: "x",
    parking: "x",
    link: "https://naver.me/GLKlugtf",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjA5MTVfMTgx%2FMDAxNjYzMjI0MDIzOTUy.tr7pMYNU5Fxswk-OV0YG0bCaF2esHYB9dx8QJ_Vxw3Qg.fYG4foIRewtTtov3ABnXQswm_R9h7pP3dVsOCVrbygIg.JPEG.yanggpdnjss%2FIMG_3111.JPG",
  },
  {
    area: "전라도",
    gu_si: "담양",
    dong: "전남",
    theme: "외국",
    name: "소예르",
    address: "남산리 384",
    off: "Wen",
    parking: "o",
    link: "https://naver.me/GmFV93t0",
    image:
      "https://ldb-phinf.pstatic.net/20220715_13/1657886327743kHsls_JPEG/51704527-EFBB-4E54-A00E-2D3A7DE3F1CF.jpeg",
  },
  {
    area: "광주",
    gu_si: "동구",
    dong: "장동",
    theme: "대형",
    name: "카페플랜비",
    address: "장동 60-17",
    off: "Mon",
    parking: "x",
    link: "https://naver.me/5s3gxo8R",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjExMjdfMTMx%2FMDAxNjY5NTQyMzg4NjYz.SZH3MOVUKgA7hnXZnnx4jZ9quq-Khu4fcyZRgVCI3lUg.Fc2zOBpyE1rf4su9oaVLT0T0m8F0nMbvaf8rXGFUVBcg.JPEG.dalmuli220331%2FIMG_6121.JPG",
  },
  {
    area: "광주",
    gu_si: "동구",
    dong: "동명",
    theme: "브런치",
    name: "파트오브런던",
    address: "동명동 154-20",
    off: "Mon",
    parking: "o",
    link: "https://naver.me/5LAhwpEc",
    image:
      "https://ldb-phinf.pstatic.net/20220715_198/1657854185091qCQYv_JPEG/97380AFB-57B5-4291-803F-D0A2332F5CE2.jpeg",
  },
  {
    area: "광주",
    gu_si: "남구",
    dong: "봉선",
    theme: "브런치",
    name: "코튼스토리위드",
    address: "봉선동 989-1",
    off: "Mon",
    parking: "x",
    link: "https://naver.me/5bXdIuWK",
    image:
      "https://ldb-phinf.pstatic.net/20201102_37/1604325618276Xlbxw_JPEG/tLwhWEvvK6H1mLzez5s1k0HG.jpeg.jpg",
  },
  {
    area: "광주",
    gu_si: "남구",
    dong: "양림",
    theme: "한옥",
    name: "호양호림",
    address: "양림동 405",
    off: "Tue",
    parking: "x",
    link: "https://naver.me/FXZK454E",
    image:
      "https://ldb-phinf.pstatic.net/20220502_246/1651464326938fzihu_JPEG/FB9DAE1A-8A30-4172-B9D7-467F71D82A7F.jpeg",
  },
  {
    area: "광주",
    gu_si: "동구",
    dong: "동명",
    theme: "힙",
    name: "텍스쳐룸",
    address: "동명동 207-42",
    off: "Tue",
    parking: "x",
    link: "https://naver.me/Gu09jy7X",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjExMTdfMTk4%2FMDAxNjY4Njg1NDYzNTI1.-Sr5S1FB0p-0ABQxzMVmRhT4a2lOyATTxPg4gYjRh3wg.wOUEOPu5D_i1e7ZWyVfExN0_1zjmmacst_ML-At-cDMg.JPEG.poem_y_luv%2FIMG_2564.jpg",
  },
  {
    area: "광주",
    gu_si: "광산구",
    dong: "첨단",
    theme: "무채색",
    name: "고요커피",
    address: "월계동 876-1",
    off: "x",
    parking: "o",
    link: "https://naver.me/GjRGqcUm",
    image:
      "https://ldb-phinf.pstatic.net/20200513_190/1589298833720aOhJP_JPEG/bfqFuPLOTPDEc5i5dP27TNQL.jpg",
  },
  {
    area: "전라도",
    gu_si: "나주",
    dong: "전남",
    theme: "무채색",
    name: "인스틸",
    address: "빛가람동 190-1",
    off: "Sun",
    parking: "x",
    link: "https://naver.me/Ge5wm4vL",
    image:
      "https://ldb-phinf.pstatic.net/20221030_81/1667100207683dKfkc_JPEG/7981ECD6-77CE-45F9-A3D9-CDD6524C0316.jpeg",
  },
  {
    area: "광주",
    gu_si: "광산구",
    dong: "월산",
    theme: "포근함",
    name: "소진담",
    address: "월산동 963-14",
    off: "x",
    parking: "x",
    link: "https://naver.me/Gsa5uY5G",
    image:
      "https://ldb-phinf.pstatic.net/20221124_229/1669256587798JzMn2_JPEG/KakaoTalk_20221124_105242118_01.jpg",
  },
  {
    area: "광주",
    gu_si: "남구",
    dong: "원산",
    theme: "힙",
    name: "아르티오",
    address: "원산동 808",
    off: "Mon",
    parking: "x",
    link: "https://naver.me/F5bFIBNl",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMDA1MDVfMTEx%2FMDAxNTg4NjUyODIyMjkw.IDkcqgnEr3BsTT7aWrXjkB6thcpEP7FANT0RsD2f6HUg.MkpjN9S4Ts7vLT8YJyqjXK6vikzKcukq2wCzNIQEpiMg.JPEG.kimjw7790%2FIMG_4868.jpg",
  },
  {
    area: "전라도",
    gu_si: "담양",
    dong: "전남",
    theme: "힙",
    name: "어텐션플리즈",
    address: "대성리 1049-4",
    off: "x",
    parking: "x",
    link: "https://naver.me/5KZ73wOH",
    image:
      "https://pup-review-phinf.pstatic.net/MjAyMjEyMzFfNDYg/MDAxNjcyNDcxMjgzMDE1.57rFQcRet2Rp7Da-MqUF7O6udo9f2i_xstze42rM24Ug.8M-8CraEB8Pi3780NLnsD5IJLbKKEH8ZM2eKw_s4tRog.JPEG/20221231_161222.jpg",
  },
  {
    area: "전라도",
    gu_si: "장성",
    dong: "전남",
    theme: "디저트",
    name: "오데온",
    address: "선적리 14-1",
    off: "x",
    parking: "o",
    link: "https://naver.me/Fa3S4aW5",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjAxMDVfMTM1%2FMDAxNjQxMzczMzA5NDA1.tQdVLTIie-QPmOkJu5TESGb1m4VSvIrr_g7r3hJVf94g.FzfPFnYskHMf7pv9ZaAirrt6W-Qu1PwX9k_8dM_0bI4g.JPEG.hector5%2FC1F33BE3-E7EA-4DB9-9EC0-5F3C9CF61AA4.jpg",
  },
  {
    area: "전라도",
    gu_si: "담양",
    dong: "전남",
    theme: "포근함",
    name: "담화",
    address: "제월리 469",
    off: "x",
    parking: "o",
    link: "https://naver.me/FyexA7T8",
    image:
      "https://ldb-phinf.pstatic.net/20210223_137/1614049742969lADJw_JPEG/q6YxnUuLCkZQaRO2nCuPPMiL.jpg",
  },
  {
    area: "광주",
    gu_si: "북구",
    dong: "일곡",
    theme: "외국",
    name: "수풀림",
    address: "일곡동 852-2",
    off: "Mon",
    parking: "x",
    link: "https://naver.me/xswYe5dA",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjAzMTFfMTMx%2FMDAxNjQ2OTc5MzUwMjQ3.YLfcC67y6XsOmHRHjhx4ep8hcMB8saSGlALrqMvgAi4g.lACElkbQFPnM_WuHiLsVLcPP5gFnpyW2_0lSYR5s6_Ag.JPEG.jha573%2FIMG_5288.jpg",
  },
  {
    area: "전라도",
    gu_si: "담양",
    dong: "전남",
    theme: "주택개조",
    name: "미각",
    address: "만성리 145-15",
    off: "x",
    parking: "o",
    link: "https://naver.me/5girGJyc",
    image:
      "https://ldb-phinf.pstatic.net/20210726_155/1627282426326KcU8Q_JPEG/FuQiGU-IdjpV2rBtn-AWqvfP.jpg",
  },
  {
    area: "광주",
    gu_si: "동구",
    dong: "동명",
    theme: "무채색",
    name: "아이디얼",
    address: "동명동 154-147",
    off: "Mon",
    parking: "x",
    link: "https://naver.me/FPu917te",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjA2MDRfMTgg%2FMDAxNjU0MzQ5NzE0MzM5.Vuj_rlaiCRfvnKly9Bi5yqUVRHtN5IQy9DD4NptL3Qkg.M5jsxj8z0BT8bbC-ETCKjM56s0MwUXGYtW5pawcDDQQg.JPEG.dzdzz2020%2FIMG_2635.jpg",
  },
  {
    area: "광주",
    gu_si: "남구",
    dong: "진월",
    theme: "대형",
    name: "카페퀜쳐",
    address: "진월동 319-21",
    off: "Thur",
    parking: "x",
    link: "https://naver.me/5oQiDPmV",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAxOTExMTlfMTcx%2FMDAxNTc0MTQ0NTQ4NzM2.E025AfQYaK7jNG2qe7VLQ1CelSDhoeeEy7M5pkgmjw0g.DlbQB706Cj7JLb6X5udPa8jDUXfh2zziDW94REDZAnEg.PNG.kamameflower%2Fimage.png",
  },
  {
    area: "광주",
    gu_si: "동구",
    dong: "지산",
    theme: "힙",
    name: "으뜸브루어스",
    address: "지산동 462-18",
    off: "Sat",
    parking: "x",
    link: "https://naver.me/xdkktNp5",
    image:
      "https://ldb-phinf.pstatic.net/20221116_71/1668576028412ffJAl_JPEG/IMG_5206.jpeg",
  },
  {
    area: "광주",
    gu_si: "남구",
    dong: "봉선",
    theme: "무채색",
    name: "인니어",
    address: "봉선동 1006-11",
    off: "x",
    parking: "o",
    link: "https://naver.me/FhAdUUSt",
    image:
      "https://ldb-phinf.pstatic.net/20201224_108/1608741339815Mnu7o_JPEG/5chVQvPPJHZRAsS1Axa_mt1Z.jpg",
  },
  {
    area: "전라도",
    gu_si: "화순",
    dong: "전남",
    theme: "대형",
    name: "리고",
    address: "수만리 산182-4",
    off: "Mon",
    parking: "o",
    link: "https://naver.me/5kLkETiV",
    image:
      "https://ldb-phinf.pstatic.net/20221228_214/1672212103233vpgjV_JPEG/20221218_130136.jpg",
  },
  {
    area: "광주",
    gu_si: "동구",
    dong: "동명",
    theme: "우드",
    name: "산수커피",
    address: "산수동 363-10",
    off: "x",
    parking: "o",
    link: "https://naver.me/GqBeDE3E",
    image:
      "https://ldb-phinf.pstatic.net/20190612_193/1560331930831NxKb2_JPEG/Cz8y4dieiHgGqdQzzJVxnxsj.JPG.jpg",
  },
  {
    area: "광주",
    gu_si: "북구",
    dong: "일곡",
    theme: "힙",
    name: "모노라보르",
    address: "일곡동 398-1",
    off: "Mon",
    parking: "x",
    link: "https://naver.me/Gfab8HiI",
    image:
      "https://ldb-phinf.pstatic.net/20191202_270/1575273740505Vx0ws_JPEG/mNOloE_6AoomI98s05SGF0pT.jpeg.jpg",
  },
  {
    area: "광주",
    gu_si: "광산구",
    dong: "수완",
    theme: "무채색",
    name: "11vibe",
    address: "수완동 1602",
    off: "x",
    parking: "x",
    link: "https://naver.me/FNu7KpUZ",
    image:
      "https://ldb-phinf.pstatic.net/20211227_9/1640600604029Iy1zT_JPEG/6264B68D-87BC-445F-B777-789C9D48C0F9.jpeg",
  },
  {
    area: "인천",
    gu_si: "중구",
    dong: "영종도",
    theme: "대형",
    name: "빌리앤오티스",
    address: "중구 백운로 333",
    off: "x",
    parking: "o",
    link: "https://naver.me/xuIC3lBJ",
    image:
      "https://pup-review-phinf.pstatic.net/MjAyMzAxMDRfMjY1/MDAxNjcyODMxMDM3NTg2.1Wn4g2E44uLLSE7zuXBZjqsQ4yv7gr2MdnjBXJSr8Q8g.DI5Rsndg9clSbtv0rzQFmJN6pbTaFjSTsPgUZ7RS04Ag.JPEG/20230101_182751.jpg",
  },
  {
    area: "인천",
    gu_si: "중구",
    dong: "영종도",
    theme: "디저트",
    name: "지금이곳",
    address: "운남동 324-9",
    off: "x",
    parking: "o",
    link: "https://naver.me/Gz512Bh7",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjA1MDlfMjY5%2FMDAxNjUyMTA0ODAzMDYy.j2gHZ5cswh9wCAFT82nYimtN_DkXigTL679ZvTJGj2cg.vTU-8PerqSqSUiGdJ-Mvqzlyr0IReVQkVwJ3XGNvoucg.JPEG.sober81%2FIMG_4028.jpg",
  },
  {
    area: "인천",
    gu_si: "중구",
    dong: "영종도",
    theme: "무채색",
    name: "비다",
    address: "운북동 412",
    off: "Mon",
    parking: "o",
    link: "https://naver.me/Gz29mPjK",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjEwMTRfMTg3%2FMDAxNjY1NzQyMzg2NTQ1.fLr9j6m3rQ6dVgv_LHS6bhpCX90hAxK6aOBXirXZ2pIg.7E3aqhPA4JoTdeOYGczYPqJkCUgtjxWaRL4ej3xDIv0g.JPEG.wkdrbfl123%2FIMG_0170.jpg",
  },
  {
    area: "인천",
    gu_si: "중구",
    dong: "영종도",
    theme: "포근함",
    name: "팜파머",
    address: "운북동 376",
    off: "x",
    parking: "o",
    link: "https://naver.me/xJaIHh7L",
    image:
      "https://ldb-phinf.pstatic.net/20221020_225/1666233734294fRmuk_JPEG/KakaoTalk_20221020_114143193_01.jpg",
  },
  {
    area: "인천",
    gu_si: "중구",
    dong: "구읍뱃터",
    theme: "뷰맛집",
    name: "브레댄코",
    address: "중산동 1956-1",
    off: "x",
    parking: "o",
    link: "https://naver.me/GhE3R8Ns",
    image:
      "https://ldb-phinf.pstatic.net/20220328_138/1648427612973Wivlm_JPEG/KakaoTalk_20220328_093017187_02.jpg",
  },
  {
    area: "인천",
    gu_si: "중구",
    dong: "구읍뱃터",
    theme: "이색",
    name: "바다앞농장",
    address: "중산동 1949-1",
    off: "x",
    parking: "o",
    link: "https://naver.me/FfM6JmNj",
    image:
      "https://pup-review-phinf.pstatic.net/MjAyMjEyMjBfMjMx/MDAxNjcxNTM2OTY2OTM3.0R7ZC82TArpe6ShnTtb3f5MFYVSKmgYNBxMn4QwnklQg.kOL1ShKb9hVdOynp4_qrs2azzIWTpo8h9ezdMGIZ6iAg.JPEG/A6A6226D-54EB-428E-A377-E24C49B18319.jpeg",
  },
  {
    area: "인천",
    gu_si: "중구",
    dong: "구읍뱃터",
    theme: "뷰맛집",
    name: "바다앞테라스",
    address: "중산동 1949-1",
    off: "x",
    parking: "o",
    link: "https://naver.me/5zJoHLz7",
    image:
      "https://ldb-phinf.pstatic.net/20200924_189/1600923823431X45dy_JPEG/IyX8UgPe1SPG5rYG4a-ZCPpd.jpg",
  },
  {
    area: "인천",
    gu_si: "중구",
    dong: "구읍뱃터",
    theme: "뷰맛집",
    name: "카페뱃터",
    address: "중산동 1956-1",
    off: "x",
    parking: "o",
    link: "https://naver.me/xUScKtXo",
    image:
      "https://ldb-phinf.pstatic.net/20220407_38/1649337371402yzSxy_JPEG/IMG_20211207_202430_501.jpg",
  },
  {
    area: "인천",
    gu_si: "중구",
    dong: "구읍뱃터",
    theme: "뷰맛집",
    name: "아테리토",
    address: "중산동 1956-1",
    off: "Mon",
    parking: "o",
    link: "https://naver.me/xGOVChja",
    image:
      "https://ldb-phinf.pstatic.net/20211106_3/1636170868442WIxgR_JPEG/PDk6j8nhcZmppu-n30kSXWq0.jpg",
  },
  {
    area: "인천",
    gu_si: "중구",
    dong: "구읍뱃터",
    theme: "뷰맛집",
    name: "차덕분",
    address: "중산동 1948-1",
    off: "x",
    parking: "o",
    link: "https://naver.me/IFjFwNBR",
    image:
      "https://ldb-phinf.pstatic.net/20210108_167/1610058220906mUE1y_JPEG/WS9mNoAXP-1ouYvq5Tj-bu_r.jpeg.jpg",
  },
  {
    area: "인천",
    gu_si: "중구",
    dong: "마시안",
    theme: "외국",
    name: "카페 림",
    address: "덕교동 488-10",
    off: "M,T",
    parking: "o",
    link: "https://naver.me/xlW1Onsd",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMTAzMjBfNzgg%2FMDAxNjE2MjQ4MTE1NTMx.wumi2kcMMfrlatyWoy9V4rlALaGxARNWcr8nQPMQXzAg.yt9oCsPGoDHzfKxD-MIPuFKDasJMxd7HHmPFBvmgw0og.JPEG.sdy2579%2FIMG_8313.jpg",
  },
  {
    area: "인천",
    gu_si: "중구",
    dong: "공항",
    theme: "디저트",
    name: "엠클리프",
    address: "덕교동 128-58",
    off: "x",
    parking: "o",
    link: "https://naver.me/xJNaZ27Y",
    image:
      "https://ldb-phinf.pstatic.net/20200615_175/1592209344018DTAj2_JPEG/8izJhQIrewl54o10BJPowesd.jpg",
  },
  {
    area: "인천",
    gu_si: "강화도",
    dong: "동막",
    theme: "외국",
    name: "토크라피",
    address: "동막리 184-2",
    off: "x",
    parking: "o",
    link: "https://naver.me/G8UtfnYf",
    image:
      "https://ldb-phinf.pstatic.net/20221127_139/1669482595668aFfG9_JPEG/20220910_172243.jpg",
  },
  {
    area: "인천",
    gu_si: "강화도",
    dong: "선두리",
    theme: "이색",
    name: "그린홀리데이",
    address: "선두리 854-7",
    off: "Sun",
    parking: "o",
    link: "https://naver.me/51Ynay8a",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMTA2MjNfMjQw%2FMDAxNjI0NDI3NTg0MDM5.KoGcXnQ1016drKyelVRVQvIRS4PV7fjpyfMdNEE0vUog.nCTTXzqv7c2J0kUFNT8UWKhkEQiG1TS8VBD6mK33iZYg.JPEG.skantjd%2F20210605%25A3%25DF131617%25A3%25DFHDR.jpg",
  },
  {
    area: "인천",
    gu_si: "강화도",
    dong: "동막",
    theme: "뷰맛집",
    name: "케이131",
    address: "동막리 184-3",
    off: "x",
    parking: "o",
    link: "https://naver.me/xry5dEWT",
    image:
      "https://ldb-phinf.pstatic.net/20220530_26/1653893198673qiVnm_JPEG/2.jpeg",
  },
  {
    area: "인천",
    gu_si: "강화도",
    dong: "선두리",
    theme: "이색",
    name: "아메네카페",
    address: "선두리 1061-3",
    off: "Tue",
    parking: "o",
    link: "https://naver.me/xaPgUwxa",
    image:
      "https://ldb-phinf.pstatic.net/20211013_106/1634105619968ssrzb_JPEG/U5eEjU6J1yvYr1sim3kNrE7V.jpg",
  },
  {
    area: "인천",
    gu_si: "강화도",
    dong: "선두리",
    theme: "뷰맛집",
    name: "유리카페",
    address: "장흥리 277-29",
    off: "Tue",
    parking: "o",
    link: "https://naver.me/xNdlA4NA",
    image:
      "https://ldb-phinf.pstatic.net/20200917_243/1600320277567Jv5VJ_JPEG/8f90cU4hPSksfW-cxPNN7_K1.jpg",
  },
  {
    area: "인천",
    gu_si: "강화도",
    dong: "동막",
    theme: "우드",
    name: "멍때림",
    address: "흥왕리 895-4",
    off: "x",
    parking: "o",
    link: "https://naver.me/G4rLyxU3",
    image:
      "https://ldb-phinf.pstatic.net/20200516_225/1589601008581O5uuk_JPEG/KK2-vgnIhEEt0pCuOBo5lqzS.jpg",
  },
  {
    area: "인천",
    gu_si: "연수",
    dong: "송도",
    theme: "외국",
    name: "아키라커피",
    address: "동춘동 791",
    off: "x",
    parking: "o",
    link: "https://naver.me/GHEDMfEn",
    image:
      "https://ldb-phinf.pstatic.net/20210909_214/1631180372231QgtfU_JPEG/5WYhYlXhHPEDTT4v65kImn8X.jpg",
  },
  {
    area: "인천",
    gu_si: "남동구",
    dong: "구월",
    theme: "무채색",
    name: "댓커피",
    address: "구월동 1173-18",
    off: "x",
    parking: "o",
    link: "https://naver.me/5NdqqeKv",
    image:
      "https://ldb-phinf.pstatic.net/20220714_12/165780423548534RgY_JPEG/7.jpg",
  },
  {
    area: "인천",
    gu_si: "남동구",
    dong: "구월",
    theme: "힙",
    name: "quex",
    address: "구월동 1367-2",
    off: "x",
    parking: "o",
    link: "https://naver.me/5qgYOMiu",
    image:
      "https://ldb-phinf.pstatic.net/20220818_93/1660796804775uuQ5E_JPEG/E98FBFB6-0824-4E40-9BB4-D7030C7888B0.jpeg",
  },
  {
    area: "인천",
    gu_si: "남동구",
    dong: "구월",
    theme: "포근함",
    name: "혜리별관",
    address: "구월동 1165-12",
    off: "Wen",
    parking: "x",
    link: "https://naver.me/5WGNttRK",
    image:
      "https://ldb-phinf.pstatic.net/20220407_127/1649303309440X8UBM_JPEG/B72AB8C7-52D7-4F30-A207-0115811B836A.jpeg",
  },
  {
    area: "인천",
    gu_si: "남동구",
    dong: "구월",
    theme: "외국",
    name: "bbrick",
    address: "구월동 1363",
    off: "Mon",
    parking: "x",
    link: "https://naver.me/G5IDIz89",
    image:
      "https://ldb-phinf.pstatic.net/20221214_233/1670995366804nQxCy_JPEG/78219873-553F-48F9-A8D8-C76556848A95_2.jpg",
  },
  {
    area: "경기도",
    gu_si: "시흥",
    dong: "대야",
    theme: "포근함",
    name: "달쿠쿠",
    address: "대야동 1-110",
    off: "Sun",
    parking: "o",
    link: "https://naver.me/xTeSufgm",
    image:
      "https://ldb-phinf.pstatic.net/20200127_103/1580120205643GGjI7_JPEG/NN6dB_dJqQvlU9pYbRDWEShB.jpeg.jpg",
  },
  {
    area: "경기도",
    gu_si: "시흥",
    dong: "신천",
    theme: "대형",
    name: "베니어",
    address: "신천동 564",
    off: "x",
    parking: "o",
    link: "https://naver.me/5U1GZPo1",
    image:
      "https://ldb-phinf.pstatic.net/20190711_13/1562833318392UfF2X_JPEG/aJSXkKbqH8WDV1y_MmDtow6z.jpg",
  },
  {
    area: "경기도",
    gu_si: "부천",
    dong: "까치울",
    theme: "디저트",
    name: "핏블리 슈가쇼크",
    address: "여월동 242-2",
    off: "x",
    parking: "o",
    link: "https://naver.me/xDsFx7ya",
    image:
      "https://ldb-phinf.pstatic.net/20210427_215/1619498060635Vh2zf_JPEG/lKxI9uIgn3mlJFFW_Y0Ybntf.jpg",
  },
  {
    area: "경기도",
    gu_si: "부천",
    dong: "까치울",
    theme: "외국",
    name: "봉떼르",
    address: "작동 33-12",
    off: "x",
    parking: "o",
    link: "https://naver.me/FLBKE17U",
    image:
      "https://ldb-phinf.pstatic.net/20210423_209/1619148604494i6hQL_JPEG/H6DFhpDl_Ny7wwLtlVpf3L4v.jpeg.jpg",
  },
  {
    area: "인천",
    gu_si: "남동구",
    dong: "문학",
    theme: "대형",
    name: "티쏘커피",
    address: "수산동 221-3",
    off: "Mon",
    parking: "o",
    link: "https://naver.me/5HUa9dXI",
    image:
      "https://ldb-phinf.pstatic.net/20221110_226/1668066949059sVoOk_JPEG/KakaoTalk_20221110_165307450.jpg",
  },
  {
    area: "인천",
    gu_si: "남동구",
    dong: "장수천",
    theme: "대형",
    name: "온더그린",
    address: "수산동 471-2",
    off: "x",
    parking: "o",
    link: "https://naver.me/GLKFMZka",
    image:
      "https://pup-review-phinf.pstatic.net/MjAyMzAxMDVfMTE5/MDAxNjcyODcyNTM4MzQw.TnMwiixDlqwh2h8WQ0xP2BIcrLZybSUOk8R5sCFlA4og.mXfMCRycAE99YGR56RSHtlZL4fB_z3-HXuhKsNSLYeAg.JPEG/20221206_165517.jpg",
  },
  {
    area: "인천",
    gu_si: "미추홀구",
    dong: "주안",
    theme: "우드",
    name: "권장커피",
    address: "주안동 223-9",
    off: "x",
    parking: "o",
    link: "https://naver.me/GFpepj5K",
    image:
      "https://ldb-phinf.pstatic.net/20221115_216/1668522655003q1Nz0_JPEG/KakaoTalk_20221115_232909653_08.jpg",
  },
  {
    area: "인천",
    gu_si: "남동구",
    dong: "구월",
    theme: "힙",
    name: "오오오",
    address: "구월동 1176-10",
    off: "Tue",
    parking: "o",
    link: "https://naver.me/IDBzUiDT",
    image:
      "https://ldb-phinf.pstatic.net/20221202_127/1669977670027mvfXz_JPEG/KakaoTalk_20220622_205214124.jpg",
  },
  {
    area: "인천",
    gu_si: "연수",
    dong: "송도",
    theme: "포근함",
    name: "데이즈드",
    address: "송도동 174-3",
    off: "x",
    parking: "o",
    link: "https://naver.me/GjRGnnM7",
    image:
      "https://ldb-phinf.pstatic.net/20210208_293/1612774811519Xt4r1_JPEG/YXziWGSJhexJ1mW3njOKBBBv.jpeg.jpg",
  },
  {
    area: "부산",
    gu_si: "수영구",
    dong: "금련산",
    theme: "주택개조",
    name: "마이페이보릿쿠키",
    address: "광안동 183-4",
    off: "x",
    parking: "x",
    link: "https://naver.me/xOCmv3Qr",
    image:
      "https://ldb-phinf.pstatic.net/20210909_31/1631186981291Tkg6L_JPEG/e5HNISD05ulhud93uSHeMxF-.jpeg.jpg",
  },
  {
    area: "부산",
    gu_si: "수영구",
    dong: "광안리",
    theme: "뷰맛집",
    name: "뚜벅스",
    address: "민락동 179-1",
    off: "x",
    parking: "x",
    link: "https://naver.me/GFpeWUTj",
    image:
      "https://ldb-phinf.pstatic.net/20210601_238/1622532156038FydYS_JPEG/AiBUrIAT3-a7O5XYD3sEjhAS.jpg",
  },
  {
    area: "부산",
    gu_si: "수영구",
    dong: "광안리",
    theme: "무채색",
    name: "필더필커피바",
    address: "광안동 736-14",
    off: "insta",
    parking: "o",
    link: "https://naver.me/5vICsn9M",
    image:
      "https://ldb-phinf.pstatic.net/20211205_73/16386819588144ATVR_JPEG/KakaoTalk_20211126_014700182.jpg",
  },
  {
    area: "부산",
    gu_si: "수영구",
    dong: "광안리",
    theme: "디저트",
    name: "두넛샵",
    address: "광안동 197-20",
    off: "x",
    parking: "x",
    link: "https://naver.me/IgTcUxV6",
    image:
      "https://ldb-phinf.pstatic.net/20211015_116/1634271612654dJdLy_JPEG/jN6co8ixrA8Sanxw4Jodeyl8.jpg",
  },
  {
    area: "부산",
    gu_si: "동래구",
    dong: "안락",
    theme: "디저트",
    name: "베이크유",
    address: "안락동 631-33",
    off: "x",
    parking: "x",
    link: "https://naver.me/5IFCFGS1",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMzAxMTVfMzcg%2FMDAxNjczNzE1NjgzNzk0.NNIbcyAQpjICau8C2TSZtf5l9RbA0-ooC4ax-ZixT44g.3NIJcU_cC8Qb57URRu_gGdIJEo61az5EvMMXxBGOouAg.JPEG.worthy_so%2FIMG_0695.jpg",
  },
  {
    area: "부산",
    gu_si: "해운대구",
    dong: "중동",
    theme: "뷰맛집",
    name: "랑데자뷰 해운대",
    address: "중동 957-9",
    off: "x",
    parking: "o",
    link: "https://naver.me/GJrFlL0w",
    image:
      "https://ldb-phinf.pstatic.net/20210129_70/1611903610866PXQEw_JPEG/0tMKFFsrlNom9mmPevbzHcIF.jpg",
  },
  {
    area: "부산",
    gu_si: "수영구",
    dong: "광안리",
    theme: "뷰맛집",
    name: "카페인차저",
    address: "민락동 179-11",
    off: "x",
    parking: "x",
    link: "https://naver.me/F0KLuXSF",
    image:
      "https://ldb-phinf.pstatic.net/20210724_56/1627096600361jlbqR_JPEG/J6TIdBCw1rszdwkxad987WGr.jpeg.jpg",
  },
  {
    area: "부산",
    gu_si: "해운대구",
    dong: "재송",
    theme: "디저트",
    name: "Bagle123",
    address: "재송동 1093-42",
    off: "Mon",
    parking: "x",
    link: "https://naver.me/5jjYXfiz",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjEyMDVfMTU3%2FMDAxNjcwMjAzNDQyODY2.EBBZ4zTebr6azEFxhNJ_UXvjFIqD8rqXFyxCWtkfczwg.lw_XYTWYN5czOrFuic7zQV9Q2oH4bOAw-ZxcZSCp8iAg.JPEG.sincret%2F20221203%25A3%25DF103902.jpg",
  },
  {
    area: "부산",
    gu_si: "수영구",
    dong: "광안리",
    theme: "브런치",
    name: "어닝썬라이즈",
    address: "광안동 135-30",
    off: "Wen",
    parking: "x",
    link: "https://naver.me/xBhesuaG",
    image:
      "https://ldb-phinf.pstatic.net/20230205_171/1675568164401gBdfj_JPEG/CAB4FFC2-C3E0-481D-B120-67501DD2D113.jpeg",
  },
  {
    area: "부산",
    gu_si: "해운대구",
    dong: "달맞이",
    theme: "뷰맛집",
    name: "라이프커피앤티",
    address: "중동 1501-3",
    off: "x",
    parking: "o",
    link: "https://naver.me/5zJo37me",
    image:
      "https://ldb-phinf.pstatic.net/20210716_88/1626423680888nasdS_JPEG/aZ0c7Bb7VMRRbblft9UeQwLz.JPG.jpg",
  },
  {
    area: "부산",
    gu_si: "해운대구",
    dong: "달맞이",
    theme: "힙",
    name: "카페 인 부산",
    address: "중동 1487-3",
    off: "x",
    parking: "o",
    link: "https://naver.me/FlJxW4Nu",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMDA4MjZfMjQ2%2FMDAxNTk4NDQyMzE3NzU0.emuQerpGiC2TWzRWo0ch_l8d92SLYPDYkap5Hd4sDAYg.bgw8emOXbeWiO_JQ-qlRWsQNa6kEfeU0qtC59Agkifog.JPEG.yn____91%2F1598442316667.jpg",
  },
  {
    area: "부산",
    gu_si: "해운대구",
    dong: "해운대",
    theme: "주택개조",
    name: "카페히토",
    address: "우동 496-8",
    off: "x",
    parking: "x",
    link: "https://naver.me/x2PkNf50",
    image:
      "https://ldb-phinf.pstatic.net/20190925_220/1569406316582Y6lLV_JPEG/zX9irmPMVUXGM6c0W5mLc-be.jpeg.jpg",
  },
  {
    area: "부산",
    gu_si: "해운대구",
    dong: "청사포",
    theme: "한옥",
    name: "청사포역",
    address: "중동  637-3",
    off: "x",
    parking: "x",
    link: "https://naver.me/5kLXkXxX",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAxOTA2MTBfMzcg%2FMDAxNTYwMDkzOTMwNDMw.3OfGagWoe8_Q0rEzhIuocPNpaTznU1OnY9D829bhBzAg.bWECBK3mVKSwqmRv7hCvxUJt-IuCBHGPDc0DgUiD9NQg.JPEG.wltnrhdw%2FIMG_4906.jpg",
  },
  {
    area: "부산",
    gu_si: "해운대구",
    dong: "청사포",
    theme: "뷰맛집",
    name: "디아트커피",
    address: "중동 586",
    off: "x",
    parking: "x",
    link: "https://naver.me/xVl3KoUt",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjA1MjZfMTU1%2FMDAxNjUzNTU1Mjk5MTkz.Rdw6N4PsMfTQSdYFVDKvSdWhXGGxGWrXMbyZAqYY5xQg.C6zyXydV__sxIkrMprmAP3EEwFuRuZKK1_ytwq0CepQg.JPEG.lio_zer0%2Foutput_2887824971.jpg",
  },
  {
    area: "부산",
    gu_si: "수영구",
    dong: "금련산",
    theme: "포근함",
    name: "코피하겐",
    address: "광안동 182-29",
    off: "Mon,Tue",
    parking: "x",
    link: "https://naver.me/FXLbo5o7",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjA4MzBfMjk1%2FMDAxNjYxODQ4NDQ2NzAx.6ZCt53oTiqD3FdaitbFrcRIv3RlgUf_6PWPwCtc0nAkg.gw6JhWKFkD-iKbUGhKd2rmsJbXPIcTvjVe3w9Bbhkf4g.JPEG.govlqkr77%2FIMG_7946.jpg",
  },
  {
    area: "부산",
    gu_si: "수영구",
    dong: "망미",
    theme: "대형",
    name: "모토커피",
    address: "망미동 420-2",
    off: "x",
    parking: "o",
    link: "https://naver.me/GPrFdACY",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAxNzAzMjhfMTI3%2FMDAxNDkwNjMwMDY5MDM0.QjtAYIOQf3vji9QTAdMMemqyA7ehmLux3MqVvm82Roog.cSPdfRA75UrMxjiZYjMkXbT9_T8H0ixI7v7Gm5kRymIg.JPEG.1tjgkdpwls%2FKakaoTalk_20170323_190103548.jpg",
  },
  {
    area: "부산",
    gu_si: "수영구",
    dong: "민락",
    theme: "외국",
    name: "Etalee",
    address: "민락동 181-44",
    off: "x",
    parking: "x",
    link: "https://naver.me/xnvsNlRl",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjA5MDdfMjEy%2FMDAxNjYyNTI3ODUyNTYz.Upypfp7B6QP2u3yNqpsysVl9hVgjz4__3gS66GF1JMQg.IJo5BrpTblgfTJPXhnOr5sZxio-K2J4xVw-3yrJGWz0g.JPEG.dbwls4482%2FIMG_9097.jpg",
  },
  {
    area: "부산",
    gu_si: "수영구",
    dong: "금련산",
    theme: "뷰맛집",
    name: "시사이드파마씨",
    address: "남천동 3-18",
    off: "x",
    parking: "x",
    link: "https://naver.me/5xnNKCx4",
    image:
      "https://ldb-phinf.pstatic.net/20221107_129/1667806494402UUDbG_JPEG/1667806337948.jpg",
  },
  {
    area: "부산",
    gu_si: "해운대구",
    dong: "청사포",
    theme: "힙",
    name: "HUS",
    address: "중동 524-15",
    off: "x",
    parking: "o",
    link: "https://naver.me/5RctQZXS",
    image:
      "https://ldb-phinf.pstatic.net/20191101_76/1572582965452MnFDN_JPEG/V4-T0nQ7RjhqDRTpfPEmh4pX.jpeg.jpg",
  },
  {
    area: "부산",
    gu_si: "해운대구",
    dong: "해운대",
    theme: "주택개조",
    name: "비커피",
    address: "우동 513-8",
    off: "x",
    parking: "x",
    link: "https://naver.me/5wfHPzYo",
    image:
      "https://ldb-phinf.pstatic.net/20190207_223/1549503748678HRBgH_JPEG/mugyEFytM9TOflt4t8vBtqNH.jpg",
  },
  {
    area: "부산",
    gu_si: "남구",
    dong: "부경대",
    theme: "힙",
    name: "펠어커피",
    address: "대연동 62-17",
    off: "x",
    parking: "x",
    link: "https://naver.me/5h3XOGX5",
    image:
      "https://ldb-phinf.pstatic.net/20211014_8/1634192086854iRybp_JPEG/xZFKbSanF4hkNa4-xZTwgb2Q.jpg",
  },
  {
    area: "부산",
    gu_si: "수영구",
    dong: "망미",
    theme: "디저트",
    name: "정움",
    address: "망미동 450-28",
    off: "Sun",
    parking: "x",
    link: "https://naver.me/GultsAv6",
    image:
      "https://ldb-phinf.pstatic.net/20221129_12/16697304096997XyuL_JPEG/3DC6AF7F-C452-4C31-9007-BC8E19DADB36.jpeg",
  },
  {
    area: "부산",
    gu_si: "해운대구",
    dong: "청사포",
    theme: "디저트",
    name: "앨리스",
    address: "중동 593-2",
    off: "x",
    parking: "o",
    link: "https://naver.me/FeOdLjeP",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjA4MTRfMjEz%2FMDAxNjYwNDc0MjgyMjcw.BmdlcDz5CK0_sWLAop5F4iF-HLzVNQo9mac2MrLC5x0g.hOOc7gi-Uf9S9qlduj4j7Wt0QzHWRcR4AnuurX90kN4g.JPEG.sinhan111%2F1660474213013.jpg",
  },
  {
    area: "부산",
    gu_si: "수영구",
    dong: "광안리",
    theme: "뷰맛집",
    name: "룩앳더바리스타",
    address: "민락동 178-15",
    off: "x",
    parking: "o",
    link: "https://naver.me/FwkMptAO",
    image:
      "https://ldb-phinf.pstatic.net/20220813_198/1660388892751AzgzY_JPEG/20220720_111113.jpg",
  },
  {
    area: "부산",
    gu_si: "수영구",
    dong: "광안리",
    theme: "디저트",
    name: "카이만커피",
    address: "민락동 707-7",
    off: "x",
    parking: "x",
    link: "https://naver.me/IMpEz88G",
    image:
      "https://ldb-phinf.pstatic.net/20230103_38/1672738972319aN6sI_JPEG/FE44B7E5-3906-4E9D-BE74-F3202A395C71.jpeg",
  },
  {
    area: "부산",
    gu_si: "해운대구",
    dong: "청사포",
    theme: "뷰맛집",
    name: "오션브리즈",
    address: "중동 산34-3",
    off: "x",
    parking: "o",
    link: "https://naver.me/52MZqlm8",
    image:
      "https://ldb-phinf.pstatic.net/20220409_75/1649506910522UTTyA_JPEG/1649505877425-2.jpg",
  },
  {
    area: "부산",
    gu_si: "수영구",
    dong: "광안리",
    theme: "디저트",
    name: "하우스멜",
    address: "광안동 133-27",
    off: "Wen",
    parking: "x",
    link: "https://naver.me/xVQgQX0T",
    image:
      "https://ldb-phinf.pstatic.net/20220320_136/16477577327441uQrd_JPEG/%C7%CF%BF%EC%BD%BA%B8%E1_%BA%B8%C1%A4%BA%BB_%2837%29.jpg",
  },
  {
    area: "부산",
    gu_si: "해운대구",
    dong: "해운대",
    theme: "무채색",
    name: "더바리스트로",
    address: "우동 490",
    off: "x",
    parking: "x",
    link: "https://naver.me/5mYgDlfl",
    image:
      "https://ldb-phinf.pstatic.net/20201126_129/1606356323852Pqvbi_JPEG/cg-JP_1u81S7VlXm3-LN-FIk.jpg",
  },
  {
    area: "부산",
    gu_si: "수영구",
    dong: "남천",
    theme: "디저트",
    name: "사랑해베이글",
    address: "남천동 15-2",
    off: "Mon",
    parking: "o",
    link: "https://naver.me/xAWFeh3y",
    image:
      "https://ldb-phinf.pstatic.net/20221220_200/1671502617867r4ft0_JPEG/1000002414.jpg",
  },
  {
    area: "부산",
    gu_si: "해운대구",
    dong: "송정",
    theme: "대형",
    name: "Fruiterie",
    address: "송정동 727-1",
    off: "Mon",
    parking: "o",
    link: "https://naver.me/5dx4R2PP",
    image:
      "https://ldb-phinf.pstatic.net/20210718_241/1626597066727xCgvH_JPEG/9jLBk1mddfH0yG98QoFjXvUc.jpg",
  },
  {
    area: "부산",
    gu_si: "수영구",
    dong: "금련산",
    theme: "브런치",
    name: "리틀오스",
    address: "광안동 185-7",
    off: "Tue",
    parking: "x",
    link: "https://naver.me/GZAjAjtk",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMjA5MDFfMTcy%2FMDAxNjYyMDEwMjQwMjQ3.wm4wyjkWM-WpOsxzTVXWovT80WwfRNfkyKBHIn-vHO4g.-BFlPT0lUBcBBGkzIK7M0mQ_gFKkqBWUrbOhSVq-Ydkg.JPEG.appleos%2FIMG_9463.jpg",
  },
  {
    area: "부산",
    gu_si: "해운대구",
    dong: "동백",
    theme: "포근함",
    name: "화이트리에",
    address: "우동 1407",
    off: "x",
    parking: "x",
    link: "https://naver.me/GYTGWh2d",
    image:
      "https://ldb-phinf.pstatic.net/20221231_244/1672466012359jQYDw_JPEG/1672465560491-2.jpg",
  },
  {
    area: "부산",
    gu_si: "수영구",
    dong: "광안리",
    theme: "무채색",
    name: "너를담다",
    address: "민락동 179-11",
    off: "x",
    parking: "x",
    link: "https://naver.me/FOvaXsoo",
    image:
      "https://ldb-phinf.pstatic.net/20221025_264/1666686231096Jb7fq_JPEG/614068DC-55D8-4238-AE88-A240F674A872.jpeg",
  },
  {
    area: "부산",
    gu_si: "수영구",
    dong: "광안리",
    theme: "디저트",
    name: "블랙베어도넛",
    address: "광안동 146-4",
    off: "x",
    parking: "x",
    link: "https://naver.me/xmiKaGQT",
    image:
      "https://ldb-phinf.pstatic.net/20221021_265/1666325277664N6Ufc_JPEG/P20221014_120711341_06F9F70C-9B06-4F97-87D5-4E4B6885971B.jpg",
  },
  {
    area: "부산",
    gu_si: "해운대구",
    dong: "센텀시티",
    theme: "포근함",
    name: "커피프론트",
    address: "우동 1514",
    off: "x",
    parking: "o",
    link: "https://naver.me/GeWda7uT",
    image:
      "https://ldb-phinf.pstatic.net/20221211_151/1670761289052vPyao_JPEG/A0CCDE5F-B6DB-4741-9EFB-B30F057B7F57.jpeg",
  },
  {
    area: "부산",
    gu_si: "해운대구",
    dong: "달맞이",
    theme: "힙",
    name: "바르트",
    address: "중동 1490-7",
    off: "x",
    parking: "x",
    link: "https://naver.me/578HFOLg",
    image:
      "https://pup-review-phinf.pstatic.net/MjAyMzAyMDVfNzMg/MDAxNjc1NjAwNzk3MDc2.2mw6ykvSAmQJHhynH_uncrY-vxMjT2FPvjR-VYtXrtog.m1Iz-BTidmEBFo0d_tQwAy4AKPLX8AbRqMg3NC5axZEg.JPEG/52730976-EC86-4FFB-9F0A-B73B1F0E0F8E.jpeg",
  },
  {
    area: "부산",
    gu_si: "수영구",
    dong: "금련산",
    theme: "뷰맛집",
    name: "별침대",
    address: "광안동 196-3",
    off: "x",
    parking: "o",
    link: "https://naver.me/xyUjTWR2",
    image:
      "https://ldb-phinf.pstatic.net/20200622_225/15927875581897zxTC_JPEG/rm8hRBB4CsCG3hdCS8JCpQ4B.jpg",
  },
  {
    area: "부산",
    gu_si: "수영구",
    dong: "망미",
    theme: "외국",
    name: "난주",
    address: "망미동 421-17",
    off: "Wen",
    parking: "x",
    link: "https://naver.me/G2HcwOv1",
    image:
      "https://ldb-phinf.pstatic.net/20220801_78/1659328924158YGRXU_JPEG/KakaoTalk_20220801_134022279_02.jpg",
  },
  {
    area: "부산",
    gu_si: "해운대구",
    dong: "센텀시티",
    theme: "힙",
    name: "초정커피",
    address: "재송동 422",
    off: "Mon",
    parking: "o",
    link: "https://naver.me/FXHuO682",
    image:
      "https://ldb-phinf.pstatic.net/20220925_12/1664107364515yr3io_JPEG/%C3%CA%C1%A4%C4%BF%C7%C72.jpg",
  },
  {
    area: "부산",
    gu_si: "수영구",
    dong: "광안리",
    theme: "디저트",
    name: "코쿠이",
    address: "광안동 150-53",
    off: "x",
    parking: "x",
    link: "https://naver.me/51YFOitu",
    image:
      "https://search.pstatic.net/common/?src=http%3A%2F%2Fblogfiles.naver.net%2FMjAyMTA3MjZfMTM3%2FMDAxNjI3Mjc3MDg3MTA4.iGfcC-9Nn7Ekh8iD4eejWwbxY6GoXLv3dix37diiMlIg.rbI0YUyqBuLtlmymFo49599TL0MhzUc60uzI8D6bjssg.JPEG.yae4713%2FIMG_2426.jpg",
  },
];
export default cafeInfo;
